import { GraphQLClient } from "graphql-request"
import { RequestInit } from "graphql-request/dist/types.dom"
import {
  useQuery,
  useMutation,
  UseQueryOptions,
  UseMutationOptions,
} from "@tanstack/react-query"
export type Maybe<T> = T | null
export type InputMaybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }

function fetcher<TData, TVariables extends { [key: string]: any }>(
  client: GraphQLClient,
  query: string,
  variables?: TVariables,
  requestHeaders?: RequestInit["headers"],
) {
  return async (): Promise<TData> =>
    client.request({
      document: query,
      variables,
      requestHeaders,
    })
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
}

export type ActiveLoan = {
  __typename?: "ActiveLoan"
  amount: Scalars["Float"]["output"]
  applicants: Maybe<Array<Applicant>>
  approvedOn: Maybe<Scalars["DateTime"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  dealerFee: Scalars["Float"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  loanDocsSentAt: Maybe<Scalars["DateTime"]["output"]>
  loanProductId: Scalars["String"]["output"]
  proposalId: Scalars["String"]["output"]
  /** the different loan providers for the activeLoan */
  provider: LoanProvider | `${LoanProvider}`
  providerId: Scalars["String"]["output"]
  providerMetadata: Maybe<Scalars["JSON"]["output"]>
  providerStatusEvents: Maybe<Array<Scalars["JSON"]["output"]>>
  rate: Scalars["Float"]["output"]
  status: Maybe<ActiveLoanStatus | `${ActiveLoanStatus}`>
  termMonths: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export enum ActiveLoanStatus {
  applied = "applied",
  approved = "approved",
  approved_with_stipulations = "approved_with_stipulations",
  cancelled = "cancelled",
  denied = "denied",
  incomplete = "incomplete",
  loan_docs_sent = "loan_docs_sent",
  signed = "signed",
}

export type Adder = {
  __typename?: "Adder"
  /** The category of the adder */
  category: Maybe<Scalars["JSON"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  description: Maybe<Scalars["String"]["output"]>
  doesMountingTypeRequireInstaller: Scalars["Boolean"]["output"]
  id: Scalars["ID"]["output"]
  isBaseCost: Scalars["Boolean"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  isDesign: Scalars["Boolean"]["output"]
  isEquipment: Scalars["Boolean"]["output"]
  isGroundMount: Scalars["Boolean"]["output"]
  isInterconnect: Scalars["Boolean"]["output"]
  isInternal: Scalars["Boolean"]["output"]
  isLabor: Scalars["Boolean"]["output"]
  isMPU: Scalars["Boolean"]["output"]
  isPermit: Scalars["Boolean"]["output"]
  isRacking: Scalars["Boolean"]["output"]
  isSiteSurvey: Scalars["Boolean"]["output"]
  isTurnKey: Scalars["Boolean"]["output"]
  isVariable: Scalars["Boolean"]["output"]
  /** An array of lender categories for the adder */
  lenderCategories: Maybe<Scalars["JSON"]["output"]>
  lineType: Maybe<Scalars["Float"]["output"]>
  needsModuleCount: Scalars["Boolean"]["output"]
  onContract: Scalars["Boolean"]["output"]
  order: Maybe<Scalars["Float"]["output"]>
  powurOsCategoryId: Scalars["Float"]["output"]
  powurOsId: Scalars["Float"]["output"]
  priceList: Maybe<Scalars["JSON"]["output"]>
  proposalDisplayName: Maybe<Scalars["String"]["output"]>
  proposalType: Maybe<Scalars["Float"]["output"]>
  proposalUseTypeId: Maybe<Scalars["Float"]["output"]>
  relatedAdder: Maybe<Scalars["JSON"]["output"]>
  relatedPowurOsAdderId: Maybe<Scalars["Float"]["output"]>
  /** The title of the adder */
  title: Scalars["String"]["output"]
  /** The unit for cost calculations of the adder */
  unit: Maybe<Scalars["Float"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
  watts: Maybe<Scalars["Float"]["output"]>
}

export type AdderForPowurOs = {
  __typename?: "AdderForPowurOS"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  quantity: Scalars["Int"]["output"]
  value: Scalars["Float"]["output"]
}

export type Address = {
  __typename?: "Address"
  city: Scalars["String"]["output"]
  state: StateCode | `${StateCode}`
  street: Scalars["String"]["output"]
  street2: Maybe<Scalars["String"]["output"]>
  zip: Scalars["String"]["output"]
}

export type AddressInput = {
  city: Scalars["String"]["input"]
  state: StateCode | `${StateCode}`
  street: Scalars["String"]["input"]
  street2?: InputMaybe<Scalars["String"]["input"]>
  zip: Scalars["String"]["input"]
}

export type ApiKey = {
  __typename?: "ApiKey"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  deactivatedAt: Maybe<Scalars["DateTime"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  serviceIntegrationId: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type Applicability = {
  __typename?: "Applicability"
  /** The name of variable that this applicability applies to. Examples include systemOwnership, azimuth, and tilt. */
  applicabilityKey: Scalars["String"]["output"]
  /** For applicabilities with a fixed set of choices, the list of available choices. */
  choices: Maybe<Array<Choice>>
  /** A user-presentable description of what this applicability represents. */
  description: Scalars["String"]["output"]
  /** A user-presentable name for this applicability. */
  displayName: Scalars["String"]["output"]
  /** For numeric applicabilities, the maximum allowed value. */
  maxValue: Maybe<Scalars["String"]["output"]>
  /** For numeric applicabilities, the minimum allowed value. */
  minValue: Maybe<Scalars["String"]["output"]>
  /** For formulaic applicabilities, the relationship that must be true for this applicability relative to its quantityKey. For example, estimatedFirstYearkWh might have a quantityKey of 110percentAnnualConsumption and an operator of <. This indicates that the estimated first year production of the solar power system must be less than 110% of the customer’s annual consumption. */
  operator: Maybe<Scalars["String"]["output"]>
  /** For formulaic applicabilities, a pointer to a PropertyKey that holds the formula defining this applicability. */
  quantityKey: Maybe<PropertyKey>
  /** If there is a single value that is allowed for this applicability, it will show up here. For example, if systemOwnership requires host, it will be here. */
  requiredValue: Maybe<Scalars["String"]["output"]>
}

export type Applicant = {
  __typename?: "Applicant"
  activeLoanId: Maybe<Scalars["String"]["output"]>
  annualIncome: Scalars["Float"]["output"]
  consentToShareInfo: Maybe<Scalars["Boolean"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  email: Scalars["String"]["output"]
  employerName: Maybe<Scalars["String"]["output"]>
  employmentMonths: Maybe<Scalars["Float"]["output"]>
  employmentYears: Maybe<Scalars["Float"]["output"]>
  firstName: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  isCreditRun: Maybe<Scalars["Boolean"]["output"]>
  isPrimary: Scalars["Boolean"]["output"]
  jobTitle: Maybe<Scalars["String"]["output"]>
  lastName: Scalars["String"]["output"]
  mailingCity: Maybe<Scalars["String"]["output"]>
  mailingStateName: Maybe<Scalars["String"]["output"]>
  mailingStreet: Maybe<Scalars["String"]["output"]>
  mailingZipCode: Maybe<Scalars["String"]["output"]>
  middleName: Maybe<Scalars["String"]["output"]>
  otherPhone: Maybe<Scalars["String"]["output"]>
  phone: Scalars["String"]["output"]
  residenceCity: Maybe<Scalars["String"]["output"]>
  residenceStateName: Maybe<Scalars["String"]["output"]>
  residenceStreet: Maybe<Scalars["String"]["output"]>
  residenceZipCode: Maybe<Scalars["String"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  userId: Maybe<Scalars["String"]["output"]>
}

export type ApplicantBodyResponse = {
  __typename?: "ApplicantBodyResponse"
  annualIncome: Scalars["Float"]["output"]
  consentToShareInfo: Scalars["Boolean"]["output"]
  email: Scalars["String"]["output"]
  employerName: Scalars["String"]["output"]
  employmentMonths: Scalars["Float"]["output"]
  employmentYears: Scalars["Float"]["output"]
  firstName: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  isCreditRun: Scalars["Boolean"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  jobTitle: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
  mailingCity: Scalars["String"]["output"]
  mailingStateName: Scalars["String"]["output"]
  mailingStreet: Scalars["String"]["output"]
  mailingZipCode: Scalars["Float"]["output"]
  middleInitial: Scalars["String"]["output"]
  otherPhone: Scalars["Float"]["output"]
  phone: Scalars["Float"]["output"]
  residenceCity: Scalars["String"]["output"]
  residenceStateName: Scalars["String"]["output"]
  residenceStreet: Scalars["String"]["output"]
  residenceZipCode: Scalars["Float"]["output"]
}

export type ApplicantInput = {
  address: AddressInput
  annualIncome: CurrencyInput
  citizenshipStatus: Citizenship_Status | `${Citizenship_Status}`
  dob: Scalars["String"]["input"]
  electronicConsent: Scalars["Boolean"]["input"]
  email: Scalars["String"]["input"]
  employer?: InputMaybe<Scalars["String"]["input"]>
  employmentDuration?: InputMaybe<Scalars["Float"]["input"]>
  employmentStatus: Employment_Status | `${Employment_Status}`
  firstName: Scalars["String"]["input"]
  homeOccupancy: Home_Occupancy | `${Home_Occupancy}`
  homeOwnership: Home_Ownership | `${Home_Ownership}`
  lastName: Scalars["String"]["input"]
  occupation: Scalars["String"]["input"]
  primaryPhoneNumber: PhoneInput
  secondaryPhoneNumber?: InputMaybe<PhoneInput>
  spokenLanguage: Spoken_Language | `${Spoken_Language}`
  ssn: Scalars["String"]["input"]
}

export type ApplicantMessage = {
  __typename?: "ApplicantMessage"
  actualLoanAmount: Scalars["String"]["output"]
  borrowingLimit: Scalars["String"]["output"]
  expiration: Scalars["String"]["output"]
}

export type Attachment = {
  __typename?: "Attachment"
  extension: Scalars["String"]["output"]
  groupId: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type BaseEquipmentObject = {
  __typename?: "BaseEquipmentObject"
  inverters: Array<Scalars["Int"]["output"]>
  moduleId: Maybe<Scalars["Int"]["output"]>
}

export type BaseProposal = {
  __typename?: "BaseProposal"
  allowChangeOrderEquipment: Scalars["Boolean"]["output"]
  annualEnergyUse: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  displayAddressId: Scalars["String"]["output"]
  downPayment: Maybe<Scalars["Float"]["output"]>
  enterpriseId: Maybe<Scalars["String"]["output"]>
  genabilityDefaultContractedRate: Maybe<Scalars["Float"]["output"]>
  genabilityUsageEstimate: Maybe<Scalars["String"]["output"]>
  hourlyConsumptionkWAC: Array<Scalars["Float"]["output"]>
  id: Scalars["String"]["output"]
  margin: Scalars["Float"]["output"]
  mentorId: Maybe<Scalars["String"]["output"]>
  monthlyEnergyCost: Array<Scalars["Float"]["output"]>
  monthlyEnergyUse: Array<Scalars["Float"]["output"]>
  name: Maybe<Scalars["String"]["output"]>
  newConstruction: Scalars["Boolean"]["output"]
  newCustomerIncentive: Scalars["Boolean"]["output"]
  postSolarUtilityRateId: Maybe<Scalars["String"]["output"]>
  powurProjectId: Maybe<Scalars["Float"]["output"]>
  preferredLanguage: Scalars["String"]["output"]
  primaryPresenter: Maybe<Scalars["Float"]["output"]>
  requiresRefresh: Scalars["Boolean"]["output"]
  secondaryPresenter: Maybe<Scalars["Float"]["output"]>
  secondarySystem: Scalars["Boolean"]["output"]
  sellerId: Scalars["String"]["output"]
  siteId: Scalars["String"]["output"]
  slug: Scalars["String"]["output"]
  /** System type (roof mount, ground mount, or both) */
  systemType: Maybe<SystemType | `${SystemType}`>
  totalCost: Scalars["Float"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
  usageProfileId: Maybe<Scalars["String"]["output"]>
  userAdjustedAfterSolarContractedRate: Maybe<Scalars["Float"]["output"]>
  userAdjustedBeforeSolarContractedRate: Maybe<Scalars["Float"]["output"]>
  userAdjustedUtilityRate: Maybe<Scalars["Float"]["output"]>
  utilityRateEscalationPercentage: Scalars["Float"]["output"]
  utilityRateId: Maybe<Scalars["String"]["output"]>
}

export type BasicAdderAssociation = {
  __typename?: "BasicAdderAssociation"
  adderId: Scalars["Int"]["output"]
  equipmentId: Scalars["Int"]["output"]
  qty: Scalars["Int"]["output"]
}

export type Brochure = {
  __typename?: "Brochure"
  afterSolarUtilityBills: Array<BrochureUtilityBill>
  annualSolarProduction: Scalars["Float"]["output"]
  baseGenabilityUtilityRate: Scalars["Float"]["output"]
  beforeSolarUtilityBills: Array<BrochureUtilityBill>
  createdAt: Scalars["DateTime"]["output"]
  /** The average expected utility rate for 25 years */
  dialUtilityRates: Array<Scalars["Float"]["output"]>
  energyOffset: Scalars["Float"]["output"]
  id: Scalars["String"]["output"]
  months: Array<BrochureMonth>
  proposalId: Scalars["String"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
  userAdjustedUtilityRate: Maybe<Scalars["Float"]["output"]>
  utilityRateEscalationPercentage: Scalars["Float"]["output"]
}

export type BrochureMonth = {
  __typename?: "BrochureMonth"
  export_kWh: Scalars["Float"]["output"]
  import_kWh: Scalars["Float"]["output"]
  month: Scalars["String"]["output"]
  postSolarEnergyCost_USD: Scalars["Float"]["output"]
  postSolarFixedCost_USD: Scalars["Float"]["output"]
  postSolarLoanPayment_USD: Scalars["Float"]["output"]
  postSolarUtilityCost_USD: Scalars["Float"]["output"]
  preSolarEnergyCost_USD: Scalars["Float"]["output"]
  preSolarFixedCost_USD: Scalars["Float"]["output"]
  preSolarUtilityCost_USD: Scalars["Float"]["output"]
  production_kWh: Scalars["Float"]["output"]
}

export type BrochureSlidesObject = {
  __typename?: "BrochureSlidesObject"
  name: Scalars["String"]["output"]
  url: Maybe<Scalars["String"]["output"]>
}

export type BrochureSlidesObjectDtoInput = {
  name: Scalars["String"]["input"]
  url?: InputMaybe<Scalars["String"]["input"]>
}

export type BrochureUtilityBill = {
  __typename?: "BrochureUtilityBill"
  bill: Scalars["Float"]["output"]
  energy: Scalars["Float"]["output"]
  fixed: Scalars["Float"]["output"]
  payment: Maybe<Scalars["Float"]["output"]>
  sortOrder: Scalars["Float"]["output"]
}

/** Goodleap Citizenship Status Type */
export enum Citizenship_Status {
  LAWFUL_PERMANENT_RESIDENT_ALIEN = "LAWFUL_PERMANENT_RESIDENT_ALIEN",
  OTHER = "OTHER",
  US_CITIZEN = "US_CITIZEN",
}

export type CalculatedSystemPricing = {
  __typename?: "CalculatedSystemPricing"
  estimatedFirstYearMonthlyPayment: PriceUnit
  powerPurchaseRate: PowerPurchaseRate
  pricePerUnit: PricePerUnit
  purchasePrice: PriceUnit
}

export type Choice = {
  __typename?: "Choice"
  dataValue: Maybe<Scalars["String"]["output"]>
  displayName: Maybe<Scalars["String"]["output"]>
  displayValue: Maybe<Scalars["String"]["output"]>
  likelihood: Maybe<Scalars["Float"]["output"]>
  name: Maybe<Scalars["String"]["output"]>
  value: Scalars["String"]["output"]
}

export type ChoiceInput = {
  dataValue?: InputMaybe<Scalars["String"]["input"]>
  displayName?: InputMaybe<Scalars["String"]["input"]>
  displayValue?: InputMaybe<Scalars["String"]["input"]>
  likelihood?: InputMaybe<Scalars["Float"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  value: Scalars["String"]["input"]
}

export type CloneProposalDtoInput = {
  proposalId: Scalars["String"]["input"]
}

export type CoApplicant = {
  address?: InputMaybe<AddressInput>
  annualIncome: CurrencyInput
  citizenshipStatus: Citizenship_Status | `${Citizenship_Status}`
  dob: Scalars["String"]["input"]
  electronicConsent: Scalars["Boolean"]["input"]
  email: Scalars["String"]["input"]
  employer?: InputMaybe<Scalars["String"]["input"]>
  employmentDuration?: InputMaybe<Scalars["Float"]["input"]>
  employmentStatus: Employment_Status | `${Employment_Status}`
  firstName: Scalars["String"]["input"]
  homeOccupancy: Home_Occupancy | `${Home_Occupancy}`
  homeOwnership: Home_Ownership | `${Home_Ownership}`
  lastName: Scalars["String"]["input"]
  occupation: Scalars["String"]["input"]
  primaryPhoneNumber?: InputMaybe<PhoneInput>
  secondaryPhoneNumber?: InputMaybe<PhoneInput>
  spokenLanguage: Spoken_Language | `${Spoken_Language}`
  ssn: Scalars["String"]["input"]
}

export type CompatibleManufacturer = {
  __typename?: "CompatibleManufacturer"
  equipmentId: Scalars["Int"]["output"]
  manufacturer: PowurOsManufacturer
  manufacturerId: Scalars["Int"]["output"]
}

export enum ContentType {
  JPEG = "JPEG",
  JPG = "JPG",
  JSON = "JSON",
  PDF = "PDF",
  PNG = "PNG",
}

export type Contract = {
  __typename?: "Contract"
  contractPackageVersion: Scalars["Float"]["output"]
  contractType: Scalars["String"]["output"]
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  dateSent: Maybe<Scalars["DateTime"]["output"]>
  dateSentToPowurOs: Maybe<Scalars["DateTime"]["output"]>
  dateSigned: Maybe<Scalars["DateTime"]["output"]>
  envelopeId: Maybe<Scalars["String"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  proposalId: Scalars["String"]["output"]
  recipientEmail: Maybe<Scalars["String"]["output"]>
  systemSize: Maybe<Scalars["Float"]["output"]>
  totalCost: Maybe<Scalars["Float"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type ContractInfo = {
  __typename?: "ContractInfo"
  cashPayment: Scalars["Float"]["output"]
  contractPdfDownloadUrl: Scalars["String"]["output"]
  cosignerEmail: Maybe<Scalars["String"]["output"]>
  cosignerFirstName: Maybe<Scalars["String"]["output"]>
  cosignerLastName: Maybe<Scalars["String"]["output"]>
  cosignerName: Maybe<Scalars["String"]["output"]>
  currentDealerFee: Scalars["Float"]["output"]
  currentPowurMargin: Scalars["Float"]["output"]
  dateSigned: Scalars["String"]["output"]
  dealerFee: Scalars["Float"]["output"]
  docusignEnvelopeId: Scalars["String"]["output"]
  extendedWarranties: Array<ExtendedWarranty>
  federalTaxCredit: Scalars["Float"]["output"]
  fundingType: Scalars["String"]["output"]
  loanAPR: Scalars["Float"]["output"]
  loanApplicationId: Scalars["String"]["output"]
  loanTerm: Scalars["Int"]["output"]
  promotionalPayment: Maybe<Scalars["Float"]["output"]>
  proposalId: Scalars["String"]["output"]
  secondPaymentWithIncentives: Maybe<Scalars["Float"]["output"]>
  secondPaymentWithoutIncentives: Maybe<Scalars["Float"]["output"]>
  totalContractPrice: Scalars["Float"]["output"]
  totalDealerFee: Scalars["Float"]["output"]
  totalFinanced: Scalars["Float"]["output"]
}

export type ContractSentDocuments = {
  __typename?: "ContractSentDocuments"
  brochurePdfUrl: Scalars["String"]["output"]
  priceSheetPdfUrl: Scalars["String"]["output"]
  pricingJsonInput: Scalars["String"]["output"]
  proposalDesignJsonUrl: Scalars["String"]["output"]
}

export type ContractSignedAddress = {
  __typename?: "ContractSignedAddress"
  city: Scalars["String"]["output"]
  country: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  street: Scalars["String"]["output"]
  zip: Scalars["String"]["output"]
}

export type ContractSignedDocuments = {
  __typename?: "ContractSignedDocuments"
  brochurePdfUrl: Scalars["String"]["output"]
  contractPdfUrl: Scalars["String"]["output"]
  priceSheetPdfUrl: Scalars["String"]["output"]
  pricingJsonInput: Scalars["String"]["output"]
  proposalDesignJsonUrl: Scalars["String"]["output"]
}

export type ContractVersionHistory = {
  __typename?: "ContractVersionHistory"
  isSigned: Scalars["Boolean"]["output"]
  isVoid: Scalars["Boolean"]["output"]
  recipientEmail: Maybe<Scalars["String"]["output"]>
  sentAt: Maybe<Scalars["DateTime"]["output"]>
  systemSize: Maybe<Scalars["Float"]["output"]>
  totalCost: Maybe<Scalars["Float"]["output"]>
  versionNumber: Scalars["Float"]["output"]
}

export type CreateCustomIncentiveInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  activeInZipCodes: Array<Scalars["String"]["input"]>
  applicabilityMaxValue?: InputMaybe<Scalars["Float"]["input"]>
  applicabilityMinValue?: InputMaybe<Scalars["Float"]["input"]>
  applicabilityName?: InputMaybe<Scalars["String"]["input"]>
  canApplyToLoan: Scalars["Boolean"]["input"]
  endDate?: InputMaybe<Scalars["String"]["input"]>
  incentiveCategory: IncentiveCategory | `${IncentiveCategory}`
  incentiveName: Scalars["String"]["input"]
  incentiveType: Scalars["String"]["input"]
  isPaidAsLumpSum: Scalars["Boolean"]["input"]
  isSungageRebate: Scalars["Boolean"]["input"]
  jurisdiction: Scalars["String"]["input"]
  lseCode?: InputMaybe<Scalars["String"]["input"]>
  lseId?: InputMaybe<Scalars["Float"]["input"]>
  lseName?: InputMaybe<Scalars["String"]["input"]>
  paymentCap?: InputMaybe<Scalars["Float"]["input"]>
  paymentDuration: Scalars["Float"]["input"]
  percentCostCap?: InputMaybe<Scalars["Float"]["input"]>
  percentCostCapKey?: InputMaybe<PropertyKeyInput>
  quantityKey: PropertyKeyInput
  quantityKeyCap?: InputMaybe<Scalars["String"]["input"]>
  rate: Scalars["Float"]["input"]
  rateUnit: Scalars["String"]["input"]
  startDate: Scalars["String"]["input"]
  state: Scalars["String"]["input"]
  turnedOnByDefaultAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type CreateEstimateOverridesInput = {
  acAnnual: Scalars["Float"]["input"]
  acHourly: Array<Scalars["Float"]["input"]>
  acMonthly: Array<Scalars["Float"]["input"]>
  designId: Scalars["String"]["input"]
  proposalId: Scalars["String"]["input"]
  providerProfileId: Scalars["String"]["input"]
  siteId: Scalars["String"]["input"]
  systemCapacity: Scalars["Float"]["input"]
}

export type CreateLoanProductInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  createdAt: Scalars["DateTime"]["input"]
  escalator?: InputMaybe<Scalars["Float"]["input"]>
  id: Scalars["ID"]["input"]
  introPaymentFactor: Scalars["Float"]["input"]
  loanType: Scalars["String"]["input"]
  maximumLoanAmount?: InputMaybe<Scalars["Float"]["input"]>
  minimumCreditScore?: InputMaybe<Scalars["Float"]["input"]>
  minimumLoanAmount?: InputMaybe<Scalars["Float"]["input"]>
  powurOsCurrentDealerFee?: InputMaybe<Scalars["Float"]["input"]>
  powurOsCurrentPowurMargin?: InputMaybe<Scalars["Float"]["input"]>
  powurOsDealerFeePlusMargin?: InputMaybe<Scalars["Float"]["input"]>
  powurOsLoanId?: InputMaybe<Scalars["Float"]["input"]>
  powurOsLoanProviderId?: InputMaybe<Scalars["Float"]["input"]>
  productName?: InputMaybe<Scalars["String"]["input"]>
  provider: Scalars["String"]["input"]
  providerFee?: InputMaybe<Scalars["Float"]["input"]>
  providerId: Scalars["String"]["input"]
  providerMeta: Scalars["JSON"]["input"]
  providerName?: InputMaybe<Scalars["String"]["input"]>
  rate: Scalars["Float"]["input"]
  statesActive?: InputMaybe<Array<Scalars["String"]["input"]>>
  statesPossible: Array<Scalars["String"]["input"]>
  syncHistory: Array<Scalars["JSON"]["input"]>
  term: Scalars["Float"]["input"]
  updatedAt: Scalars["DateTime"]["input"]
}

export type CreateProposalStatusInput = {
  message: Scalars["String"]["input"]
  proposalId: Scalars["String"]["input"]
}

export type CreateServiceIntegrationInput = {
  contactEmail: Scalars["String"]["input"]
  contactName: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
}

export type CreateSiteInput = {
  /** Address of the site */
  address: Scalars["String"]["input"]
  /** Latitude of the site */
  latitude: Scalars["Float"]["input"]
  /** Longitude of the site */
  longitude: Scalars["Float"]["input"]
  /** street view latitude of the site */
  streetViewLatitude: Scalars["Float"]["input"]
  /** Street view longitude of the site */
  streetViewLongitude: Scalars["Float"]["input"]
  /** zoom level of the mapping service */
  zoom?: InputMaybe<Scalars["Float"]["input"]>
}

export type CreateUserInput = {
  email: Scalars["String"]["input"]
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  permissions: Array<Permission | `${Permission}`>
  phone?: InputMaybe<Scalars["String"]["input"]>
  powurUserId?: InputMaybe<Scalars["Float"]["input"]>
}

export type Currency = {
  __typename?: "Currency"
  type: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type CurrencyInput = {
  type: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type CustomerInfo = {
  __typename?: "CustomerInfo"
  address: ContractSignedAddress
  homeowner: Homeowner
  preferredLanguage: Scalars["String"]["output"]
  projectId: Scalars["Int"]["output"]
}

export enum DataType {
  BOOLEAN = "BOOLEAN",
  CHOICE = "CHOICE",
  DATE = "DATE",
  DECIMAL = "DECIMAL",
  DEMAND = "DEMAND",
  FORMULA = "FORMULA",
  INTEGER = "INTEGER",
  STRING = "STRING",
}

export type Decision = {
  __typename?: "Decision"
  applicantMessages: ApplicantMessage
  creditApplicationId: Scalars["String"]["output"]
  description: Scalars["String"]["output"]
  expires: Scalars["String"]["output"]
  financingProducts: Array<FinancingProduct>
  result: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  updated: Scalars["String"]["output"]
}

export type Design = {
  __typename?: "Design"
  activatedAt: Maybe<Scalars["DateTime"]["output"]>
  annualOffset: Maybe<Scalars["Float"]["output"]>
  annualProduction: Maybe<Scalars["Float"]["output"]>
  batteryCompatibility: Scalars["Boolean"]["output"]
  brochurePositionX: Scalars["Float"]["output"]
  brochurePositionY: Scalars["Float"]["output"]
  brochureZoom: Scalars["Float"]["output"]
  completedAt: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  designEquipment: Array<DesignEquipmentObject>
  designRequest: Maybe<DesignRequest>
  designRequestId: Maybe<Scalars["ID"]["output"]>
  designers: Array<DesignUser>
  displayImageryProvider: ImagerySource | `${ImagerySource}`
  edges: Scalars["JSON"]["output"]
  energyBackup: Maybe<PricedEquipment>
  energyBackupId: Maybe<Scalars["Int"]["output"]>
  energyEfficiencyKitRebate: Scalars["Boolean"]["output"]
  energyEfficiencyKitRebateAmount: Scalars["Float"]["output"]
  estimates: Maybe<Array<EstimateResult>>
  evCharger: Scalars["Boolean"]["output"]
  evOutlet: Scalars["Boolean"]["output"]
  extendedWarrantyCost: Maybe<Scalars["Float"]["output"]>
  extendedWarrantyFamily: Maybe<Scalars["String"]["output"]>
  extendedWarrantyName: Maybe<Scalars["String"]["output"]>
  extendedWarrantyPowurOsId: Maybe<Scalars["Int"]["output"]>
  extendedWarrantySpanishName: Maybe<Scalars["String"]["output"]>
  homeownerRebate: Scalars["Boolean"]["output"]
  homeownerRebateAmount: Scalars["Float"]["output"]
  id: Scalars["ID"]["output"]
  installAreas: Scalars["JSON"]["output"]
  installAreasToPanels: Scalars["JSON"]["output"]
  inverter: Maybe<PricedEquipment>
  inverterId: Maybe<Scalars["Int"]["output"]>
  inverterManufacturer: Maybe<Scalars["String"]["output"]>
  name: Maybe<Scalars["String"]["output"]>
  nodes: Scalars["JSON"]["output"]
  obstructions: Scalars["JSON"]["output"]
  openSolarImage: Maybe<Imagery>
  optimalEstimate: Maybe<EstimateResult>
  panels: Scalars["JSON"]["output"]
  parentId: Maybe<Scalars["ID"]["output"]>
  phase: Scalars["String"]["output"]
  poison: Maybe<Poison>
  profiles: Array<GenabilityProfile>
  proposal: Maybe<Proposal>
  proposalId: Scalars["ID"]["output"]
  roofType: Maybe<Scalars["String"]["output"]>
  roofWorkRebate: Scalars["Boolean"]["output"]
  roofWorkRebateAmount: Scalars["Float"]["output"]
  savings: Maybe<SavingsResult>
  secondaryInverter: Maybe<PricedEquipment>
  secondaryInverterId: Maybe<Scalars["Int"]["output"]>
  setbacks: Scalars["JSON"]["output"]
  shadingAreas: Scalars["JSON"]["output"]
  /** @deprecated Use designEquipment filtered by MODULE equipment type */
  solarModule: Maybe<PricedEquipment>
  /** @deprecated Use designEquipment filtered by MODULE equipment type */
  solarModuleId: Maybe<Scalars["Int"]["output"]>
  source: DesignSource | `${DesignSource}`
  sunroofCheckedAt: Maybe<Scalars["DateTime"]["output"]>
  systemSizeKw: Maybe<Scalars["Float"]["output"]>
  tool: Scalars["String"]["output"]
  treeTrimmingRebate: Scalars["Boolean"]["output"]
  treeTrimmingRebateAmount: Scalars["Float"]["output"]
  type: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export type DesignEdit = {
  __typename?: "DesignEdit"
  createdAt: Scalars["String"]["output"]
  designPhase: Scalars["String"]["output"]
  powurUserId: Scalars["Int"]["output"]
}

export type DesignEquipmentObject = {
  __typename?: "DesignEquipmentObject"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  designId: Scalars["String"]["output"]
  equipment: PricedEquipment
  equipmentId: Scalars["Int"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  isDomesticContent: Scalars["Boolean"]["output"]
  powurOsEquipmentTypeId: Scalars["Int"]["output"]
  price: Scalars["Float"]["output"]
  quantity: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type DesignFindManyWhereInput = {
  before?: InputMaybe<Scalars["DateTime"]["input"]>
  designerId?: InputMaybe<Scalars["ID"]["input"]>
  proposalId?: InputMaybe<Scalars["ID"]["input"]>
  sellerId?: InputMaybe<Scalars["ID"]["input"]>
  since?: InputMaybe<Scalars["DateTime"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
}

export type DesignNote = {
  __typename?: "DesignNote"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: User
  createdById: Scalars["String"]["output"]
  designRequest: DesignRequest
  designRequestId: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  message: Scalars["String"]["output"]
  reason: Maybe<Scalars["String"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export type DesignOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>
  id?: InputMaybe<SortOrder | `${SortOrder}`>
  proposalId?: InputMaybe<SortOrder | `${SortOrder}`>
  type?: InputMaybe<SortOrder | `${SortOrder}`>
  updatedAt?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type DesignRequest = {
  __typename?: "DesignRequest"
  abandonedAt: Maybe<Scalars["DateTime"]["output"]>
  claimedUntil: Maybe<Scalars["DateTime"]["output"]>
  completedAt: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  design: Maybe<Design>
  designNotes: Array<DesignNote>
  designUser: Maybe<DesignUser>
  designUserId: Maybe<Scalars["String"]["output"]>
  enterprise: Maybe<Enterprise>
  enterpriseId: Maybe<Scalars["String"]["output"]>
  escalatedAt: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["String"]["output"]
  metadata: Maybe<Scalars["String"]["output"]>
  pausedUntil: Maybe<Scalars["DateTime"]["output"]>
  priority: Scalars["Float"]["output"]
  promisedAt: Maybe<Scalars["DateTime"]["output"]>
  rejectedAt: Maybe<Scalars["DateTime"]["output"]>
  requestType: Maybe<Scalars["String"]["output"]>
  timeAdded: Maybe<Scalars["Float"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export type DesignRequestCount = {
  __typename?: "DesignRequestCount"
  abandoned: Scalars["Float"]["output"]
  completed: Scalars["Float"]["output"]
  escalated: Scalars["Float"]["output"]
  inProgress: Scalars["Float"]["output"]
  requested: Scalars["Float"]["output"]
  total: Scalars["Float"]["output"]
}

export type DesignRequestFindManyWhereInput = {
  projectId?: InputMaybe<Scalars["Int"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
}

export type DesignRequestTypeDto = {
  __typename?: "DesignRequestTypeDto"
  prettyName: Scalars["String"]["output"]
  value: Maybe<Scalars["String"]["output"]>
}

export type DesignRevisionInput = {
  notes: Scalars["String"]["input"]
  parentId: Scalars["ID"]["input"]
  reasons: Array<Scalars["String"]["input"]>
  revisionType?: InputMaybe<Scalars["String"]["input"]>
}

export enum DesignSource {
  aurora = "aurora",
  vision = "vision",
}

export type DesignUser = {
  __typename?: "DesignUser"
  completedAt: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  design: Design
  designId: Scalars["String"]["output"]
  designNotes: Array<DesignNote>
  designRequests: Array<DesignRequest>
  id: Scalars["String"]["output"]
  startedAt: Maybe<Scalars["DateTime"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
  user: User
  userId: Scalars["String"]["output"]
}

export type DesignsInput = {
  filter?: InputMaybe<DesignFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<DesignOrderByInput>
}

export type DevCreateProposalDtoNew = {
  __typename?: "DevCreateProposalDtoNew"
  designRequestNote: Scalars["String"]["output"]
  designRequestType: Array<DesignRequestTypeDto>
  mentors: Array<User>
  /** Proposal name */
  name: Maybe<Scalars["String"]["output"]>
  platform: PlatformCreateProposalDto
  roofTypes: Array<Scalars["String"]["output"]>
  sellers: Array<User>
}

export type DisplayAddress = {
  __typename?: "DisplayAddress"
  category: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["String"]["output"]
  lat: Scalars["Float"]["output"]
  long: Scalars["Float"]["output"]
  postal: Scalars["String"]["output"]
  projectId: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  street: Scalars["String"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type DisplayAddressInput = {
  category: Scalars["String"]["input"]
  city: Scalars["String"]["input"]
  lat: Scalars["Float"]["input"]
  long: Scalars["Float"]["input"]
  postal: Scalars["String"]["input"]
  state: Scalars["String"]["input"]
  street: Scalars["String"]["input"]
}

export type Document = {
  __typename?: "Document"
  description: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type DocumentObject = {
  __typename?: "DocumentObject"
  contentType: ContentType | `${ContentType}`
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  filename: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type DocumentsForPowurOs = {
  __typename?: "DocumentsForPowurOS"
  contractId: Scalars["String"]["output"]
  contractSent: ContractSentDocuments
  contractSigned: ContractSignedDocuments
}

/** Goodleap Employment Status Type */
export enum Employment_Status {
  EMPLOYED = "EMPLOYED",
  NOT_EMPLOYED = "NOT_EMPLOYED",
  OTHER = "OTHER",
  RETIRED = "RETIRED",
}

export type EnfinApplicationDetails = {
  __typename?: "EnfinApplicationDetails"
  appStatus: Scalars["String"]["output"]
  message: Scalars["String"]["output"]
}

export type Enterprise = {
  __typename?: "Enterprise"
  cobrandSettings: Maybe<EnterpriseCobrandSettingsObject>
  commissionVisibility: Maybe<Scalars["String"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  logo: Maybe<Logo>
  logoUrl: Maybe<Scalars["String"]["output"]>
  marginVisibility: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  owner: User
  ownerId: Scalars["String"]["output"]
  poisonId: Scalars["String"]["output"]
  powurId: Scalars["Float"]["output"]
  shouldCobrand: Scalars["Boolean"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type EnterpriseCobrandSettingsObject = {
  __typename?: "EnterpriseCobrandSettingsObject"
  brochureSlides: Array<BrochureSlidesObject>
  createdAt: Scalars["DateTime"]["output"]
  enterpriseId: Scalars["String"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type EnterpriseLogoDto = {
  __typename?: "EnterpriseLogoDto"
  bucket: Scalars["String"]["output"]
  key: Scalars["String"]["output"]
}

export type EnterpriseLogoDtoInput = {
  bucket: Scalars["String"]["input"]
  key: Scalars["String"]["input"]
}

export type EnterpriseMarginSettingsDto = {
  __typename?: "EnterpriseMarginSettingsDto"
  manager_margin_adjustment: Scalars["Boolean"]["output"]
  manager_minimum_margin: Scalars["Float"]["output"]
  margin_fixed: Scalars["Boolean"]["output"]
  proposal_margin: Scalars["Float"]["output"]
}

export type EnterpriseSettings = {
  __typename?: "EnterpriseSettings"
  compType: Maybe<Scalars["String"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  entBaselinePpw: Maybe<Scalars["Float"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  managerMarginAdjustment: Scalars["Boolean"]["output"]
  managerMinimumMargin: Scalars["Float"]["output"]
  marginFixed: Scalars["Boolean"]["output"]
  orgHoldbackPpw: Maybe<Scalars["Float"]["output"]>
  proposalMargin: Scalars["Float"]["output"]
  sellerPowurlinePpw: Maybe<Scalars["Float"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type Equipment = {
  __typename?: "Equipment"
  basicAdderAssociations: Array<BasicAdderAssociation>
  catalogNumber: Maybe<Scalars["String"]["output"]>
  cecWeightedEfficiency: Scalars["Float"]["output"]
  childEquipmentAssociations: Scalars["JSON"]["output"]
  compatibleInverterManufacturers: Array<CompatibleManufacturer>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  currentProposalPrice: Scalars["Float"]["output"]
  deprecated_id: Maybe<Scalars["String"]["output"]>
  description: Maybe<Scalars["String"]["output"]>
  energyBackupData: Maybe<Scalars["JSON"]["output"]>
  equipmentType: EquipmentType
  equipmentTypeId: Scalars["String"]["output"]
  fallbackPrice: Maybe<Scalars["Float"]["output"]>
  height: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  inverterData: Maybe<Scalars["JSON"]["output"]>
  isDefault: Scalars["Boolean"]["output"]
  isKit: Scalars["Boolean"]["output"]
  manufacturer: Manufacturer
  manufacturerId: Scalars["String"]["output"]
  moduleData: Maybe<Scalars["JSON"]["output"]>
  name: Scalars["String"]["output"]
  parentEquipmentAssociations: Scalars["JSON"]["output"]
  powurOsEnergyBackupDataId: Maybe<Scalars["Float"]["output"]>
  powurOsEquipmentTypeId: Scalars["Float"]["output"]
  powurOsInverterDataId: Maybe<Scalars["Float"]["output"]>
  powurOsManufacturerId: Scalars["Float"]["output"]
  powurOsModuleDataId: Maybe<Scalars["Float"]["output"]>
  proposalPrices: Array<Scalars["JSON"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  warranty: Maybe<Scalars["JSON"]["output"]>
  wattage: Maybe<Scalars["Float"]["output"]>
  width: Maybe<Scalars["Float"]["output"]>
}

export type EquipmentAvailabilityResultObject = {
  __typename?: "EquipmentAvailabilityResultObject"
  availabilityStatus: UnavailabilityReason | `${UnavailabilityReason}`
  catalogNumber: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  manufacturerName: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  unavailabilityReason: Maybe<Scalars["String"]["output"]>
}

export type EquipmentForPowurOs = {
  __typename?: "EquipmentForPowurOS"
  catalogNumber: Scalars["String"]["output"]
  equipmentTypeId: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  manufacturerId: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  price: Scalars["Float"]["output"]
  quantity: Scalars["Int"]["output"]
}

export type EquipmentType = {
  __typename?: "EquipmentType"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  equipment: Maybe<Array<Equipment>>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  powurOsId: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type Estimate = {
  __typename?: "Estimate"
  /** Annual AC system output. (kWhac) */
  acAnnual: Scalars["Float"]["output"]
  /** Hourly AC system output (only when timeframe=hourly). (Wac) */
  acHourly: Array<Scalars["Float"]["output"]>
  /** Monthly AC system output. (kWhac).  The array of values represents the value for each month, with the first element being for January and the last element being for December. */
  acMonthly: Array<Scalars["Float"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** The ID of the associated design */
  designId: Maybe<Scalars["String"]["output"]>
  /** Any error messages resulting from the request. */
  errors: Array<Scalars["String"]["output"]>
  /** The ID of the estimate. */
  id: Scalars["ID"]["output"]
  /** Inputs used to make the request to PvWatts API */
  inputs: Maybe<PvWatts_Inputs>
  /** The ID of the associated install area */
  installAreaId: Maybe<Scalars["String"]["output"]>
  solarProfile: Maybe<GenabilityProfile>
  solarProfileId: Maybe<Scalars["String"]["output"]>
  /** Information about the SSC library. */
  sscInfo: Maybe<SscInfo>
  /** Information about the climate data used in the simulation. */
  stationInfo: Maybe<StationInfo>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type EstimateResult = Estimate | PoisonedEstimate

export type ExtendedWarranty = {
  __typename?: "ExtendedWarranty"
  equipmentId: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
  warrantyId: Scalars["Int"]["output"]
}

export type ExternalIdentifier = {
  __typename?: "ExternalIdentifier"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** the external id */
  identifier: Scalars["String"]["output"]
  /** metadata information */
  metadata: Scalars["JSON"]["output"]
  /** internal vision proposal id */
  proposalId: Maybe<Scalars["String"]["output"]>
  /** provider name  */
  provider: ExternalProvider | `${ExternalProvider}`
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  /** internal vision user id */
  userId: Scalars["String"]["output"]
}

export enum ExternalProvider {
  concert = "concert",
  enfin = "enfin",
  goodleap = "goodleap",
  mosaic = "mosaic",
  sungage = "sungage",
  sunlight = "sunlight",
}

export type FinancingProduct = {
  __typename?: "FinancingProduct"
  id: Scalars["String"]["output"]
  maxBorrowingAmount: Scalars["Float"]["output"]
  minBorrowingAmount: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
}

export type FindEstimateInput = {
  id: Scalars["ID"]["input"]
}

export type FindProposalInput = {
  /** Proposal ID */
  id?: InputMaybe<Scalars["String"]["input"]>
  /** Proposal unique slug */
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type FirstYearMonthlyPayment = {
  __typename?: "FirstYearMonthlyPayment"
  type: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type GenabilityAccountAnalysis = {
  __typename?: "GenabilityAccountAnalysis"
  currency: Maybe<Scalars["String"]["output"]>
  dataStatus: Scalars["Float"]["output"]
  designId: Maybe<Scalars["String"]["output"]>
  scenarios: Array<GenabilityScenario>
  series: Array<GenabilitySeries>
  seriesCosts: Array<GenabilityCalculatedCost>
  seriesData: Array<GenabilitySeriesMeasure>
  summary: GenabilityAccountAnalysisSummary
}

export type GenabilityAccountAnalysisInputs = {
  __typename?: "GenabilityAccountAnalysisInputs"
  consumptionProviderProfileId: Maybe<Scalars["String"]["output"]>
  fromDateTime: Maybe<Scalars["String"]["output"]>
  genabilityAccountId: Scalars["String"]["output"]
  optimizedConsumptionProviderProfileId: Maybe<Scalars["String"]["output"]>
  optimizedProductionProviderProfileId: Maybe<Scalars["String"]["output"]>
  postSolarMasterTariffId: Scalars["Float"]["output"]
  preSolarMasterTariffId: Scalars["Float"]["output"]
  productionProviderProfileIds: Maybe<Array<Scalars["String"]["output"]>>
  projectDuration: Scalars["Float"]["output"]
  rateInflation: Scalars["Float"]["output"]
  solarDegradation: Scalars["Float"]["output"]
  storageProviderProfileId: Maybe<Scalars["String"]["output"]>
  userAdjustedRate: Maybe<Scalars["Float"]["output"]>
}

export type GenabilityAccountAnalysisSummary = {
  __typename?: "GenabilityAccountAnalysisSummary"
  lifeTimeUtilityAfterCost: Maybe<Scalars["Float"]["output"]>
  lifeTimeUtilityAvoidedRate: Maybe<Scalars["Float"]["output"]>
  lifetimeAvoidedCost: Maybe<Scalars["Float"]["output"]>
  lifetimeSolarCost: Maybe<Scalars["Float"]["output"]>
  lifetimeWithoutCost: Maybe<Scalars["Float"]["output"]>
  netAvoidedCost: Maybe<Scalars["Float"]["output"]>
  netAvoidedCostPctOffset: Maybe<Scalars["Float"]["output"]>
  netAvoidedKWh: Maybe<Scalars["Float"]["output"]>
  netAvoidedKWhPctOffset: Maybe<Scalars["Float"]["output"]>
  netAvoidedRate: Maybe<Scalars["Float"]["output"]>
  postTotalCost: Scalars["Float"]["output"]
  postTotalKWh: Scalars["Float"]["output"]
  postTotalKWhCost: Scalars["Float"]["output"]
  postTotalKWhRate: Scalars["Float"]["output"]
  postTotalMinCost: Scalars["Float"]["output"]
  postTotalNonBypassableCost: Maybe<Scalars["Float"]["output"]>
  postTotalNonMinCost: Maybe<Scalars["Float"]["output"]>
  postTotalRate: Maybe<Scalars["Float"]["output"]>
  preTotalCost: Scalars["Float"]["output"]
  preTotalKWh: Scalars["Float"]["output"]
  preTotalKWhCost: Scalars["Float"]["output"]
  preTotalKWhRate: Scalars["Float"]["output"]
  preTotalMinCost: Scalars["Float"]["output"]
  preTotalNonBypassableCost: Scalars["Float"]["output"]
  preTotalNonMinCost: Scalars["Float"]["output"]
  preTotalRate: Scalars["Float"]["output"]
}

export type GenabilityCalculatedCost = {
  __typename?: "GenabilityCalculatedCost"
  accuracy: Scalars["Float"]["output"]
  assumptions: Array<GenabilityPropertyData>
  calculatedCostId: Maybe<Scalars["String"]["output"]>
  currency: Scalars["String"]["output"]
  fromDateTime: Scalars["String"]["output"]
  items: Array<GenabilityCalculatedCostItem>
  masterTariffId: Scalars["Float"]["output"]
  summary: GenabilityCalculatedCostSummary
  tariffName: Scalars["String"]["output"]
  toDateTime: Scalars["String"]["output"]
  totalCost: Scalars["Float"]["output"]
}

export type GenabilityCalculatedCostItem = {
  __typename?: "GenabilityCalculatedCostItem"
  chargeClass: Maybe<Scalars["String"]["output"]>
  chargeType: Maybe<Scalars["String"]["output"]>
  cost: Maybe<Scalars["Float"]["output"]>
  demandInterval: Maybe<Scalars["String"]["output"]>
  duration: Maybe<Scalars["Float"]["output"]>
  formula: Maybe<Scalars["String"]["output"]>
  fromDateTime: Scalars["String"]["output"]
  itemQuantity: Scalars["Float"]["output"]
  periodType: Maybe<Scalars["String"]["output"]>
  quantityKey: Scalars["String"]["output"]
  quantityKeyDescription: Maybe<Scalars["String"]["output"]>
  rateAmount: Scalars["Float"]["output"]
  rateName: Maybe<Scalars["String"]["output"]>
  rateProration: Maybe<Scalars["Float"]["output"]>
  rateSequenceNumber: Maybe<Scalars["Float"]["output"]>
  rateType: Maybe<Scalars["String"]["output"]>
  seasonId: Maybe<Scalars["Float"]["output"]>
  seasonName: Maybe<Scalars["String"]["output"]>
  tariffId: Maybe<Scalars["Float"]["output"]>
  tariffRateBandId: Maybe<Scalars["Float"]["output"]>
  tariffRateId: Maybe<Scalars["Float"]["output"]>
  tierLowerLimit: Maybe<Scalars["Float"]["output"]>
  tierUpperLimit: Maybe<Scalars["Float"]["output"]>
  toDateTime: Scalars["String"]["output"]
  touId: Maybe<Scalars["Float"]["output"]>
  touName: Maybe<Scalars["String"]["output"]>
  transactionType: Maybe<Scalars["String"]["output"]>
}

export type GenabilityCalculatedCostSummary = {
  __typename?: "GenabilityCalculatedCostSummary"
  ELECTRICITY: Maybe<GenabilityKWkWh>
  adjustedTotalCost: Scalars["Float"]["output"]
  export: Maybe<Scalars["Float"]["output"]>
  import: Maybe<Scalars["Float"]["output"]>
  kW: Scalars["Float"]["output"]
  kWh: Scalars["Float"]["output"]
  nonBypassableCost: Maybe<Scalars["Float"]["output"]>
  preTaxMinimumCost: Maybe<Scalars["Float"]["output"]>
  subTotalCost: Scalars["Float"]["output"]
  taxCost: Scalars["Float"]["output"]
  totalCost: Scalars["Float"]["output"]
}

export type GenabilityKWkWh = {
  __typename?: "GenabilityKWkWh"
  kW: Scalars["Float"]["output"]
  kWh: Scalars["Float"]["output"]
}

export type GenabilityProfile = {
  __typename?: "GenabilityProfile"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  profileId: Scalars["String"]["output"]
  providerProfileId: Scalars["String"]["output"]
  savingsId: Maybe<Scalars["String"]["output"]>
  siteId: Scalars["String"]["output"]
  type: GenabilityProfileType | `${GenabilityProfileType}`
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export enum GenabilityProfileType {
  solar_post = "solar_post",
  storage_post = "storage_post",
  usage_post = "usage_post",
  usage_pre = "usage_pre",
}

export type GenabilityPropertyData = {
  __typename?: "GenabilityPropertyData"
  accuracy: Maybe<Scalars["Float"]["output"]>
  dataFactor: Maybe<Scalars["Float"]["output"]>
  dataSeries: Maybe<Array<Scalars["Float"]["output"]>>
  dataType: Maybe<DataType | `${DataType}`>
  dataValue: Maybe<Scalars["String"]["output"]>
  description: Maybe<Scalars["String"]["output"]>
  displayName: Maybe<Scalars["String"]["output"]>
  duration: Maybe<Scalars["Float"]["output"]>
  fromDateTime: Maybe<Scalars["String"]["output"]>
  keyName: Scalars["String"]["output"]
  operator: Maybe<Scalars["String"]["output"]>
  toDateTime: Maybe<Scalars["String"]["output"]>
  unit: Maybe<Scalars["String"]["output"]>
}

export type GenabilityScenario = {
  __typename?: "GenabilityScenario"
  id: Maybe<Scalars["String"]["output"]>
  inputs: Array<GenabilityPropertyData>
  name: Maybe<Scalars["String"]["output"]>
  rates: Maybe<Array<GenabilityTariffRateSimple>>
  serviceType: Maybe<Scalars["String"]["output"]>
}

export type GenabilitySeries = {
  __typename?: "GenabilitySeries"
  cost: Scalars["Float"]["output"]
  designId: Maybe<Scalars["String"]["output"]>
  displayLabel: Scalars["String"]["output"]
  fromDateTime: Scalars["String"]["output"]
  key: Maybe<Scalars["String"]["output"]>
  qty: Scalars["Float"]["output"]
  rate: Maybe<Scalars["Float"]["output"]>
  scenario: Scalars["String"]["output"]
  seriesDuration: Scalars["Float"]["output"]
  seriesId: Scalars["Float"]["output"]
  seriesPeriod: Scalars["String"]["output"]
  toDateTime: Scalars["String"]["output"]
}

export type GenabilitySeriesMeasure = {
  __typename?: "GenabilitySeriesMeasure"
  cost: Scalars["Float"]["output"]
  fromDateTime: Scalars["String"]["output"]
  qty: Scalars["Float"]["output"]
  rate: Maybe<Scalars["Float"]["output"]>
  seriesId: Scalars["Float"]["output"]
  toDateTime: Scalars["String"]["output"]
}

export type GenabilityTariffRateBand = {
  __typename?: "GenabilityTariffRateBand"
  hasConsumptionLimit: Maybe<Scalars["Boolean"]["output"]>
  hasDemandLimit: Maybe<Scalars["Boolean"]["output"]>
  hasPropertyLimit: Maybe<Scalars["Boolean"]["output"]>
  isCredit: Scalars["Boolean"]["output"]
  prevUpperLimit: Maybe<Scalars["Float"]["output"]>
  rateAmount: Maybe<Scalars["Float"]["output"]>
  rateSequenceNumber: Maybe<Scalars["Float"]["output"]>
  rateUnit: Maybe<Scalars["String"]["output"]>
  tariffRateBandId: Maybe<Scalars["Float"]["output"]>
  tariffRateId: Maybe<Scalars["Float"]["output"]>
}

export type GenabilityTariffRateSimple = {
  __typename?: "GenabilityTariffRateSimple"
  chargeClass: Maybe<Scalars["String"]["output"]>
  chargePeriod: Maybe<Scalars["String"]["output"]>
  chargeType: Maybe<Scalars["String"]["output"]>
  fromDateTime: Maybe<Scalars["String"]["output"]>
  rateBands: Maybe<Array<GenabilityTariffRateBand>>
  rateName: Scalars["String"]["output"]
  scenarios: Maybe<Scalars["String"]["output"]>
  toDateTime: Maybe<Scalars["String"]["output"]>
}

export type GetDisclosuresByLoanProductIdResponse =
  | GoodLeapGetDisclosuresResponseDto
  | MosaicGetDisclosuresResponseDto
  | SunlightGetDisclosuresResponse

export type GetMockAddressInput = {
  state?: InputMaybe<MockAddressStateCode | `${MockAddressStateCode}`>
}

export type GetSelectIncentivesModal = {
  __typename?: "GetSelectIncentivesModal"
  listed: Array<ProposalIncentive>
  unlisted: Array<ProposalIncentive>
}

export type GetSunlightIframeUrlDto = {
  loanProductId: Scalars["String"]["input"]
  proposalId: Scalars["String"]["input"]
}

export type GoodLeapAmount = {
  __typename?: "GoodLeapAmount"
  type: Scalars["String"]["output"]
  value: Maybe<Scalars["Float"]["output"]>
}

export type GoodLeapCalculation = {
  __typename?: "GoodLeapCalculation"
  amount: GoodLeapAmount
  interval: Scalars["String"]["output"]
  paydownAmount: Maybe<GoodLeapAmount>
  paymentDescription: Maybe<Scalars["String"]["output"]>
  roundedAmount: GoodLeapAmount
  type: Scalars["String"]["output"]
}

export type GoodLeapCreateLoanRequestDto = {
  amount: CurrencyInput
  applicant: ApplicantInput
  applicantSignature: Scalars["String"]["input"]
  categoryId: Scalars["String"]["input"]
  channel?: InputMaybe<Scalars["String"]["input"]>
  coApplicant?: InputMaybe<CoApplicant>
  disclosureToken: Scalars["String"]["input"]
  enrollments: Array<Scalars["String"]["input"]>
  offerId?: InputMaybe<Scalars["String"]["input"]>
  referenceNumber?: InputMaybe<Scalars["String"]["input"]>
  subjectProperty: SubjectPropertyInput
  submittingUser: SubmittingUser
}

export type GoodLeapCreateLoanResponseDto = {
  __typename?: "GoodLeapCreateLoanResponseDto"
  appliedFor: Maybe<Scalars["JSON"]["output"]>
  approvedFor: Maybe<Scalars["JSON"]["output"]>
  approvedLoanAmount: Maybe<Currency>
  calculatedSystemPricing: CalculatedSystemPricing
  changes: Maybe<Array<Scalars["JSON"]["output"]>>
  id: Scalars["String"]["output"]
  offerId: Maybe<Scalars["String"]["output"]>
  pendingCases: Maybe<Array<Scalars["JSON"]["output"]>>
  referenceNumber: Scalars["String"]["output"]
  requestedLoanAmount: Maybe<Currency>
  sentLoanDocuments: Scalars["Boolean"]["output"]
  status: Scalars["String"]["output"]
  stipulations: Array<Stipulation>
  tags: Maybe<Scalars["JSON"]["output"]>
  type: Maybe<Scalars["String"]["output"]>
}

export type GoodLeapDisclosuresDataArrayDto = {
  __typename?: "GoodLeapDisclosuresDataArrayDto"
  current: Scalars["Boolean"]["output"]
  id: Scalars["String"]["output"]
  meta: GoodLeapDisclosuresMetaObjectDto
  name: Scalars["String"]["output"]
  sections: Array<GoodLeapDisclosuresSectionArrayDto>
  token: Maybe<Scalars["String"]["output"]>
  tokenExpiresAt: Maybe<Scalars["String"]["output"]>
}

export type GoodLeapDisclosuresMetaObjectDto = {
  __typename?: "GoodLeapDisclosuresMetaObjectDto"
  cursor: Maybe<Scalars["String"]["output"]>
}

export type GoodLeapDisclosuresSectionArrayDto = {
  __typename?: "GoodLeapDisclosuresSectionArrayDto"
  boldText: Scalars["Boolean"]["output"]
  checkbox: Scalars["Boolean"]["output"]
  signatureBox: Scalars["Boolean"]["output"]
  sort: Scalars["Float"]["output"]
  text: Scalars["String"]["output"]
}

export type GoodLeapGetDisclosuresResponseDto = {
  __typename?: "GoodLeapGetDisclosuresResponseDto"
  data: Array<GoodLeapDisclosuresDataArrayDto>
  links: GoodleapDisclosuresLinks
}

export type GoodLeapPaymentsResponse = {
  __typename?: "GoodLeapPaymentsResponse"
  calculations: Array<GoodLeapCalculation>
  disclaimerText: Maybe<Scalars["String"]["output"]>
  loanAmount: GoodLeapAmount
  offerId: Scalars["String"]["output"]
}

export type GoodleapBorrower = {
  __typename?: "GoodleapBorrower"
  address: Address
  annualIncome: GoodleapValue
  email: Scalars["String"]["output"]
  firstName: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
  phones: Array<Phone>
}

export type GoodleapDisclosuresLinks = {
  __typename?: "GoodleapDisclosuresLinks"
  next: Maybe<Scalars["String"]["output"]>
  prev: Maybe<Scalars["String"]["output"]>
}

export type GoodleapEnrollment = {
  __typename?: "GoodleapEnrollment"
  name: Scalars["String"]["output"]
}

export type GoodleapLoanDetails = {
  __typename?: "GoodleapLoanDetails"
  amount: Maybe<GoodLeapAmount>
  borrower: GoodleapBorrower
  calculatedSystemPricing: CalculatedSystemPricing
  changes: Maybe<Array<Scalars["String"]["output"]>>
  coBorrower: Maybe<GoodleapBorrower>
  createdAt: Scalars["String"]["output"]
  creditExpiresAt: Scalars["String"]["output"]
  enrollments: Array<GoodleapEnrollment>
  estimatedInitialMonthlyPayment: GoodLeapAmount
  id: Scalars["String"]["output"]
  installationCategoryId: Scalars["String"]["output"]
  maxAmount: Maybe<GoodLeapAmount>
  monthlyPayment: Maybe<GoodLeapAmount>
  offerId: Scalars["String"]["output"]
  partnerId: Scalars["String"]["output"]
  referenceNumber: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
  subjectProperty: SubjectProperty
}

export type GoodleapStipulationDetailed = {
  __typename?: "GoodleapStipulationDetailed"
  appliesTo: Maybe<Scalars["String"]["output"]>
  attachments: Maybe<Array<Scalars["JSON"]["output"]>>
  createdAt: Scalars["String"]["output"]
  description: Maybe<Scalars["String"]["output"]>
  documentsToClear: Maybe<Array<Scalars["JSON"]["output"]>>
  domain: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  reasonCodes: Array<Scalars["String"]["output"]>
  status: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
  updatedAt: Scalars["String"]["output"]
}

export type GoodleapValue = {
  __typename?: "GoodleapValue"
  type: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

/** Goodleap Home Type */
export enum Home_Occupancy {
  INVESTMENT = "INVESTMENT",
  OTHER = "OTHER",
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

/** Goodleap Home Ownership Type */
export enum Home_Ownership {
  NOT_OWNED = "NOT_OWNED",
  OWNED_FREE_AND_CLEAR = "OWNED_FREE_AND_CLEAR",
  OWNED_WITH_MORTGAGE = "OWNED_WITH_MORTGAGE",
}

export type Homeowner = {
  __typename?: "Homeowner"
  email: Scalars["String"]["output"]
  firstName: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
  phone: Scalars["String"]["output"]
}

export type ImageSizes = {
  __typename?: "ImageSizes"
  large: Maybe<Scalars["String"]["output"]>
  original: Maybe<Scalars["String"]["output"]>
  preview: Maybe<Scalars["String"]["output"]>
  retina: Maybe<Scalars["String"]["output"]>
  thumb: Maybe<Scalars["String"]["output"]>
}

export type Imagery = {
  __typename?: "Imagery"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** The design this imagery belongs to. If applicable. */
  design: Maybe<Design>
  filename: Scalars["String"]["output"]
  height: Maybe<Scalars["Float"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  imageDate: Maybe<Scalars["String"]["output"]>
  positionedX: Maybe<Scalars["Float"]["output"]>
  positionedY: Maybe<Scalars["Float"]["output"]>
  positionedZoom: Maybe<Scalars["Float"]["output"]>
  /** The site this imagery belongs to */
  site: Maybe<Site>
  siteId: Maybe<Scalars["ID"]["output"]>
  source: ImagerySource | `${ImagerySource}`
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  width: Maybe<Scalars["Float"]["output"]>
  zoomLevel: Maybe<Scalars["Float"]["output"]>
}

export type ImageryResult = Imagery | PoisonedImagery

export enum ImagerySource {
  bing = "bing",
  google = "google",
  nearmap = "nearmap",
  open_solar = "open_solar",
  pictometry = "pictometry",
}

export type Incentive = {
  __typename?: "Incentive"
  activatedAt: Maybe<Scalars["DateTime"]["output"]>
  activeInZipCodes: Array<Scalars["String"]["output"]>
  applicabilities: Maybe<Array<Applicability>>
  applicabilityMaxValue: Maybe<Scalars["Float"]["output"]>
  applicabilityMinValue: Maybe<Scalars["Float"]["output"]>
  applicabilityName: Maybe<Scalars["String"]["output"]>
  canApplyToLoan: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customDisplayName: Maybe<Scalars["String"]["output"]>
  customerClass: Scalars["String"]["output"]
  documents: Maybe<Scalars["String"]["output"]>
  eligibility: Scalars["String"]["output"]
  endDate: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  incentiveCategory: IncentiveCategory | `${IncentiveCategory}`
  incentiveId: Maybe<Scalars["Float"]["output"]>
  incentiveName: Scalars["String"]["output"]
  incentivePaidTo: Maybe<Scalars["String"]["output"]>
  incentiveType: Scalars["String"]["output"]
  isExhausted: Scalars["Boolean"]["output"]
  isPaidAsLumpSum: Scalars["Boolean"]["output"]
  isSungageRebate: Scalars["Boolean"]["output"]
  jurisdiction: Scalars["String"]["output"]
  lseCode: Maybe<Scalars["String"]["output"]>
  lseId: Maybe<Scalars["Float"]["output"]>
  lseName: Maybe<Scalars["String"]["output"]>
  masterIncentiveId: Maybe<Scalars["Float"]["output"]>
  paymentCap: Maybe<Scalars["Float"]["output"]>
  paymentDuration: Scalars["Float"]["output"]
  percentCostCap: Maybe<Scalars["Float"]["output"]>
  percentCostCapKey: Maybe<PropertyKey>
  projectType: Scalars["String"]["output"]
  projectTypeExclusive: Maybe<Scalars["Boolean"]["output"]>
  quantityKey: PropertyKey
  quantityKeyCap: Maybe<Scalars["String"]["output"]>
  rate: Scalars["Float"]["output"]
  rateUnit: Scalars["String"]["output"]
  requiredData: Maybe<Array<Applicability>>
  requirements: Maybe<Scalars["String"]["output"]>
  serviceType: Maybe<Scalars["String"]["output"]>
  source: Scalars["String"]["output"]
  startDate: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  summary: Scalars["String"]["output"]
  tariffCode: Maybe<Scalars["String"]["output"]>
  turnedOnByDefaultAt: Maybe<Scalars["DateTime"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export enum IncentiveCategory {
  battery = "battery",
  solar = "solar",
}

export type IncentiveFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]["input"]>
  source?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  zipCode?: InputMaybe<Scalars["String"]["input"]>
}

export type IncentiveInput = {
  filter?: InputMaybe<IncentiveFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<IncentiveOrderByInput>
}

export type IncentiveOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type InvertersForProposalResponse = {
  __typename?: "InvertersForProposalResponse"
  brands: Array<Scalars["String"]["output"]>
  inverters: Array<NewEquipment>
}

export type License = {
  __typename?: "License"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  expiresAt: Scalars["DateTime"]["output"]
  externalId: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  identifier: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  userId: Scalars["String"]["output"]
}

export type LoanProduct = {
  __typename?: "LoanProduct"
  activatedAt: Maybe<Scalars["DateTime"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  escalator: Maybe<Scalars["Float"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  introPaymentFactor: Scalars["Float"]["output"]
  loanType: Scalars["String"]["output"]
  maximumLoanAmount: Maybe<Scalars["Float"]["output"]>
  minimumCreditScore: Maybe<Scalars["Float"]["output"]>
  minimumLoanAmount: Maybe<Scalars["Float"]["output"]>
  powurOsCurrentDealerFee: Scalars["Float"]["output"]
  powurOsCurrentPowurMargin: Scalars["Float"]["output"]
  powurOsDealerFeePlusMargin: Scalars["Float"]["output"]
  /** Unique ID for loan products as stored in OS's database */
  powurOsLoanId: Maybe<Scalars["Float"]["output"]>
  /** Unique ID for loan products as stored in OS's database */
  powurOsLoanProviderId: Maybe<Scalars["Float"]["output"]>
  productName: Scalars["String"]["output"]
  provider: LoanProvider | `${LoanProvider}`
  providerFee: Scalars["Float"]["output"]
  /** Unique id generated by loan provider */
  providerId: Scalars["String"]["output"]
  providerMeta: Maybe<Scalars["JSON"]["output"]>
  providerName: Maybe<Scalars["String"]["output"]>
  rate: Scalars["Float"]["output"]
  /** States that this loan product is active in */
  statesActive: Array<StateCode | `${StateCode}`>
  /** States that this loan product can be active in */
  statesPossible: Array<StateCode | `${StateCode}`>
  syncHistory: Maybe<Scalars["JSON"]["output"]>
  term: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type LoanProductFindManyWhereInput = {
  loanType?: InputMaybe<Scalars["String"]["input"]>
  provider?: InputMaybe<LoanProvider | `${LoanProvider}`>
  search?: InputMaybe<Scalars["String"]["input"]>
  state?: InputMaybe<StateCode | `${StateCode}`>
  status?: InputMaybe<Scalars["String"]["input"]>
}

export type LoanProductOptions = {
  __typename?: "LoanProductOptions"
  products: Array<LoanProduct>
  providers: Array<LoanProvider | `${LoanProvider}`>
}

export type LoanProductsInput = {
  filter?: InputMaybe<LoanProductFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<LoanProductsOrderByInput>
}

export type LoanProductsOrderByInput = {
  activatedAt?: InputMaybe<SortOrder | `${SortOrder}`>
  powurOsCurrentDealerFee?: InputMaybe<SortOrder | `${SortOrder}`>
  powurOsCurrentPowurMargin?: InputMaybe<SortOrder | `${SortOrder}`>
  powurOsDealerFeePlusMargin?: InputMaybe<SortOrder | `${SortOrder}`>
  productName?: InputMaybe<SortOrder | `${SortOrder}`>
  provider?: InputMaybe<SortOrder | `${SortOrder}`>
  providerName?: InputMaybe<SortOrder | `${SortOrder}`>
  rate?: InputMaybe<SortOrder | `${SortOrder}`>
  syncHistory?: InputMaybe<SortOrder | `${SortOrder}`>
  term?: InputMaybe<SortOrder | `${SortOrder}`>
}

export enum LoanProvider {
  concert = "concert",
  credit_human = "credit_human",
  enfin = "enfin",
  goodleap = "goodleap",
  lightreach = "lightreach",
  mosaic = "mosaic",
  sungage = "sungage",
  sunlight = "sunlight",
}

export type Logo = {
  __typename?: "Logo"
  bucket: Scalars["String"]["output"]
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  key: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type Manufacturer = {
  __typename?: "Manufacturer"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  powurOsId: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export enum MockAddressStateCode {
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  FL = "FL",
  MA = "MA",
  MD = "MD",
  NC = "NC",
  TX = "TX",
}

export type MoqProposalInput = {
  dynamicEquipmentTypeName?: InputMaybe<Scalars["String"]["input"]>
  financing?: InputMaybe<Scalars["String"]["input"]>
  latitude?: InputMaybe<Scalars["Float"]["input"]>
  longitude?: InputMaybe<Scalars["Float"]["input"]>
  manufacturer?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
  systemSize?: InputMaybe<Scalars["Float"]["input"]>
}

export type MosaicApplicationDto = {
  __typename?: "MosaicApplicationDto"
  id: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
}

export type MosaicCreateNewUserBodyDto = {
  email: Scalars["String"]["input"]
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  partnerIdentifier: Scalars["String"]["input"]
  phoneNumber: Scalars["String"]["input"]
  role: Scalars["String"]["input"]
  status: Scalars["String"]["input"]
}

export type MosaicDisclosuresArrayDto = {
  __typename?: "MosaicDisclosuresArrayDto"
  assetCode: Maybe<Scalars["String"]["output"]>
  assetType: Scalars["String"]["output"]
  contents: Array<MosaicDisclosuresContentArrayDto>
  scope: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
  version: Scalars["String"]["output"]
}

export type MosaicDisclosuresContentArrayDto = {
  __typename?: "MosaicDisclosuresContentArrayDto"
  contentType: Scalars["String"]["output"]
  data: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type MosaicGetApplicationResponseDto = {
  __typename?: "MosaicGetApplicationResponseDto"
  decision: Decision
  externalId: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  salesRepExternalIdentifier: Scalars["String"]["output"]
  salesRepIdentifier: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
}

export type MosaicGetDisclosuresBodyDto = {
  category: Scalars["String"]["input"]
  combined: Scalars["Boolean"]["input"]
  format: Scalars["String"]["input"]
  language: Scalars["String"]["input"]
  tag: Scalars["String"]["input"]
}

export type MosaicGetDisclosuresResponseDto = {
  __typename?: "MosaicGetDisclosuresResponseDto"
  bundleId: Scalars["String"]["output"]
  disclosures: Array<MosaicDisclosuresArrayDto>
}

export type MosaicGetLoginsResponseDto = {
  __typename?: "MosaicGetLoginsResponseDto"
  email: Scalars["String"]["output"]
  firstName: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  lastName: Scalars["String"]["output"]
  partnerIdentifier: Scalars["String"]["output"]
  role: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
}

export type MosaicGetUsersBodyDto = {
  after?: InputMaybe<Scalars["String"]["input"]>
  email?: InputMaybe<Scalars["String"]["input"]>
  limit?: InputMaybe<Scalars["String"]["input"]>
  partnerIdentifier?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<Scalars["String"]["input"]>
}

export type MosaicGetUsersResponseDto = {
  __typename?: "MosaicGetUsersResponseDto"
  links: Maybe<MosaicGetUsersResponseLinksDto>
  logins: Array<MosaicGetLoginsResponseDto>
}

export type MosaicGetUsersResponseLinksDto = {
  __typename?: "MosaicGetUsersResponseLinksDto"
  additionalResults: Maybe<Scalars["String"]["output"]>
}

export type MosaicPostApplicationResponseDto = {
  __typename?: "MosaicPostApplicationResponseDto"
  application: MosaicApplicationDto
}

export type Mutation = {
  __typename?: "Mutation"
  SubmitChangeOrder: SubmitChangeOrderResponse
  activateDesign: Design
  activateLoanProduct: LoanProduct
  /** activate or deactivate a utility company */
  activateUtilityCompany: UtilityCompany
  /** activate or deactivate a utility rate */
  activateUtilityRate: UtilityRate
  addNoteDesignRequest: DesignRequest
  cancelDesignRequest: DesignRequest
  cancelGoodleapLoan: Scalars["Boolean"]["output"]
  claimDesignRequest: DesignRequest
  claimNextDesignRequest: DesignRequest
  cloneProposal: Scalars["String"]["output"]
  completeClaimedDesignRequest: DesignRequest
  completeClaimedDesignRequestAndClaimNext: DesignRequest
  completeDesignRequest: DesignRequest
  completeDesignRequestAndClaimNext: DesignRequest
  /** create a custom incentive */
  createCustomIncentive: Incentive
  createDesignRequest: DesignRequest
  createEstimateOverrides: Scalars["String"]["output"]
  createLoanProduct: LoanProduct
  createServiceIntegration: ServiceIntegration
  createSite: Site
  /** created a new user */
  createUser: User
  deactivateApiKey: ServiceIntegration
  designRequestClaimedUntil: Scalars["DateTime"]["output"]
  duplicateDesignRequest: DesignRequest
  escalateDesignRequest: DesignRequest
  escalateDesignRequestAndClaimNext: DesignRequest
  fixOptimalEstimate: Scalars["Boolean"]["output"]
  generateApiKey: ServiceIntegration
  moqProposal: Proposal
  mosaicPostUser: MosaicGetUsersResponseDto
  pauseDesignRequest: DesignRequest
  prioritizeDesignRequest: DesignRequest
  refreshProposal: Scalars["Boolean"]["output"]
  /** Deletes and recreates the Site (and its Genability account) for a proposal */
  refreshProposalSite: Scalars["Boolean"]["output"]
  rejectDesignRequest: DesignRequest
  /** soft remove the site from database matching provided id */
  removeSite: Maybe<Scalars["Boolean"]["output"]>
  /** soft remove the user from database matching provided id */
  removeUser: Maybe<Scalars["Boolean"]["output"]>
  requestDesignRevision: Design
  resendContract: Contract
  /** reset a design to its original state */
  resetDesign: Design
  sendCreditApplication: SendCreditApplicationResponse
  sendLoanDocuments: ActiveLoan
  sendSupplementalContract: Contract
  /** Fetch invcentives from Genability and insert into db */
  syncIncentives: Scalars["String"]["output"]
  syncLoanProducts: SyncLoanOfferResponse
  updateDesign: Design
  updateImagePosition: ImageryResult
  /** update a custom incentive */
  updateIncentive: Incentive
  updateInverter: Design
  updateLoanProduct: LoanProduct
  updateModule: Design
  updateNonPrimaryEquipmentSelection: Design
  updateProposal: Proposal
  /** Update allowChangeOrderEquipment for a proposal */
  updateProposalAllowChangeOrderEquipment: BaseProposal
  updateServiceIntegration: ServiceIntegration
  updateSite: Site
  updateStatusDesignComplete: ProposalStatus
  updateStatusDesignFailed: ProposalStatus
  updateStatusDesignQueued: ProposalStatus
  updateStatusDesignRejected: ProposalStatus
  updateStatusDesignUnderway: ProposalStatus
  updateStatusProposalContractRequested: ProposalStatus
  updateStatusProposalCreated: ProposalStatus
  updateStatusProposalPublished: ProposalStatus
  updateStatusSummaryConfirmed: ProposalStatus
  updateStorage: Design
  /** Update total cost for a proposal by the given price per watt */
  updateTotalCostByPricePerWatt: BaseProposal
  /** update the given user with provided fields, returns a Not Found Error if the user does not exist */
  updateUser: User
}

export type MutationSubmitChangeOrderArgs = {
  id: Scalars["String"]["input"]
}

export type MutationActivateDesignArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationActivateLoanProductArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationActivateUtilityCompanyArgs = {
  utilityCompanyId: InputMaybe<Scalars["String"]["input"]>
}

export type MutationActivateUtilityRateArgs = {
  utilityRateId: InputMaybe<Scalars["String"]["input"]>
}

export type MutationAddNoteDesignRequestArgs = {
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}

export type MutationCancelDesignRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationCancelGoodleapLoanArgs = {
  loanProviderId: Scalars["String"]["input"]
}

export type MutationClaimDesignRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationCloneProposalArgs = {
  input: CloneProposalDtoInput
}

export type MutationCompleteDesignRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationCompleteDesignRequestAndClaimNextArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationCreateCustomIncentiveArgs = {
  createIncentiveInput: CreateCustomIncentiveInput
}

export type MutationCreateDesignRequestArgs = {
  initialMessage: InputMaybe<Scalars["String"]["input"]>
  proposalId: Scalars["ID"]["input"]
  requestType: InputMaybe<Scalars["String"]["input"]>
}

export type MutationCreateEstimateOverridesArgs = {
  input: CreateEstimateOverridesInput
}

export type MutationCreateLoanProductArgs = {
  CreateLoanProductInput: CreateLoanProductInput
}

export type MutationCreateServiceIntegrationArgs = {
  createServiceIntegrationInput: CreateServiceIntegrationInput
}

export type MutationCreateSiteArgs = {
  createSiteInput: CreateSiteInput
}

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput
}

export type MutationDeactivateApiKeyArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDesignRequestClaimedUntilArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationDuplicateDesignRequestArgs = {
  designRequestId: Scalars["ID"]["input"]
  message: InputMaybe<Scalars["String"]["input"]>
}

export type MutationEscalateDesignRequestArgs = {
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}

export type MutationEscalateDesignRequestAndClaimNextArgs = {
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}

export type MutationFixOptimalEstimateArgs = {
  proposalId: Scalars["String"]["input"]
}

export type MutationGenerateApiKeyArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationMoqProposalArgs = {
  input: MoqProposalInput
}

export type MutationMosaicPostUserArgs = {
  input: MosaicCreateNewUserBodyDto
}

export type MutationPauseDesignRequestArgs = {
  pauseDesignRequestInput: PauseDesignRequestInput
}

export type MutationPrioritizeDesignRequestArgs = {
  id: Scalars["ID"]["input"]
  priority: Scalars["Float"]["input"]
}

export type MutationRefreshProposalArgs = {
  id: Scalars["String"]["input"]
}

export type MutationRefreshProposalSiteArgs = {
  proposalId: Scalars["String"]["input"]
}

export type MutationRejectDesignRequestArgs = {
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}

export type MutationRemoveSiteArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationRemoveUserArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationRequestDesignRevisionArgs = {
  input: DesignRevisionInput
}

export type MutationResendContractArgs = {
  id: Scalars["String"]["input"]
}

export type MutationResetDesignArgs = {
  id: Scalars["ID"]["input"]
}

export type MutationSendCreditApplicationArgs = {
  input: SendCreditApplicationInput
}

export type MutationSendLoanDocumentsArgs = {
  activeLoanId: Scalars["ID"]["input"]
}

export type MutationSendSupplementalContractArgs = {
  id: Scalars["String"]["input"]
}

export type MutationUpdateDesignArgs = {
  input: UpdateDesignInput
}

export type MutationUpdateImagePositionArgs = {
  imageryId: Scalars["ID"]["input"]
  updateImageryPositionInput: UpdateImageryPositionInput
}

export type MutationUpdateIncentiveArgs = {
  updateIncentiveInput: UpdateIncentiveInput
}

export type MutationUpdateInverterArgs = {
  input: UpdateInverterInput
}

export type MutationUpdateLoanProductArgs = {
  UpdateLoanProductInput: UpdateLoanProductInput
}

export type MutationUpdateModuleArgs = {
  designId: Scalars["String"]["input"]
  equipmentId: Scalars["Int"]["input"]
}

export type MutationUpdateNonPrimaryEquipmentSelectionArgs = {
  designId: Scalars["String"]["input"]
  equipmentIds: Array<Scalars["Int"]["input"]>
}

export type MutationUpdateProposalArgs = {
  updateProposalInput: UpdateProposalInput
}

export type MutationUpdateProposalAllowChangeOrderEquipmentArgs = {
  allowChangeOrderEquipment: Scalars["Boolean"]["input"]
  proposalId: Scalars["String"]["input"]
}

export type MutationUpdateServiceIntegrationArgs = {
  updateServiceIntegrationInput: UpdateServiceIntegrationInput
}

export type MutationUpdateSiteArgs = {
  updateSiteInput: UpdateSiteInput
}

export type MutationUpdateStatusDesignCompleteArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusDesignFailedArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusDesignQueuedArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusDesignRejectedArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusDesignUnderwayArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusProposalContractRequestedArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusProposalCreatedArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStatusProposalPublishedArgs = {
  publishProposalInput: PublishProposalInput
}

export type MutationUpdateStatusSummaryConfirmedArgs = {
  data: CreateProposalStatusInput
}

export type MutationUpdateStorageArgs = {
  input: UpdateStorageInput
}

export type MutationUpdateTotalCostByPricePerWattArgs = {
  pricePerWatt: Scalars["Float"]["input"]
  proposalId: Scalars["String"]["input"]
}

export type MutationUpdateUserArgs = {
  id: Scalars["ID"]["input"]
  updateUserInput: UpdateUserInput
}

export type NewEquipment = {
  __typename?: "NewEquipment"
  batteryData: Maybe<Scalars["JSON"]["output"]>
  catalogNumber: Scalars["String"]["output"]
  currentProposalPrice: Scalars["Float"]["output"]
  description: Maybe<Scalars["String"]["output"]>
  energyBackupData: Maybe<Scalars["JSON"]["output"]>
  evChargerData: Maybe<Scalars["JSON"]["output"]>
  height: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  inverterData: Maybe<Scalars["JSON"]["output"]>
  isBattery: Scalars["Boolean"]["output"]
  isDefault: Scalars["Boolean"]["output"]
  isDomesticContent: Scalars["Boolean"]["output"]
  isKit: Scalars["Boolean"]["output"]
  manufacturer: Scalars["String"]["output"]
  manufacturerId: Scalars["Int"]["output"]
  manufacturerNumber: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  proposalName: Maybe<Scalars["String"]["output"]>
  type: Scalars["String"]["output"]
  typeId: Scalars["Int"]["output"]
  wattage: Scalars["Int"]["output"]
  width: Maybe<Scalars["Float"]["output"]>
}

/** Allowed equipment types */
export enum NewEquipmentType {
  COMPUTER = "COMPUTER",
  ENERGY_BACKUP = "ENERGY_BACKUP",
  EV_CHARGER = "EV_CHARGER",
  INVERTER = "INVERTER",
  MODULE = "MODULE",
  SMART_PANEL = "SMART_PANEL",
}

/** Goodleap Phone Type Type */
export enum Phone_Type {
  HOME = "HOME",
  MOBILE = "MOBILE",
}

/** Inputs used to make the request to PvWatts API */
export type PvWatts_Inputs = {
  __typename?: "PVWatts_Inputs"
  /**
   * Array type.
   *   Option	Description
   *   - 0	Fixed - Open Rack
   *   - 1	Fixed - Roof Mounted
   *   - 2	1-Axis
   *   - 3	1-Axis Backtracking
   *   - 4	2-Axis
   */
  array_type: Scalars["String"]["output"]
  /** Azimuth angle (degrees). */
  azimuth: Scalars["Float"]["output"]
  /** DC to AC ratio. */
  dc_ac_ratio: Maybe<Scalars["Float"]["output"]>
  /** Inverter efficiency. */
  inv_eff: Maybe<Scalars["Float"]["output"]>
  /** Latitude of the input location. (degrees) */
  lat: Scalars["Float"]["output"]
  /** Longitude of the input location. (degrees) */
  lon: Scalars["Float"]["output"]
  /** System losses (percent). */
  losses: Scalars["Float"]["output"]
  /**
   * Module type.
   *
   *   Option	Description
   *   - 0	Standard
   *   - 1	Premium
   *   - 2	Thin film
   */
  module_type: Scalars["String"]["output"]
  /** Nameplate capacity (kW). */
  system_capacity: Maybe<Scalars["Float"]["output"]>
  /** Tilt angle (degrees) */
  tilt: Maybe<Scalars["Float"]["output"]>
  /** Time frame */
  timeframe: Maybe<Scalars["String"]["output"]>
}

export type PaginationInput = {
  skip?: InputMaybe<Scalars["Float"]["input"]>
  take?: InputMaybe<Scalars["Float"]["input"]>
}

export type PauseDesignRequestInput = {
  id: Scalars["String"]["input"]
  /** link to the ticket */
  url: Scalars["String"]["input"]
}

export enum Permission {
  active_subscribers = "active_subscribers",
  admin = "admin",
  ambassador = "ambassador",
  api_key_admin = "api_key_admin",
  can_reset_design = "can_reset_design",
  can_view_enterprise_proposal_pricing_breakdown = "can_view_enterprise_proposal_pricing_breakdown",
  careers_administrator = "careers_administrator",
  commission_specialist = "commission_specialist",
  comped_subscribers = "comped_subscribers",
  consultants = "consultants",
  designer_user = "designer_user",
  energy = "energy",
  enterprise_admin = "enterprise_admin",
  enterprise_admin_pro = "enterprise_admin_pro",
  enterprise_comped = "enterprise_comped",
  enterprise_consultant = "enterprise_consultant",
  enterprise_manager = "enterprise_manager",
  enterprise_owner = "enterprise_owner",
  enterprise_owner_pro = "enterprise_owner_pro",
  enterprise_super_admin = "enterprise_super_admin",
  enterprise_support = "enterprise_support",
  equipment_admin = "equipment_admin",
  finance = "finance",
  financing_admin = "financing_admin",
  former_ambassador = "former_ambassador",
  guest = "guest",
  has_no_enterprise_margin_limit = "has_no_enterprise_margin_limit",
  homeowner = "homeowner",
  installer = "installer",
  inv = "inv",
  lead_generator = "lead_generator",
  licenses_administrator = "licenses_administrator",
  limited_demo = "limited_demo",
  marketing_staff = "marketing_staff",
  may_use_lower_enterprise_margin_limit = "may_use_lower_enterprise_margin_limit",
  mentorship_assignment = "mentorship_assignment",
  open_solar_designer = "open_solar_designer",
  ops_support = "ops_support",
  opsmanager = "opsmanager",
  org_mentor_access = "org_mentor_access",
  platform_admins = "platform_admins",
  platform_communications = "platform_communications",
  proposal_admin = "proposal_admin",
  proposal_creation = "proposal_creation",
  proposal_read = "proposal_read",
  sales_org = "sales_org",
  sales_pro = "sales_pro",
  sales_support = "sales_support",
  service_bureau_admin = "service_bureau_admin",
  service_bureau_user = "service_bureau_user",
  serviceareaupdater = "serviceareaupdater",
  tier_2_vision_designer = "tier_2_vision_designer",
  user_admin = "user_admin",
  vision_admin = "vision_admin",
  vision_api_key_admin = "vision_api_key_admin",
  vision_designer_user = "vision_designer_user",
  vision_developer = "vision_developer",
  vision_equipment_admin = "vision_equipment_admin",
  vision_financing_admin = "vision_financing_admin",
  vision_proposal_admin = "vision_proposal_admin",
  vision_service_bureau_admin = "vision_service_bureau_admin",
  vision_service_bureau_user = "vision_service_bureau_user",
  vision_user_admin = "vision_user_admin",
}

export type Phone = {
  __typename?: "Phone"
  type: Phone_Type | `${Phone_Type}`
  value: Scalars["String"]["output"]
}

export type PhoneInput = {
  type: Phone_Type | `${Phone_Type}`
  value: Scalars["String"]["input"]
}

export type PlatformCreateProposalDto = {
  __typename?: "PlatformCreateProposalDto"
  metadata: Maybe<Scalars["String"]["output"]>
  project: PowurProjectDto
  request_type: Maybe<Scalars["String"]["output"]>
}

export type PlatformCreateProposalDtoInput = {
  metadata?: InputMaybe<Scalars["String"]["input"]>
  project: PowurProjectDtoInput
  request_type?: InputMaybe<Scalars["String"]["input"]>
}

export type PlatformEnterpriseCobrandSettingsDto = {
  __typename?: "PlatformEnterpriseCobrandSettingsDto"
  brochure_slides: Array<BrochureSlidesObject>
  enterprise_id: Scalars["Float"]["output"]
}

export type PlatformEnterpriseCobrandSettingsDtoInput = {
  brochure_slides: Array<BrochureSlidesObjectDtoInput>
  enterprise_id: Scalars["Float"]["input"]
}

export type Poison = {
  __typename?: "Poison"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  data: Scalars["JSON"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  reason: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type PoisonedEstimate = {
  __typename?: "PoisonedEstimate"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  data: Scalars["JSON"]["output"]
  estimate: Maybe<Estimate>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  poisonIds: Scalars["String"]["output"]
  reason: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type PoisonedImagery = {
  __typename?: "PoisonedImagery"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  data: Scalars["JSON"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  imagery: Imagery
  reason: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type PoisonedQuote = {
  __typename?: "PoisonedQuote"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  data: Scalars["JSON"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  quote: Quote
  reason: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type PoisonedSavings = {
  __typename?: "PoisonedSavings"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  data: Scalars["JSON"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  reason: Scalars["String"]["output"]
  savings: Savings
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type PowerPurchaseRate = {
  __typename?: "PowerPurchaseRate"
  unit: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type PowurAddressDto = {
  __typename?: "PowurAddressDto"
  category: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  lat: Scalars["Float"]["output"]
  long: Scalars["Float"]["output"]
  postal: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  street: Scalars["String"]["output"]
}

export type PowurConstructionDetailsDto = {
  __typename?: "PowurConstructionDetailsDto"
  new_construction: Maybe<Scalars["Boolean"]["output"]>
  other: Array<Scalars["String"]["output"]>
  preference: Scalars["String"]["output"]
  secondary_system: Maybe<Scalars["Boolean"]["output"]>
}

export type PowurConstructionDetailsInput = {
  new_construction?: InputMaybe<Scalars["Boolean"]["input"]>
  other: Array<Scalars["String"]["input"]>
  preference: Scalars["String"]["input"]
  secondary_system?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type PowurEnterpriseDto = {
  __typename?: "PowurEnterpriseDto"
  cobrand_settings: Maybe<PlatformEnterpriseCobrandSettingsDto>
  commission_visibility: Maybe<Scalars["Boolean"]["output"]>
  comp_type: Maybe<Scalars["String"]["output"]>
  ent_baseline_ppw: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Float"]["output"]
  logo: Maybe<EnterpriseLogoDto>
  margin_settings: Maybe<EnterpriseMarginSettingsDto>
  margin_visibility: Maybe<Scalars["Boolean"]["output"]>
  name: Scalars["String"]["output"]
  org_holdback_ppw: Maybe<Scalars["Float"]["output"]>
  owner: PutUserDto
  seller_powurline_ppw: Maybe<Scalars["Float"]["output"]>
  should_cobrand: Maybe<Scalars["Boolean"]["output"]>
}

export type PowurEnterpriseDtoInput = {
  cobrand_settings?: InputMaybe<PlatformEnterpriseCobrandSettingsDtoInput>
  commission_visibility?: InputMaybe<Scalars["Boolean"]["input"]>
  comp_type?: InputMaybe<Scalars["String"]["input"]>
  ent_baseline_ppw?: InputMaybe<Scalars["Float"]["input"]>
  id: Scalars["Float"]["input"]
  logo?: InputMaybe<EnterpriseLogoDtoInput>
  margin_settings?: InputMaybe<PowurEnterpriseMarginSettingsDtoInput>
  margin_visibility?: InputMaybe<Scalars["Boolean"]["input"]>
  name: Scalars["String"]["input"]
  org_holdback_ppw?: InputMaybe<Scalars["Float"]["input"]>
  owner: PutUserDtoInput
  seller_powurline_ppw?: InputMaybe<Scalars["Float"]["input"]>
  should_cobrand?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type PowurEnterpriseMarginSettingsDtoInput = {
  manager_margin_adjustment: Scalars["Boolean"]["input"]
  manager_minimum_margin: Scalars["Float"]["input"]
  margin_fixed: Scalars["Boolean"]["input"]
  proposal_margin: Scalars["Float"]["input"]
}

export type PowurExistingSystemDto = {
  __typename?: "PowurExistingSystemDto"
  ownership: Maybe<Scalars["String"]["output"]>
}

export type PowurExistingSystemInput = {
  ownership?: InputMaybe<Scalars["String"]["input"]>
}

export type PowurHoaDto = {
  __typename?: "PowurHoaDto"
  name: Scalars["String"]["output"]
  phone: Scalars["String"]["output"]
}

export type PowurHoaInput = {
  name: Scalars["String"]["input"]
  phone: Scalars["String"]["input"]
}

export type PowurImageSizeDto = {
  __typename?: "PowurImageSizeDto"
  large: Maybe<Scalars["String"]["output"]>
  original: Maybe<Scalars["String"]["output"]>
  preview: Maybe<Scalars["String"]["output"]>
  retina: Maybe<Scalars["String"]["output"]>
  thumb: Maybe<Scalars["String"]["output"]>
}

export type PowurImageSizeDtoInput = {
  large?: InputMaybe<Scalars["String"]["input"]>
  original?: InputMaybe<Scalars["String"]["input"]>
  preview?: InputMaybe<Scalars["String"]["input"]>
  retina?: InputMaybe<Scalars["String"]["input"]>
  thumb?: InputMaybe<Scalars["String"]["input"]>
}

export type PowurOsManufacturer = {
  __typename?: "PowurOsManufacturer"
  createdById: Maybe<Scalars["String"]["output"]>
  createdDateTime: Scalars["String"]["output"]
  deletedById: Scalars["String"]["output"]
  deletedDateTime: Scalars["String"]["output"]
  id: Maybe<Scalars["Float"]["output"]>
  manufacturerLenderAliases: Array<PowurOsManufacturerLenderAlias>
  modifiedById: Scalars["String"]["output"]
  modifiedDateTime: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type PowurOsManufacturerLenderAlias = {
  __typename?: "PowurOsManufacturerLenderAlias"
  deletedDateTime: Scalars["String"]["output"]
  id: Scalars["Float"]["output"]
  lenderIdentifier: Scalars["String"]["output"]
  lenderManufacturerName: Scalars["String"]["output"]
  loanProviderOwnerId: Scalars["Float"]["output"]
  manufacturerId: Scalars["Float"]["output"]
}

export type PowurOsRecommendedEquipment = {
  __typename?: "PowurOsRecommendedEquipment"
  equipmentId: Scalars["Int"]["output"]
  qty: Scalars["Int"]["output"]
}

export type PowurOsWarrantyPricing = {
  __typename?: "PowurOsWarrantyPricing"
  cost: Scalars["Float"]["output"]
  eligible: Scalars["Boolean"]["output"]
  family: Scalars["String"]["output"]
  id: Scalars["Float"]["output"]
  localizedName: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type PowurProfileImgDto = {
  __typename?: "PowurProfileImgDto"
  bucket: Maybe<Scalars["String"]["output"]>
  sizes: Maybe<PowurImageSizeDto>
}

export type PowurProfileImgDtoInput = {
  bucket?: InputMaybe<Scalars["String"]["input"]>
  sizes?: InputMaybe<PowurImageSizeDtoInput>
}

export type PowurProjectDto = {
  __typename?: "PowurProjectDto"
  enterprise: PowurEnterpriseDto
  project_info: PowurProjectInfoDto
  proposal_settings: ProposalSettingsDto
  seller: PowurUserDto
  site_info: PowurSiteInfoDto
  utility_bill_info: PowurUtilityBillInfoDto
}

export type PowurProjectDtoInput = {
  enterprise: PowurEnterpriseDtoInput
  project_info: PowurProjectInfoInput
  proposal_settings: ProposalSettingsDtoInput
  seller: PowurUserDtoInput
  site_info: PowurSiteInfoInput
  utility_bill_info: PowurUtilityBillInfoInput
}

export type PowurProjectInfoDto = {
  __typename?: "PowurProjectInfoDto"
  address: PowurAddressDto
  email: Scalars["String"]["output"]
  first_name: Scalars["String"]["output"]
  id: Scalars["Float"]["output"]
  last_name: Scalars["String"]["output"]
  lead_source: Maybe<Scalars["String"]["output"]>
  phone: Scalars["String"]["output"]
}

export type PowurProjectInfoInput = {
  address: DisplayAddressInput
  email: Scalars["String"]["input"]
  first_name: Scalars["String"]["input"]
  id: Scalars["Float"]["input"]
  last_name: Scalars["String"]["input"]
  lead_source?: InputMaybe<Scalars["String"]["input"]>
  phone: Scalars["String"]["input"]
}

export type PowurProjectV2Dto = {
  __typename?: "PowurProjectV2Dto"
  enterprise: PowurEnterpriseDto
  project_info: PowurProjectInfoDto
  proposal_settings: ProposalSettingsDto
  seller: PowurUserDto
  site_info: PowurSiteInfoDto
  utility_bill_info: PowurUtilityBillInfoDto
}

export type PowurProjectV2DtoInput = {
  enterprise: PowurEnterpriseDtoInput
  project_info: PowurProjectInfoInput
  proposal_settings: ProposalSettingsDtoInput
  seller: PowurUserDtoInput
  site_info: PowurSiteInfoInput
  utility_bill_info: PowurUtilityBillInfoInput
}

export type PowurRoofDto = {
  __typename?: "PowurRoofDto"
  age: Scalars["String"]["output"]
  main_service_panel: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type PowurRoofDtoInput = {
  age: Scalars["String"]["input"]
  main_service_panel: Scalars["String"]["input"]
  type: Scalars["String"]["input"]
}

export type PowurSiteInfoDto = {
  __typename?: "PowurSiteInfoDto"
  construction_details: PowurConstructionDetailsDto
  existing_system: Maybe<PowurExistingSystemDto>
  financing: Scalars["String"]["output"]
  hoa: PowurHoaDto
  installer: Scalars["String"]["output"]
  project_notes: Scalars["String"]["output"]
  proposal_notes: Scalars["String"]["output"]
  roof: PowurRoofDto
}

export type PowurSiteInfoInput = {
  construction_details: PowurConstructionDetailsInput
  existing_system?: InputMaybe<PowurExistingSystemInput>
  financing: Scalars["String"]["input"]
  hoa: PowurHoaInput
  installer: Scalars["String"]["input"]
  project_notes: Scalars["String"]["input"]
  proposal_notes: Scalars["String"]["input"]
  roof: PowurRoofDtoInput
}

export type PowurUserDto = {
  __typename?: "PowurUserDto"
  bio: Maybe<Scalars["String"]["output"]>
  email: Scalars["String"]["output"]
  enterprise_id: Maybe<Scalars["Float"]["output"]>
  first_name: Scalars["String"]["output"]
  id: Scalars["Float"]["output"]
  last_name: Scalars["String"]["output"]
  mentor: Maybe<PowurUserDto>
  phone: Maybe<Scalars["String"]["output"]>
  profile_img: Maybe<PowurProfileImgDto>
}

export type PowurUserDtoInput = {
  bio?: InputMaybe<Scalars["String"]["input"]>
  email: Scalars["String"]["input"]
  enterprise_id?: InputMaybe<Scalars["Float"]["input"]>
  first_name: Scalars["String"]["input"]
  id: Scalars["Float"]["input"]
  last_name: Scalars["String"]["input"]
  mentor?: InputMaybe<PowurUserDtoInput>
  phone?: InputMaybe<Scalars["String"]["input"]>
  profile_img?: InputMaybe<PowurProfileImgDtoInput>
}

export type PowurUtilityBillInfoDto = {
  __typename?: "PowurUtilityBillInfoDto"
  annual_consumption_kwh: Maybe<Scalars["Float"]["output"]>
  avg_monthly_bill: Maybe<Scalars["Float"]["output"]>
  company: Scalars["String"]["output"]
  url: Maybe<Scalars["String"]["output"]>
}

export type PowurUtilityBillInfoInput = {
  annual_consumption_kwh?: InputMaybe<Scalars["Float"]["input"]>
  avg_monthly_bill?: InputMaybe<Scalars["Float"]["input"]>
  company: Scalars["String"]["input"]
  url?: InputMaybe<Scalars["String"]["input"]>
}

export type PricePerUnit = {
  __typename?: "PricePerUnit"
  currency: Scalars["String"]["output"]
  price: Scalars["Float"]["output"]
  unit: Scalars["String"]["output"]
}

export type PriceUnit = {
  __typename?: "PriceUnit"
  type: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type PricedEquipment = {
  __typename?: "PricedEquipment"
  basicAdderAssociations: Array<BasicAdderAssociation>
  catalogNumber: Maybe<Scalars["String"]["output"]>
  cecWeightedEfficiency: Scalars["Float"]["output"]
  childEquipmentAssociations: Scalars["JSON"]["output"]
  compatibleInverterManufacturers: Array<CompatibleManufacturer>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  currentProposalPrice: Scalars["Float"]["output"]
  deprecated_id: Maybe<Scalars["String"]["output"]>
  description: Maybe<Scalars["String"]["output"]>
  energyBackupData: Maybe<Scalars["JSON"]["output"]>
  equipmentType: EquipmentType
  equipmentTypeId: Scalars["String"]["output"]
  fallbackPrice: Maybe<Scalars["Float"]["output"]>
  height: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  inverterData: Maybe<Scalars["JSON"]["output"]>
  isDefault: Scalars["Boolean"]["output"]
  isKit: Scalars["Boolean"]["output"]
  manufacturer: Manufacturer
  manufacturerId: Scalars["String"]["output"]
  moduleData: Maybe<Scalars["JSON"]["output"]>
  name: Scalars["String"]["output"]
  parentEquipmentAssociations: Scalars["JSON"]["output"]
  powurOsEnergyBackupDataId: Maybe<Scalars["Float"]["output"]>
  powurOsEquipmentTypeId: Scalars["Float"]["output"]
  powurOsInverterDataId: Maybe<Scalars["Float"]["output"]>
  powurOsManufacturerId: Scalars["Float"]["output"]
  powurOsModuleDataId: Maybe<Scalars["Float"]["output"]>
  proposalPrices: Array<Scalars["JSON"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  warranty: Maybe<Scalars["JSON"]["output"]>
  wattage: Maybe<Scalars["Float"]["output"]>
  width: Maybe<Scalars["Float"]["output"]>
}

export type PricingResponseAdder = {
  __typename?: "PricingResponseAdder"
  adderId: Scalars["Int"]["output"]
  lineType: Scalars["Int"]["output"]
  parentEquipmentId: Maybe<Scalars["Int"]["output"]>
  qty: Scalars["Int"]["output"]
  title: Scalars["String"]["output"]
  totalPrice: Scalars["Float"]["output"]
  unitPrice: Scalars["Float"]["output"]
}

export type PricingResponseEquipment = {
  __typename?: "PricingResponseEquipment"
  categoryId: Scalars["Int"]["output"]
  deletedDateTime: Maybe<Scalars["String"]["output"]>
  equipmentId: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  parentEquipmentId: Maybe<Scalars["Int"]["output"]>
  qty: Scalars["Int"]["output"]
  totalPrice: Scalars["Float"]["output"]
}

export type PricingResponseFee = {
  __typename?: "PricingResponseFee"
  cost: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
}

export type PricingResponseModel = {
  __typename?: "PricingResponseModel"
  adders: Array<PricingResponseAdder>
  cashPrice: Scalars["Float"]["output"]
  dealerFee: Scalars["Float"]["output"]
  dealerFeeRate: Scalars["Float"]["output"]
  downPayment: Scalars["Float"]["output"]
  equipment: Array<PricingResponseEquipment>
  fees: Array<PricingResponseFee>
  financedAmount: Scalars["Float"]["output"]
  fundingType: Scalars["String"]["output"]
  generalExciseTax: Scalars["Float"]["output"]
  generalExciseTaxRate: Scalars["Float"]["output"]
  newCustomerIncentive: Scalars["Float"]["output"]
  powurLenderMarginFee: Scalars["Float"]["output"]
  rebates: Array<PricingResponseRebate>
  salesTax: Scalars["Float"]["output"]
  sellerMarginRate: Scalars["Float"]["output"]
  sellerProjectMargin: Scalars["Float"]["output"]
  systemSize: Scalars["Float"]["output"]
  totalContractPrice: Scalars["Float"]["output"]
  totalDealerFee: Scalars["Float"]["output"]
  warranty: Scalars["Float"]["output"]
}

export type PricingResponseRebate = {
  __typename?: "PricingResponseRebate"
  cost: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
}

export type ProductionRate = {
  __typename?: "ProductionRate"
  type: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type ProfileImg = {
  __typename?: "ProfileImg"
  bucket: Maybe<Scalars["String"]["output"]>
  sizes: Maybe<ImageSizes>
}

export type ProjectBodyResponse = {
  __typename?: "ProjectBodyResponse"
  amountDrawn: Scalars["Float"]["output"]
  amountRemaining: Scalars["Float"]["output"]
  applicants: Array<ApplicantBodyResponse>
  approvedForPayments: Scalars["Boolean"]["output"]
  apr: Scalars["Float"]["output"]
  blockDraw: Scalars["Boolean"]["output"]
  drawAutoApproved: Scalars["Boolean"]["output"]
  drawCount: Scalars["Float"]["output"]
  drawExpired: Scalars["Boolean"]["output"]
  externalId: Scalars["String"]["output"]
  hashId: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  installCity: Scalars["String"]["output"]
  installStateName: Scalars["String"]["output"]
  installStreet: Scalars["String"]["output"]
  installZipCode: Scalars["Float"]["output"]
  installerEnglishOnly: Scalars["Boolean"]["output"]
  installerId: Maybe<Scalars["String"]["output"]>
  installerName: Maybe<Scalars["String"]["output"]>
  isACH: Scalars["Boolean"]["output"]
  isCreditAuthorized: Scalars["Boolean"]["output"]
  itcCutoff: Scalars["String"]["output"]
  language: Scalars["String"]["output"]
  lender: Scalars["String"]["output"]
  maxAvailable: Scalars["Float"]["output"]
  nonACHApr: Scalars["Float"]["output"]
  ownerEmail: Scalars["String"]["output"]
  ownerName: Scalars["String"]["output"]
  productType: Scalars["String"]["output"]
  projectCategory: Scalars["String"]["output"]
  projectStatus: Maybe<Scalars["String"]["output"]>
  quotes: Array<QuoteBodyResponse>
  requestedLoanAmount: Scalars["Float"]["output"]
  showTranslationServices: Scalars["Boolean"]["output"]
  slfProductMinLoanAmount: Scalars["Float"]["output"]
  stage: Scalars["String"]["output"]
  statusText: Scalars["String"]["output"]
  stips: Maybe<Array<StipsBodyResponse>>
  systemDesigns: Array<SystemDesignBodyResponse>
  term: Scalars["Float"]["output"]
}

export type ProjectHomeowner = {
  __typename?: "ProjectHomeowner"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  email: Scalars["String"]["output"]
  firstName: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  lastName: Scalars["String"]["output"]
  phone: Maybe<Scalars["String"]["output"]>
  powurProjectId: Scalars["Int"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type PropertyKey = {
  __typename?: "PropertyKey"
  /** For properties of type CHOICE or LOOKUP, this contains the possible choices to choose from. */
  choices: Maybe<Array<Choice>>
  /** The data type of this property. Possible values are STRING, CHOICE, BOOLEAN, DATE, DECIMAL, INTEGER, FORMULA, LOOKUP (see Lookup API), or DEMAND. */
  dataType: Maybe<Scalars["String"]["output"]>
  /** A user-friendly detailed description of the purpose of this property. */
  description: Maybe<Scalars["String"]["output"]>
  /** A string that can be used to display to users. */
  displayName: Maybe<Scalars["String"]["output"]>
  /** The ID of the entity this property key belongs to. For example, for an LSE-specific property, this will be the LSE ID. For general properties, this will be null. */
  entityId: Maybe<Scalars["Float"]["output"]>
  /** The type of entity this property key belongs to. For example, for an LSE-specific property, this will be "LSE". For general properties, this will be null. */
  entityType: Maybe<Scalars["String"]["output"]>
  /** Second level of the categorization hierarchy, family groups keyNames together into logical areas, such as "billing", "generation", "load", "peakDemand", and "ratchetDemand". */
  family: Maybe<Scalars["String"]["output"]>
  /** For properties that specify a formula, this is the actual formula used. */
  formulaDetail: Maybe<Scalars["String"]["output"]>
  /** The unique name for this property. */
  keyName: Maybe<Scalars["String"]["output"]>
  /** The top level of the categorization hierarchy, keyspace defines major groups of keyNames, such as "customer", "electricity", "market", “tariff”, and "solarPV". */
  keyspace: Maybe<Scalars["String"]["output"]>
  /** For properties of type DEMAND, this specifies the size of the interval in minutes. */
  lookbackIntervalQuantity: Maybe<Scalars["Float"]["output"]>
  /** For properties of type DEMAND, this specifies the duration of a single lookback period. */
  lookbackPeriod: Maybe<Scalars["String"]["output"]>
  /** For properties of type DEMAND, this specifies the number of lookback periods. */
  lookbackQuantity: Maybe<Scalars["Float"]["output"]>
  /** For properties of type DEMAND, this specifies the applicable seasonId. */
  lookbackSeasonId: Maybe<Scalars["Float"]["output"]>
  /** For properties of type DEMAND, this specifies the applicable timeOfUseId. */
  lookbackTimeOfUseId: Maybe<Scalars["Float"]["output"]>
  /** The unit that applies to this property. e.g. "kWh", "Inches", "HP" */
  quantityUnit: Maybe<Scalars["String"]["output"]>
  /** Sub-property name for this property. */
  subKeyName: Maybe<Scalars["String"]["output"]>
}

export type PropertyKeyInput = {
  /** For properties of type CHOICE or LOOKUP, this contains the possible choices to choose from. */
  choices?: InputMaybe<Array<ChoiceInput>>
  /** The data type of this property. Possible values are STRING, CHOICE, BOOLEAN, DATE, DECIMAL, INTEGER, FORMULA, LOOKUP (see Lookup API), or DEMAND. */
  dataType?: InputMaybe<Scalars["String"]["input"]>
  /** A user-friendly detailed description of the purpose of this property. */
  description?: InputMaybe<Scalars["String"]["input"]>
  /** A string that can be used to display to users. */
  displayName?: InputMaybe<Scalars["String"]["input"]>
  /** The ID of the entity this property key belongs to. For example, for an LSE-specific property, this will be the LSE ID. For general properties, this will be null. */
  entityId?: InputMaybe<Scalars["Float"]["input"]>
  /** The type of entity this property key belongs to. For example, for an LSE-specific property, this will be "LSE". For general properties, this will be null. */
  entityType?: InputMaybe<Scalars["String"]["input"]>
  /** Second level of the categorization hierarchy, family groups keyNames together into logical areas, such as "billing", "generation", "load", "peakDemand", and "ratchetDemand". */
  family?: InputMaybe<Scalars["String"]["input"]>
  /** For properties that specify a formula, this is the actual formula used. */
  formulaDetail?: InputMaybe<Scalars["String"]["input"]>
  /** The unique name for this property. */
  keyName?: InputMaybe<Scalars["String"]["input"]>
  /** The top level of the categorization hierarchy, keyspace defines major groups of keyNames, such as "customer", "electricity", "market", “tariff”, and "solarPV". */
  keyspace?: InputMaybe<Scalars["String"]["input"]>
  /** For properties of type DEMAND, this specifies the size of the interval in minutes. */
  lookbackIntervalQuantity?: InputMaybe<Scalars["Float"]["input"]>
  /** For properties of type DEMAND, this specifies the duration of a single lookback period. */
  lookbackPeriod?: InputMaybe<Scalars["String"]["input"]>
  /** For properties of type DEMAND, this specifies the number of lookback periods. */
  lookbackQuantity?: InputMaybe<Scalars["Float"]["input"]>
  /** For properties of type DEMAND, this specifies the applicable seasonId. */
  lookbackSeasonId?: InputMaybe<Scalars["Float"]["input"]>
  /** For properties of type DEMAND, this specifies the applicable timeOfUseId. */
  lookbackTimeOfUseId?: InputMaybe<Scalars["Float"]["input"]>
  /** The unit that applies to this property. e.g. "kWh", "Inches", "HP" */
  quantityUnit?: InputMaybe<Scalars["String"]["input"]>
  /** Sub-property name for this property. */
  subKeyName?: InputMaybe<Scalars["String"]["input"]>
}

export type Proposal = {
  __typename?: "Proposal"
  activeLoans: Maybe<Array<ActiveLoan>>
  allowChangeOrderEquipment: Scalars["Boolean"]["output"]
  /** approximate annual energy use in kwh */
  annualEnergyUse: Maybe<Scalars["Float"]["output"]>
  /** average monthly utility bill */
  avgMonthlyBill: Maybe<Scalars["Float"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  currentStatus: Maybe<Scalars["String"]["output"]>
  designs: Array<Design>
  displayAddress: DisplayAddress
  displayAddressId: Scalars["String"]["output"]
  downPayment: Maybe<Scalars["Float"]["output"]>
  enterprise: Maybe<Enterprise>
  enterpriseId: Maybe<Scalars["String"]["output"]>
  enterpriseLogoUrl: Maybe<Scalars["String"]["output"]>
  enterpriseSettings: Maybe<EnterpriseSettings>
  /** Selected finance id */
  financeProductId: Maybe<Scalars["String"]["output"]>
  /** Type of financing selected */
  financeType: Maybe<Scalars["String"]["output"]>
  /** The funding group corresponding to the funding type selected */
  fundingGroup: Maybe<Scalars["String"]["output"]>
  /** genability default contracted rate if no adjusted rate is provided */
  genabilityDefaultContractedRate: Maybe<Scalars["Float"]["output"]>
  /** fixed genability usage */
  genabilityUsageEstimate: Maybe<GenabilityCalculatedCost>
  homeowner: ProjectHomeowner
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  incentives: Maybe<Array<ProposalIncentive>>
  /** The lead source of the homeowner */
  leadSource: Maybe<Scalars["String"]["output"]>
  margin: Scalars["Float"]["output"]
  mentor: Maybe<User>
  mentorId: Maybe<Scalars["String"]["output"]>
  metadata: Scalars["String"]["output"]
  /** historic energy cost in $ */
  monthlyEnergyCost: Array<Scalars["Float"]["output"]>
  /** flag indicating if monthly entry was manually entered */
  monthlyEnergyManualFlags: Array<Scalars["Boolean"]["output"]>
  /** historic energy usage kWh */
  monthlyEnergyUse: Array<Scalars["Float"]["output"]>
  /** Proposal name */
  name: Maybe<Scalars["String"]["output"]>
  /** whether this proposal is for new construction */
  newConstruction: Scalars["Boolean"]["output"]
  newCustomerIncentive: Scalars["Boolean"]["output"]
  /** Post-solar-install utility rate for the proposal */
  postSolarUtilityRate: Maybe<UtilityRate>
  postSolarUtilityRateId: Scalars["String"]["output"]
  powurProjectId: Scalars["Float"]["output"]
  preferredLanguage: Scalars["String"]["output"]
  primaryPresenter: Maybe<Scalars["Float"]["output"]>
  /** Project adders */
  proposalAdders: Array<ProposalAdderObject>
  proposalCost: ProposalCost
  proposalStatuses: Maybe<Array<ProposalStatus>>
  quote: Maybe<QuoteResult>
  quotes: Maybe<Array<QuoteResult>>
  requestType: Scalars["String"]["output"]
  requiresRefresh: Scalars["Boolean"]["output"]
  secondaryPresenter: Maybe<Scalars["Float"]["output"]>
  /** whether this proposal is for a secondary system */
  secondarySystem: Scalars["Boolean"]["output"]
  selectedLoanProduct: Maybe<LoanProduct>
  selectedLoanProductId: Maybe<Scalars["String"]["output"]>
  /** Consultant for the proposal, has limited edit access */
  seller: User
  sellerId: Scalars["String"]["output"]
  shortLink: Maybe<ShortLink>
  /** Site for which the proposal is being prepared */
  site: Site
  siteId: Scalars["String"]["output"]
  /** Short unique identifier for the proposal */
  slug: Scalars["String"]["output"]
  /** Stored Smart Estimates banner text */
  smartEstimateBanner: Maybe<Scalars["String"]["output"]>
  /** system type (roof mount, ground mount, or both) */
  systemType: Maybe<SystemType | `${SystemType}`>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  usageProfile: Maybe<GenabilityProfile>
  usageProfileId: Maybe<Scalars["String"]["output"]>
  userAdjustedAfterSolarContractedRate: Maybe<Scalars["Float"]["output"]>
  userAdjustedBeforeSolarContractedRate: Maybe<Scalars["Float"]["output"]>
  userAdjustedUtilityRate: Maybe<Scalars["Float"]["output"]>
  /** Utility rate plan for the proposal */
  utilityRate: Maybe<UtilityRate>
  /** utility rate escalation percentage */
  utilityRateEscalationPercentage: Scalars["Float"]["output"]
  utilityRateId: Scalars["String"]["output"]
}

export type ProposalAdderObject = {
  __typename?: "ProposalAdderObject"
  adder: Adder
  cost: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customPrice: Maybe<Scalars["Float"]["output"]>
  customQuantity: Maybe<Scalars["Float"]["output"]>
  end: Maybe<Scalars["DateTime"]["output"]>
  isRequired: Scalars["Boolean"]["output"]
  isVariable: Scalars["Boolean"]["output"]
  powurOsAdderId: Scalars["Float"]["output"]
  proposalId: Scalars["String"]["output"]
  /** Whether or not the adder is included in cost calculations */
  selected: Scalars["Boolean"]["output"]
  start: Maybe<Scalars["DateTime"]["output"]>
  updatedAt: Scalars["DateTime"]["output"]
}

export type ProposalCost = {
  __typename?: "ProposalCost"
  batteryCost: Scalars["Float"]["output"]
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  designCost: Scalars["Float"]["output"]
  exciseTax: Scalars["Float"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  lineItems: Array<ProposalLineItem>
  proposalId: Scalars["String"]["output"]
  salesTax: Scalars["Float"]["output"]
  totalCost: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type ProposalIncentive = {
  __typename?: "ProposalIncentive"
  applyToLoan: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  incentive: Incentive
  incentiveId: Scalars["String"]["output"]
  proposalId: Scalars["String"]["output"]
  showOnBrochure: Scalars["Boolean"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
  value: Scalars["Float"]["output"]
}

export type ProposalLineItem = {
  __typename?: "ProposalLineItem"
  children: Array<ProposalLineItem>
  cost: Scalars["Float"]["output"]
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  displayName: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  powurOsId: Maybe<Scalars["Float"]["output"]>
  quantity: Scalars["Float"]["output"]
  subType: Maybe<Scalars["String"]["output"]>
  taxable: Scalars["Boolean"]["output"]
  type: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type ProposalSettingsDto = {
  __typename?: "ProposalSettingsDto"
  primary_seller: Maybe<Scalars["Float"]["output"]>
  secondary_seller: Maybe<Scalars["Float"]["output"]>
}

export type ProposalSettingsDtoInput = {
  primary_seller?: InputMaybe<Scalars["Float"]["input"]>
  secondary_seller?: InputMaybe<Scalars["Float"]["input"]>
}

export type ProposalStatus = {
  __typename?: "ProposalStatus"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** Status message */
  message: Scalars["String"]["output"]
  /** Proposal ID */
  proposalId: Scalars["String"]["output"]
  /** Proposal status type */
  status: ProposalStatusType | `${ProposalStatusType}`
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  /** Proposal updated by */
  updatedBy: Scalars["String"]["output"]
}

export enum ProposalStatusType {
  contract_requested = "contract_requested",
  contract_sent = "contract_sent",
  contract_signed = "contract_signed",
  design_complete = "design_complete",
  design_failed = "design_failed",
  design_queued = "design_queued",
  design_rejected = "design_rejected",
  design_underway = "design_underway",
  proposal_created = "proposal_created",
  proposal_published = "proposal_published",
  summary_confirmed = "summary_confirmed",
}

export type ProposalsFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]["input"]>
}

export type ProposalsInput = {
  filter?: InputMaybe<ProposalsFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<ProposalsOrderByInput>
}

export type ProposalsOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type PublishProposalInput = {
  message: Scalars["String"]["input"]
  proposalId: Scalars["String"]["input"]
}

export type PurchasePrice = {
  __typename?: "PurchasePrice"
  type: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type PutUserDto = {
  __typename?: "PutUserDto"
  bio: Maybe<Scalars["String"]["output"]>
  email: Scalars["String"]["output"]
  enterprise_id: Maybe<Scalars["Float"]["output"]>
  first_name: Scalars["String"]["output"]
  id: Scalars["Float"]["output"]
  last_name: Scalars["String"]["output"]
  phone: Maybe<Scalars["String"]["output"]>
  profile_img: Maybe<PowurProfileImgDto>
}

export type PutUserDtoInput = {
  bio?: InputMaybe<Scalars["String"]["input"]>
  email: Scalars["String"]["input"]
  enterprise_id?: InputMaybe<Scalars["Float"]["input"]>
  first_name: Scalars["String"]["input"]
  id: Scalars["Float"]["input"]
  last_name: Scalars["String"]["input"]
  phone?: InputMaybe<Scalars["String"]["input"]>
  profile_img?: InputMaybe<PowurProfileImgDtoInput>
}

export type Query = {
  __typename?: "Query"
  baseEquipmentForProposal: BaseEquipmentObject
  contract: Contract
  contractVersionHistoryForProposal: Array<ContractVersionHistory>
  contractsForProposal: Array<Contract>
  design: Design
  designHasSunroof: Scalars["Boolean"]["output"]
  designRequest: DesignRequest
  designerDataByRequestId: DesignRequest
  designs: Array<Design>
  equipmentForProposal: Array<NewEquipment>
  estimate: EstimateResult
  estimatesForDesign: Array<EstimateResult>
  /** finds all loan products */
  findAllLoanProducts: Array<LoanProduct>
  findDisclosuresForLoanProduct: GetDisclosuresByLoanProductIdResponse
  findLoanProductById: LoanProduct
  findLoanProductsForProposal: LoanProductOptions
  findPossibleTpoLoanProductTypesForProposal: Array<Scalars["String"]["output"]>
  getActiveLoanStatus: Scalars["String"]["output"]
  /** Get the brochure data for a proposal */
  getBrochure: Maybe<Brochure>
  /** Get contract signed DTO for a proposal */
  getContractSignedDTO: Maybe<VisionContractSigned>
  getCronJobActiveStatus: Scalars["Boolean"]["output"]
  getDevProposalData: DevCreateProposalDtoNew
  getEnfinApplicationDetails: EnfinApplicationDetails
  getEnfinFrame: Scalars["String"]["output"]
  getGoodLeapDisclosures: GoodLeapGetDisclosuresResponseDto
  getGoodleapLoanDetails: GoodleapLoanDetails
  getGoodleapStipulations: Array<GoodleapStipulationDetailed>
  getInProgressDesign: Design
  getIncentivesByProposalId: Array<ProposalIncentive>
  getMockAddress: PowurAddressDto
  getProposalStatusEvents: Array<ProposalStatus>
  getQueue: Array<DesignRequest>
  getQueueCount: DesignRequestCount
  getQuotesForProposal: Array<QuoteResult>
  getSelectIncentivesModal: GetSelectIncentivesModal
  getShortLink: Maybe<ShortLink>
  getSungageApplicationDetails: SungageApplicationDetails
  getSungageFrame: Scalars["String"]["output"]
  getSunlightFrame: Scalars["String"]["output"]
  getSunlightProjectStatus: SunlightGetStatusResponse
  getWarrantyPricing: Array<PowurOsWarrantyPricing>
  incentives: Array<Incentive>
  incentivesCount: Scalars["Float"]["output"]
  invertersForProposal: InvertersForProposalResponse
  mosaicGetApplication: MosaicGetApplicationResponseDto
  mosaicGetUsers: MosaicGetUsersResponseDto
  mosaicListDisclosures: MosaicGetDisclosuresResponseDto
  profile: User
  proposal: Proposal
  proposalStatuses: Array<ProposalStatus>
  proposals: Array<Proposal>
  proposalsCount: Scalars["Float"]["output"]
  savingsForDesignId: Maybe<SavingsResult>
  /** Search equipment with availability reasons for troubleshooting */
  searchEquipmentWithAvailability: Array<EquipmentAvailabilityResultObject>
  /** performs case insensitive pattern matching search against provided fields */
  searchLoanProducts: Array<LoanProduct>
  /** performs case insensitive pattern matching search against provided fields */
  searchUsers: Array<User>
  serviceIntegration: ServiceIntegration
  serviceIntegrations: Array<ServiceIntegration>
  site: Site
  sites: Array<Site>
  /** finds user by id */
  user: User
  /** finds all users */
  users: Array<User>
  /** Search all utility companies */
  utilityCompanies: Array<UtilityCompany>
  utilityCompaniesCount: Scalars["Float"]["output"]
  /** Find utility companies for a given site's zip code */
  utilityCompaniesForSite: Array<UtilityCompany>
  /** Find all utility rates */
  utilityRates: Array<UtilityRate>
  utilityRatesCount: Scalars["Float"]["output"]
  /** Find utility rates for a given site */
  utilityRatesForSite: Array<UtilityRate>
  /** Find utility rates for a utility company */
  utilityTariffsForCompany: Array<UtilityRate>
}

export type QueryBaseEquipmentForProposalArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryContractArgs = {
  id: Scalars["String"]["input"]
}

export type QueryContractVersionHistoryForProposalArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryContractsForProposalArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryDesignArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDesignHasSunroofArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDesignRequestArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDesignerDataByRequestIdArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryDesignsArgs = {
  designsInput: InputMaybe<DesignsInput>
}

export type QueryEquipmentForProposalArgs = {
  equipmentType: InputMaybe<NewEquipmentType>
  inverterManufacturerId: InputMaybe<Scalars["Float"]["input"]>
  proposalId: Scalars["String"]["input"]
}

export type QueryEstimateArgs = {
  findEstimateInput: FindEstimateInput
}

export type QueryEstimatesForDesignArgs = {
  designId: Scalars["ID"]["input"]
}

export type QueryFindAllLoanProductsArgs = {
  loanProductsInput: InputMaybe<LoanProductsInput>
}

export type QueryFindDisclosuresForLoanProductArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryFindLoanProductByIdArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryFindLoanProductsForProposalArgs = {
  proposalId: Scalars["ID"]["input"]
  provider: Scalars["String"]["input"]
}

export type QueryFindPossibleTpoLoanProductTypesForProposalArgs = {
  proposalId: Scalars["ID"]["input"]
}

export type QueryGetActiveLoanStatusArgs = {
  id: Scalars["String"]["input"]
}

export type QueryGetBrochureArgs = {
  proposalId: Scalars["ID"]["input"]
}

export type QueryGetContractSignedDtoArgs = {
  contractId: Scalars["String"]["input"]
  proposalId: Scalars["String"]["input"]
}

export type QueryGetCronJobActiveStatusArgs = {
  jobName: Scalars["String"]["input"]
}

export type QueryGetEnfinApplicationDetailsArgs = {
  providerId: Scalars["String"]["input"]
}

export type QueryGetEnfinFrameArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryGetGoodLeapDisclosuresArgs = {
  category: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetGoodleapLoanDetailsArgs = {
  providerId: Scalars["String"]["input"]
}

export type QueryGetGoodleapStipulationsArgs = {
  providerId: Scalars["String"]["input"]
}

export type QueryGetIncentivesByProposalIdArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryGetMockAddressArgs = {
  input: GetMockAddressInput
}

export type QueryGetProposalStatusEventsArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryGetQueueArgs = {
  queueInput: QueueInput
}

export type QueryGetQuotesForProposalArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryGetSelectIncentivesModalArgs = {
  proposalId: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetShortLinkArgs = {
  id: InputMaybe<Scalars["String"]["input"]>
  slug: InputMaybe<Scalars["String"]["input"]>
}

export type QueryGetSungageApplicationDetailsArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryGetSungageFrameArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryGetSunlightFrameArgs = {
  input: GetSunlightIframeUrlDto
}

export type QueryGetSunlightProjectStatusArgs = {
  id: Scalars["String"]["input"]
}

export type QueryGetWarrantyPricingArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryIncentivesArgs = {
  incentiveListInput: InputMaybe<IncentiveInput>
}

export type QueryIncentivesCountArgs = {
  incentiveListInput: InputMaybe<IncentiveInput>
}

export type QueryInvertersForProposalArgs = {
  proposalId: Scalars["String"]["input"]
}

export type QueryMosaicGetApplicationArgs = {
  input: Scalars["ID"]["input"]
}

export type QueryMosaicGetUsersArgs = {
  input: MosaicGetUsersBodyDto
}

export type QueryMosaicListDisclosuresArgs = {
  input: MosaicGetDisclosuresBodyDto
}

export type QueryProposalArgs = {
  findProposalInput: FindProposalInput
}

export type QueryProposalsArgs = {
  proposalListInput: InputMaybe<ProposalsInput>
}

export type QueryProposalsCountArgs = {
  proposalListInput: InputMaybe<ProposalsInput>
}

export type QuerySavingsForDesignIdArgs = {
  designId: Scalars["ID"]["input"]
}

export type QuerySearchEquipmentWithAvailabilityArgs = {
  proposalId: Scalars["String"]["input"]
  searchTerm: Scalars["String"]["input"]
}

export type QuerySearchLoanProductsArgs = {
  searchTerms: SearchLoanProductInput
}

export type QuerySearchUsersArgs = {
  searchTerms: SearchUserInput
}

export type QueryServiceIntegrationArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryServiceIntegrationsArgs = {
  serviceIntegrationsInput: InputMaybe<ServiceIntegrationsInput>
}

export type QuerySiteArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryUserArgs = {
  id: Scalars["ID"]["input"]
}

export type QueryUsersArgs = {
  usersInput: InputMaybe<UsersInput>
}

export type QueryUtilityCompaniesArgs = {
  utilityCompanyInput: InputMaybe<UtilityCompanyInput>
}

export type QueryUtilityCompaniesCountArgs = {
  utilityCompanyInput: InputMaybe<UtilityCompanyInput>
}

export type QueryUtilityCompaniesForSiteArgs = {
  siteId: Scalars["ID"]["input"]
}

export type QueryUtilityRatesArgs = {
  utilityRateInput: InputMaybe<UtilityRateInput>
}

export type QueryUtilityRatesCountArgs = {
  utilityRateInput: InputMaybe<UtilityRateInput>
}

export type QueryUtilityRatesForSiteArgs = {
  siteId: Scalars["ID"]["input"]
}

export type QueryUtilityTariffsForCompanyArgs = {
  lseId: Scalars["String"]["input"]
  nameMatch: InputMaybe<Scalars["String"]["input"]>
}

export type QueueInput = {
  filter?: InputMaybe<DesignRequestFindManyWhereInput>
  skip?: InputMaybe<Scalars["Float"]["input"]>
  take: Scalars["Float"]["input"]
}

export type Quote = {
  __typename?: "Quote"
  alternateMonthlyPayment: Maybe<Scalars["Float"]["output"]>
  buyoutAmount: Maybe<Scalars["Float"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  finalEscalatedMonthlyPayment: Maybe<Scalars["Float"]["output"]>
  finalMonthlyPayment: Maybe<Scalars["Float"]["output"]>
  goodleapJson: Maybe<GoodLeapPaymentsResponse>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  loanAmount: Maybe<Scalars["Float"]["output"]>
  loanProductId: Scalars["String"]["output"]
  monthlyAdjustedPayment: Scalars["Float"]["output"]
  monthlyInitialPayment: Scalars["Float"]["output"]
  monthlyPayments: Maybe<Array<Scalars["JSON"]["output"]>>
  paydownAmount: Maybe<Scalars["Float"]["output"]>
  paydownPercentage: Maybe<Scalars["Float"]["output"]>
  paymentFactors: Maybe<Scalars["JSON"]["output"]>
  poisonId: Maybe<Scalars["String"]["output"]>
  prepaid: Maybe<Scalars["Float"]["output"]>
  productionRate: Scalars["Float"]["output"]
  proposalId: Scalars["String"]["output"]
  solarRate: Scalars["Float"]["output"]
  totalProjectCost: Maybe<Scalars["Float"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type QuoteBodyResponse = {
  __typename?: "QuoteBodyResponse"
  apr: Scalars["Float"]["output"]
  createdDateTime: Scalars["String"]["output"]
  escalatedMonthlyPayment: Scalars["Float"]["output"]
  finalEscalatedMonthlyPayment: Scalars["Float"]["output"]
  finalMonthlyPayment: Scalars["Float"]["output"]
  id: Scalars["String"]["output"]
  includesBattery: Scalars["Boolean"]["output"]
  isACH: Scalars["Boolean"]["output"]
  isSyncing: Scalars["Boolean"]["output"]
  loanAmount: Scalars["Float"]["output"]
  monthlyPayment: Scalars["Float"]["output"]
  nonACHApr: Scalars["Float"]["output"]
  prePaymentPercentage: Scalars["Float"]["output"]
  productName: Scalars["String"]["output"]
  productType: Scalars["String"]["output"]
  quoteNumber: Scalars["String"]["output"]
  systemDesignId: Scalars["String"]["output"]
  term: Scalars["Float"]["output"]
}

export type QuoteResult = PoisonedQuote | Quote

export type RebateForPowurOs = {
  __typename?: "RebateForPowurOS"
  name: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

/** Goodleap Spoken Language Type */
export enum Spoken_Language {
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
}

export type Savings = {
  __typename?: "Savings"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  designId: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  inputs: GenabilityAccountAnalysisInputs
  outputs: Maybe<GenabilityAccountAnalysis>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type SavingsResult = PoisonedSavings | Savings

export type SearchLoanProductInput = {
  /** string for the provider */
  provider?: InputMaybe<Scalars["String"]["input"]>
}

export type SearchUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>
  enterpriseId?: InputMaybe<Scalars["String"]["input"]>
  firstName?: InputMaybe<Scalars["String"]["input"]>
  lastName?: InputMaybe<Scalars["String"]["input"]>
  permissions?: InputMaybe<Array<Permission | `${Permission}`>>
  phone?: InputMaybe<Scalars["String"]["input"]>
}

export type SendCreditApplicationInput = {
  goodLeapRequest?: InputMaybe<GoodLeapCreateLoanRequestDto>
  proposalId: Scalars["String"]["input"]
  provider: LoanProvider | `${LoanProvider}`
  selectedLoanProductId: Scalars["String"]["input"]
}

export type SendCreditApplicationResponse =
  | GoodLeapCreateLoanResponseDto
  | MosaicPostApplicationResponseDto

export type ServiceIntegration = {
  __typename?: "ServiceIntegration"
  apiKeys: Array<ApiKey>
  contactEmail: Scalars["String"]["output"]
  contactName: Scalars["String"]["output"]
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  name: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type ServiceIntegrationFilterInput = {
  search?: InputMaybe<Scalars["String"]["input"]>
}

export type ServiceIntegrationSortInput = {
  contactEmail?: InputMaybe<SortOrder | `${SortOrder}`>
  contactName?: InputMaybe<SortOrder | `${SortOrder}`>
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>
  name?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type ServiceIntegrationsInput = {
  filter?: InputMaybe<ServiceIntegrationFilterInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<ServiceIntegrationSortInput>
}

export type ShortLink = {
  __typename?: "ShortLink"
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  expiresAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  proposalId: Scalars["String"]["output"]
  slug: Scalars["String"]["output"]
  timesVisited: Scalars["Float"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  url: Scalars["String"]["output"]
}

export type Site = {
  __typename?: "Site"
  /** Normalized address (123 S Main St. Anytown USA, 00000) */
  address: Scalars["String"]["output"]
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** Account ID from Genability */
  genabilityAccountId: Maybe<Scalars["String"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** Imagery for this site */
  imagery: Array<ImageryResult>
  /** Whether the site is in an IRA energy community */
  isEnergyCommunity: Scalars["Boolean"]["output"]
  /** When energy community eligibility was manually set */
  isEnergyCommunityManuallySetAt: Maybe<Scalars["DateTime"]["output"]>
  /** Site kind */
  kind: SiteKind | `${SiteKind}`
  /** Site Latitude (-90.0 - 90.0 */
  latitude: Scalars["Float"]["output"]
  /** Site locality */
  locality: Scalars["String"]["output"]
  /** Site Longitude (-180.0 - 180.0 */
  longitude: Scalars["Float"]["output"]
  /** Site zip code */
  postalCode: Scalars["String"]["output"]
  /** Site zip code suffix */
  postalCodeSuffix: Scalars["String"]["output"]
  /** Site state */
  state: StateCode | `${StateCode}`
  /** street address */
  street: Scalars["String"]["output"]
  /** Street View Latitude (-90.0 - 90.0 */
  streetViewLatitude: Maybe<Scalars["Float"]["output"]>
  /** Street View Longitude (-180.0 - 180.0 */
  streetViewLongitude: Maybe<Scalars["Float"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export enum SiteKind {
  battery_only = "battery_only",
  solar = "solar",
}

export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

/** Information about the SSC library. */
export type SscInfo = {
  __typename?: "SscInfo"
  /** Build Identifier */
  build: Scalars["String"]["output"]
  /** Module name */
  module: Scalars["String"]["output"]
  /** Version number */
  version: Scalars["Float"]["output"]
}

export enum StateCode {
  AK = "AK",
  AL = "AL",
  AR = "AR",
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  DE = "DE",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  IA = "IA",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  MA = "MA",
  MD = "MD",
  ME = "ME",
  MI = "MI",
  MN = "MN",
  MO = "MO",
  MS = "MS",
  MT = "MT",
  NC = "NC",
  ND = "ND",
  NE = "NE",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NV = "NV",
  NY = "NY",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  PR = "PR",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VA = "VA",
  VT = "VT",
  WA = "WA",
  WI = "WI",
  WV = "WV",
  WY = "WY",
}

/** Information about the climate data used in the simulation. */
export type StationInfo = {
  __typename?: "StationInfo"
  /** City where climate station is located. */
  city: Scalars["String"]["output"]
  /** Distance between the input location and the climate station. (meters) */
  distance: Maybe<Scalars["Float"]["output"]>
  /** Elevation of the climate station. (meters) */
  elev: Scalars["Float"]["output"]
  /** Latitude of the climate station. */
  lat: Scalars["Float"]["output"]
  /** ID of the climate station. */
  location: Scalars["String"]["output"]
  /** Longitude of the climate station. */
  lon: Scalars["Float"]["output"]
  /** Solar resource filename. */
  solar_resource_file: Scalars["String"]["output"]
  /** State where climate station is located. */
  state: Scalars["String"]["output"]
  /** Timezone offset from GMT. */
  tz: Scalars["Float"]["output"]
  /** Weather data source. */
  weather_data_source: Scalars["String"]["output"]
}

export type StipsBodyResponse = {
  __typename?: "StipsBodyResponse"
  description: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  installerOnlyEmail: Scalars["Boolean"]["output"]
  isStipSuppressed: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  status: Scalars["String"]["output"]
}

export type Stipulation = {
  __typename?: "Stipulation"
  appliesTo: Maybe<Scalars["String"]["output"]>
  attachments: Array<Attachment>
  createdAt: Maybe<Scalars["String"]["output"]>
  deferred: Maybe<Scalars["Boolean"]["output"]>
  description: Maybe<Scalars["String"]["output"]>
  documentsToClear: Array<Document>
  domain: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  reasonCodes: Array<Scalars["String"]["output"]>
  status: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
  updatedAt: Maybe<Scalars["String"]["output"]>
  updatedBy: Maybe<Scalars["String"]["output"]>
}

export type SubjectProperty = {
  __typename?: "SubjectProperty"
  address: Address
  mortgageTotalBalances: Maybe<Currency>
  mortgageTotalPayments: Maybe<Currency>
}

export type SubjectPropertyInput = {
  address: AddressInput
  mortgageTotalBalances?: InputMaybe<CurrencyInput>
  mortgageTotalPayments?: InputMaybe<CurrencyInput>
}

export type SubmitChangeOrderResponse = {
  __typename?: "SubmitChangeOrderResponse"
  id: Scalars["ID"]["output"]
}

export type SubmittingUser = {
  email: Scalars["String"]["input"]
  firstName: Scalars["String"]["input"]
  lastName: Scalars["String"]["input"]
  phone?: InputMaybe<Scalars["String"]["input"]>
}

export type SungageApplicationDetails = {
  __typename?: "SungageApplicationDetails"
  applicationDate: Scalars["String"]["output"]
  approvalAmount: Scalars["Float"]["output"]
  approvedTerm: Scalars["String"]["output"]
  creditDeadline: Scalars["String"]["output"]
  key: Scalars["String"]["output"]
  roofAndBattery: Scalars["Boolean"]["output"]
  status: Scalars["String"]["output"]
  stipulations: Maybe<Array<Scalars["String"]["output"]>>
  url: Scalars["String"]["output"]
}

export type SunlightDisclosure = {
  __typename?: "SunlightDisclosure"
  disclosureText: Scalars["String"]["output"]
  isHome: Scalars["Boolean"]["output"]
  isSolar: Scalars["Boolean"]["output"]
  spanishDisclosureText: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type SunlightGetDisclosuresResponse = {
  __typename?: "SunlightGetDisclosuresResponse"
  projects: Array<SunlightProjectsArray>
  returnCode: Scalars["String"]["output"]
}

export type SunlightGetStatusResponse = {
  __typename?: "SunlightGetStatusResponse"
  projects: Array<ProjectBodyResponse>
  returnCode: Scalars["String"]["output"]
}

export type SunlightProjectsArray = {
  __typename?: "SunlightProjectsArray"
  disclosures: Array<SunlightDisclosure>
}

export type SyncLoanOfferResponse = {
  __typename?: "SyncLoanOfferResponse"
  created: Scalars["Float"]["output"]
  fetched: Scalars["Float"]["output"]
  unchanged: Scalars["Float"]["output"]
  updated: Scalars["Float"]["output"]
}

export type SystemDesignBodyResponse = {
  __typename?: "SystemDesignBodyResponse"
  estAnnualProductionkwh: Scalars["Float"]["output"]
  id: Scalars["String"]["output"]
  inverterCount: Scalars["Float"]["output"]
  inverterMake: Scalars["String"]["output"]
  inverterMakeName: Scalars["String"]["output"]
  inverterModel: Scalars["String"]["output"]
  moduleCount: Scalars["Float"]["output"]
  moduleMake: Scalars["String"]["output"]
  moduleMakeName: Scalars["String"]["output"]
  moduleModel: Scalars["String"]["output"]
  projectType: Scalars["String"]["output"]
  systemSize: Scalars["Float"]["output"]
}

export type SystemDesignInfo = {
  __typename?: "SystemDesignInfo"
  equipment: Array<EquipmentForPowurOs>
  estimatedAnnualProduction: Scalars["Float"]["output"]
  postSolarUtility: UtilityInfo
  preSolarUtility: UtilityInfo
  proposalPdfDownloadUrl: Scalars["String"]["output"]
  roofType: Maybe<Scalars["String"]["output"]>
}

export enum SystemType {
  both = "both",
  ground_mount = "ground_mount",
  roof_mount = "roof_mount",
}

export type TpoPricing = {
  __typename?: "TPOPricing"
  firstYearMonthlyPayment: FirstYearMonthlyPayment
  pricePerUnit: PricePerUnit
  productionRate: ProductionRate
  purchasePrice: PurchasePrice
}

export type TpoPricingOffer = {
  __typename?: "TPOPricingOffer"
  disclaimer: Scalars["String"]["output"]
  estimatedAnnualProduction: Scalars["Float"]["output"]
  offerId: Scalars["String"]["output"]
  pricing: Array<TpoPricing>
  systemSize: Scalars["Float"]["output"]
}

/** Reasons why equipment might not be available for a proposal */
export enum UnavailabilityReason {
  AVAILABLE = "AVAILABLE",
  DISCONTINUED = "DISCONTINUED",
  FUNDING_PARTNER_RESTRICTION = "FUNDING_PARTNER_RESTRICTION",
  JURISDICTION_RESTRICTION = "JURISDICTION_RESTRICTION",
  REGIONAL_RESTRICTION = "REGIONAL_RESTRICTION",
}

export type UpdateDesignInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  batteryCompatibility?: InputMaybe<Scalars["Boolean"]["input"]>
  brochurePositionX?: InputMaybe<Scalars["Float"]["input"]>
  brochurePositionY?: InputMaybe<Scalars["Float"]["input"]>
  brochureZoom?: InputMaybe<Scalars["Float"]["input"]>
  completedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  displayImageryProvider?: InputMaybe<Scalars["String"]["input"]>
  edges?: InputMaybe<Scalars["JSON"]["input"]>
  energyBackupId?: InputMaybe<Scalars["Int"]["input"]>
  energyEfficiencyKitRebate?: InputMaybe<Scalars["Boolean"]["input"]>
  energyEfficiencyKitRebateAmount?: InputMaybe<Scalars["Float"]["input"]>
  evCharger?: InputMaybe<Scalars["Boolean"]["input"]>
  evOutlet?: InputMaybe<Scalars["Boolean"]["input"]>
  homeownerRebate?: InputMaybe<Scalars["Boolean"]["input"]>
  homeownerRebateAmount?: InputMaybe<Scalars["Float"]["input"]>
  id: Scalars["ID"]["input"]
  installAreas?: InputMaybe<Scalars["JSON"]["input"]>
  installAreasToPanels?: InputMaybe<Scalars["JSON"]["input"]>
  inverterId?: InputMaybe<Scalars["Int"]["input"]>
  inverterManufacturer?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  nodes?: InputMaybe<Scalars["JSON"]["input"]>
  obstructions?: InputMaybe<Scalars["JSON"]["input"]>
  panels?: InputMaybe<Scalars["JSON"]["input"]>
  phase?: InputMaybe<Scalars["String"]["input"]>
  roofWorkRebate?: InputMaybe<Scalars["Boolean"]["input"]>
  roofWorkRebateAmount?: InputMaybe<Scalars["Float"]["input"]>
  secondaryInverterId?: InputMaybe<Scalars["Int"]["input"]>
  /** Selected additional equipment ids */
  selectedDesignEquipmentIds?: InputMaybe<Array<Scalars["Float"]["input"]>>
  setbacks?: InputMaybe<Scalars["JSON"]["input"]>
  shadingAreas?: InputMaybe<Scalars["JSON"]["input"]>
  solarModuleId?: InputMaybe<Scalars["Int"]["input"]>
  tool?: InputMaybe<Scalars["String"]["input"]>
  treeTrimmingRebate?: InputMaybe<Scalars["Boolean"]["input"]>
  treeTrimmingRebateAmount?: InputMaybe<Scalars["Float"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateImageryPositionInput = {
  positionedX?: InputMaybe<Scalars["Float"]["input"]>
  positionedY?: InputMaybe<Scalars["Float"]["input"]>
  positionedZoom?: InputMaybe<Scalars["Float"]["input"]>
}

export type UpdateIncentiveInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  canApplyToLoan: Scalars["Boolean"]["input"]
  customDisplayName?: InputMaybe<Scalars["String"]["input"]>
  endDate?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["String"]["input"]
  isPaidAsLumpSum: Scalars["Boolean"]["input"]
  isSungageRebate: Scalars["Boolean"]["input"]
  lseCode?: InputMaybe<Scalars["String"]["input"]>
  lseId?: InputMaybe<Scalars["Float"]["input"]>
  lseName?: InputMaybe<Scalars["String"]["input"]>
  turnedOnByDefaultAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type UpdateInverterInput = {
  designId: Scalars["String"]["input"]
  inverterId?: InputMaybe<Scalars["Float"]["input"]>
  inverterManufacturer: Scalars["String"]["input"]
  secondaryInverterId?: InputMaybe<Scalars["Float"]["input"]>
}

export type UpdateLoanProductInput = {
  activatedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  id: Scalars["ID"]["input"]
  maximumLoanAmount?: InputMaybe<Scalars["Float"]["input"]>
  minimumCreditScore?: InputMaybe<Scalars["Float"]["input"]>
  minimumLoanAmount?: InputMaybe<Scalars["Float"]["input"]>
  powurOsLoanId?: InputMaybe<Scalars["Float"]["input"]>
  providerFee?: InputMaybe<Scalars["Float"]["input"]>
  providerName?: InputMaybe<Scalars["String"]["input"]>
  statesActive?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export type UpdateProposalAdderInput = {
  customPrice?: InputMaybe<Scalars["Float"]["input"]>
  customQuantity?: InputMaybe<Scalars["Float"]["input"]>
  powurOsAdderId: Scalars["Float"]["input"]
  proposalId: Scalars["String"]["input"]
  selected?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type UpdateProposalInput = {
  annualEnergyUse?: InputMaybe<Scalars["Float"]["input"]>
  /** Down Payment */
  downPayment?: InputMaybe<Scalars["Float"]["input"]>
  financeProductId?: InputMaybe<Scalars["String"]["input"]>
  financeType?: InputMaybe<Scalars["String"]["input"]>
  fundingGroup?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
  /** Margin (priced in $ per watt) */
  margin?: InputMaybe<Scalars["Float"]["input"]>
  /** Selected mentor ID */
  mentorId?: InputMaybe<Scalars["String"]["input"]>
  monthlyEnergyCost?: InputMaybe<Array<Scalars["Float"]["input"]>>
  monthlyEnergyManualFlags?: InputMaybe<Array<Scalars["Boolean"]["input"]>>
  monthlyEnergyUse?: InputMaybe<Array<Scalars["Float"]["input"]>>
  /** Proposal name */
  name?: InputMaybe<Scalars["String"]["input"]>
  newCustomerIncentive?: InputMaybe<Scalars["Boolean"]["input"]>
  newCustomerIncentiveMonths?: InputMaybe<Scalars["Float"]["input"]>
  /** Post-solar-install utility rate id */
  postSolarInstallUtilityRateId?: InputMaybe<Scalars["String"]["input"]>
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>
  /** primary presenter powurUserId */
  primaryPresenter?: InputMaybe<Scalars["Float"]["input"]>
  /** Proposal Adder */
  proposalAdders?: InputMaybe<Array<UpdateProposalAdderInput>>
  /** secondary presenter powurUserId */
  secondaryPresenter?: InputMaybe<Scalars["Float"]["input"]>
  /** Selected loan product Id */
  selectedLoanProductId?: InputMaybe<Scalars["String"]["input"]>
  /** Consultant powur id */
  sellerId?: InputMaybe<Scalars["ID"]["input"]>
  smartEstimateBanner?: InputMaybe<Scalars["String"]["input"]>
  /** system type (roof mount, ground mount, or both) */
  systemType?: InputMaybe<SystemType | `${SystemType}`>
  userAdjustedAfterSolarContractedRate?: InputMaybe<Scalars["Float"]["input"]>
  userAdjustedBeforeSolarContractedRate?: InputMaybe<Scalars["Float"]["input"]>
  /** user has overridden the average utility rate */
  userAdjustedUtilityRate?: InputMaybe<Scalars["Float"]["input"]>
  /** Utility rate escalation percentage */
  utilityRateEscalationPercentage?: InputMaybe<Scalars["Float"]["input"]>
  /** Utility rate id */
  utilityRateId?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateServiceIntegrationInput = {
  contactEmail?: InputMaybe<Scalars["String"]["input"]>
  contactName?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type UpdateSiteInput = {
  /** Address of the site */
  address?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["ID"]["input"]
  /** Latitude of the site */
  latitude?: InputMaybe<Scalars["Float"]["input"]>
  /** Longitude of the site */
  longitude?: InputMaybe<Scalars["Float"]["input"]>
  /** street view latitude of the site */
  streetViewLatitude?: InputMaybe<Scalars["Float"]["input"]>
  /** Street view longitude of the site */
  streetViewLongitude?: InputMaybe<Scalars["Float"]["input"]>
  /** zoom level of the mapping service */
  zoom?: InputMaybe<Scalars["Float"]["input"]>
}

export type UpdateStorageInput = {
  designId: Scalars["String"]["input"]
  equipmentId?: InputMaybe<Scalars["Int"]["input"]>
}

export type UpdateUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>
  enterpriseId?: InputMaybe<Scalars["String"]["input"]>
  firstName?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["String"]["input"]
  lastName?: InputMaybe<Scalars["String"]["input"]>
  permissions?: InputMaybe<Array<Permission | `${Permission}`>>
  phone?: InputMaybe<Scalars["String"]["input"]>
}

export type User = {
  __typename?: "User"
  /** user bio */
  bio: Maybe<Scalars["String"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** user email */
  email: Scalars["String"]["output"]
  /** user enterprise id */
  enterpriseId: Maybe<Scalars["String"]["output"]>
  /** external identifiers for the user */
  externalIds: Maybe<Array<ExternalIdentifier>>
  /** user first name */
  firstName: Scalars["String"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** user last name */
  lastName: Scalars["String"]["output"]
  licenses: Maybe<Array<License>>
  /** user permission for determining application permissions */
  permissions: Array<Permission | `${Permission}`>
  /** user phone number */
  phone: Maybe<Scalars["String"]["output"]>
  /** powur.com user id */
  powurUserId: Maybe<Scalars["Float"]["output"]>
  /** user profile image url */
  profileImage: Maybe<ProfileImg>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
}

export type UserFindManyWhereInput = {
  permission?: InputMaybe<Permission | `${Permission}`>
  search?: InputMaybe<Scalars["String"]["input"]>
}

export type UsersInput = {
  filter?: InputMaybe<UserFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<UsersOrderByInput>
}

export type UsersOrderByInput = {
  email?: InputMaybe<SortOrder | `${SortOrder}`>
  firstName?: InputMaybe<SortOrder | `${SortOrder}`>
  lastName?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type UtilityCompany = {
  __typename?: "UtilityCompany"
  /** Activated date */
  activatedAt: Maybe<Scalars["DateTime"]["output"]>
  /** Details about how the LSE represents billing periods. See https://developer.genability.com/api-reference/tariff-api/load-serving-entity/ for more details */
  billingPeriodRepresentation: Maybe<Scalars["JSON"]["output"]>
  /** Short code (an alternate key). For US companies this is the EIA ID */
  code: Maybe<Scalars["String"]["output"]>
  /** Commercial customer count */
  commercialCustomers: Maybe<Scalars["Float"]["output"]>
  /** Annual commercial revenue in thousands of local currency (e.g. USD) */
  commercialRevenues: Maybe<Scalars["Float"]["output"]>
  /** Annual commercial sales in MWh */
  commercialSales: Maybe<Scalars["Float"]["output"]>
  /** Service types offered to commercial customers. Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  commercialServiceTypes: Maybe<Scalars["String"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** Industrial customer count */
  industrialCustomers: Maybe<Scalars["Float"]["output"]>
  /** Annual industrial revenue in thousands of local currency (e.g. USD) */
  industrialRevenues: Maybe<Scalars["Float"]["output"]>
  /** Annual industrial sales in MWh */
  industrialSales: Maybe<Scalars["Float"]["output"]>
  /** Service types offered to industrial customers. Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  industrialServiceTypes: Maybe<Scalars["String"]["output"]>
  /** Shorthand code for the company (PGE for Pacific Gas & Electric) */
  lseCode: Maybe<Scalars["String"]["output"]>
  /** Unique Genability ID (primary key) for each LSE */
  lseId: Scalars["Float"]["output"]
  /** Published name of the company */
  name: Scalars["String"]["output"]
  /** Utility classification based on the type of service they offer */
  offeringType: Scalars["String"]["output"]
  /** Ownership structure */
  ownership: Scalars["String"]["output"]
  ptcTduId: Maybe<Scalars["String"]["output"]>
  /** Residential customer count */
  residentialCustomers: Maybe<Scalars["Float"]["output"]>
  /** Annual residential revenue in thousands of local currency (e.g. USD) */
  residentialRevenues: Maybe<Scalars["Float"]["output"]>
  /** Annual residential sales in MWh */
  residentialSales: Maybe<Scalars["Float"]["output"]>
  /** Service types offered to residential customers. Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  residentialServiceTypes: Maybe<Scalars["String"]["output"]>
  /** Service types offered to any customer */
  serviceTypes: Maybe<Scalars["String"]["output"]>
  /** Total customer count */
  totalCustomers: Maybe<Scalars["Float"]["output"]>
  /** Annual total revenue in thousands of local currency (e.g. USD) */
  totalRevenues: Maybe<Scalars["Float"]["output"]>
  /** Annual total sales in MWh */
  totalSales: Maybe<Scalars["Float"]["output"]>
  /** Transportation customer count */
  transportationCustomers: Maybe<Scalars["Float"]["output"]>
  /** Annual transportation revenue in thousands of local currency (e.g. USD) */
  transportationRevenues: Maybe<Scalars["Float"]["output"]>
  /** Annual transportation sales in MWh */
  transportationSales: Maybe<Scalars["Float"]["output"]>
  /** Service types offered to transportation customers (such as municipal bus services, regional mass transit etc). Current values include "ELECTRICITY" and "SOLAR_PV". Blank means not offered */
  transportationServiceTypes: Maybe<Scalars["String"]["output"]>
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  /** Utility Rates associated with this Utility Company */
  utilityRates: Maybe<Array<UtilityRate>>
  /** The URL to the home page of the LSE website */
  websiteHome: Maybe<Scalars["String"]["output"]>
}

export type UtilityCompanyFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]["input"]>
}

export type UtilityCompanyInput = {
  filter?: InputMaybe<UtilityCompanyFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<UtilityCompanyOrderByInput>
}

export type UtilityCompanyOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type UtilityInfo = {
  __typename?: "UtilityInfo"
  contractedRate: Maybe<Scalars["Float"]["output"]>
  contractedRateType: Maybe<Scalars["String"]["output"]>
  genabilityId: Scalars["Int"]["output"]
  genabilityTariffId: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  rateName: Scalars["String"]["output"]
}

export type UtilityRate = {
  __typename?: "UtilityRate"
  /** vision managed activated date */
  activatedAt: Maybe<Scalars["DateTime"]["output"]>
  /** Genability billing period */
  billingPeriod: Scalars["String"]["output"]
  chargePeriod: Maybe<Scalars["String"]["output"]>
  chargeTypes: Maybe<Scalars["String"]["output"]>
  closedDate: Maybe<Scalars["String"]["output"]>
  /** resource creation date */
  createdAt: Scalars["DateTime"]["output"]
  /** Genability currency */
  currency: Scalars["String"]["output"]
  /** Genability customer class */
  customerClass: Maybe<Scalars["String"]["output"]>
  customerCount: Maybe<Scalars["Float"]["output"]>
  customerCountSource: Maybe<Scalars["String"]["output"]>
  customerLikelihood: Maybe<Scalars["Float"]["output"]>
  /** Date on which the tariff was or will be effective */
  effectiveDate: Maybe<Scalars["String"]["output"]>
  effectiveOnRule: Maybe<Scalars["String"]["output"]>
  /** Genability end date */
  endDate: Maybe<Scalars["String"]["output"]>
  hasContractedRates: Maybe<Scalars["Boolean"]["output"]>
  hasNetMetering: Maybe<Scalars["Boolean"]["output"]>
  hasRateApplicability: Maybe<Scalars["Boolean"]["output"]>
  hasTariffApplicability: Maybe<Scalars["Boolean"]["output"]>
  hasTieredRates: Maybe<Scalars["Boolean"]["output"]>
  hasTimeOfUseRates: Maybe<Scalars["Boolean"]["output"]>
  /** version 4(random) UUID */
  id: Scalars["ID"]["output"]
  /** active status per genability */
  isActive: Scalars["Boolean"]["output"]
  isNEM3: Scalars["Boolean"]["output"]
  isSolarPvEligible: Scalars["Boolean"]["output"]
  lseCode: Maybe<Scalars["String"]["output"]>
  /** Genability lse (Utility Company) id */
  lseId: Scalars["Float"]["output"]
  /** Genability lse (Utility Company) name */
  lseName: Scalars["String"]["output"]
  /** Genability master tariff (Rate) id */
  masterTariffId: Scalars["Float"]["output"]
  maxMonthlyConsumption: Maybe<Scalars["Float"]["output"]>
  maxMonthlyDemand: Maybe<Scalars["Float"]["output"]>
  minMonthlyConsumption: Maybe<Scalars["Float"]["output"]>
  minMonthlyDemand: Maybe<Scalars["Float"]["output"]>
  priorTariffId: Maybe<Scalars["Float"]["output"]>
  privacy: Maybe<Scalars["String"]["output"]>
  serviceType: Maybe<Scalars["String"]["output"]>
  tariffBookName: Maybe<Scalars["String"]["output"]>
  /** Genability tariff (Rate) code */
  tariffCode: Scalars["String"]["output"]
  /** Genability tariff Id */
  tariffId: Scalars["Float"]["output"]
  /** Genability tariff (Rate) name */
  tariffName: Scalars["String"]["output"]
  tariffType: Maybe<Scalars["String"]["output"]>
  territoryId: Maybe<Scalars["Float"]["output"]>
  /** Genability time zone */
  timeZone: Scalars["String"]["output"]
  /** resource last updated update date */
  updatedAt: Scalars["DateTime"]["output"]
  utilityCompany: Maybe<UtilityCompany>
  /** ID of utility company */
  utilityCompanyId: Maybe<Scalars["String"]["output"]>
  utilityRateZipCodeLikelihoods: Maybe<Array<UtilityRateZipCodeLikelihood>>
}

export type UtilityRateFindManyWhereInput = {
  search?: InputMaybe<Scalars["String"]["input"]>
}

export type UtilityRateInput = {
  filter?: InputMaybe<UtilityRateFindManyWhereInput>
  paginate?: InputMaybe<PaginationInput>
  sort?: InputMaybe<UtilityRateOrderByInput>
}

export type UtilityRateOrderByInput = {
  createdAt?: InputMaybe<SortOrder | `${SortOrder}`>
}

export type UtilityRateZipCodeLikelihood = {
  __typename?: "UtilityRateZipCodeLikelihood"
  createdAt: Scalars["DateTime"]["output"]
  likelihood: Maybe<Scalars["Float"]["output"]>
  rateTariffId: Scalars["Float"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
  zipcode: Scalars["String"]["output"]
}

export type VisionContractSigned = {
  __typename?: "VisionContractSigned"
  IsDomesticBattery: Maybe<Scalars["Boolean"]["output"]>
  IsDomesticSolar: Maybe<Scalars["Boolean"]["output"]>
  IsEnergyCommunity: Maybe<Scalars["Boolean"]["output"]>
  adders: Array<AdderForPowurOs>
  contract: ContractInfo
  customerInfo: CustomerInfo
  designEdits: Array<DesignEdit>
  documents: Maybe<DocumentsForPowurOs>
  expectedMargin: Scalars["Float"]["output"]
  newCustomerIncentive: Maybe<Scalars["Float"]["output"]>
  pricingModel: Maybe<Scalars["String"]["output"]>
  rebates: Array<RebateForPowurOs>
  recommendedEquipment: Maybe<Array<PowurOsRecommendedEquipment>>
  systemDesign: SystemDesignInfo
}

export type GetEnfinStatusQueryVariables = Exact<{
  providerId: Scalars["String"]["input"]
}>

export type GetEnfinStatusQuery = {
  __typename?: "Query"
  getEnfinApplicationDetails: {
    __typename?: "EnfinApplicationDetails"
    appStatus: string
  }
}

export type AllGlBorrowerFieldsFragment = {
  __typename?: "GoodleapLoanDetails"
  borrower: {
    __typename?: "GoodleapBorrower"
    firstName: string
    lastName: string
    email: string
    phones: Array<{ __typename?: "Phone"; value: string; type: Phone_Type }>
    address: {
      __typename?: "Address"
      street: string
      street2: string | null
      city: string
      state: StateCode
      zip: string
    }
  }
  coBorrower: {
    __typename?: "GoodleapBorrower"
    firstName: string
    lastName: string
    email: string
    phones: Array<{ __typename?: "Phone"; value: string; type: Phone_Type }>
    address: {
      __typename?: "Address"
      street: string
      street2: string | null
      city: string
      state: StateCode
      zip: string
    }
  } | null
}

export type CurrencyFieldsFragment = {
  __typename?: "Currency"
  type: string
  value: number
}

export type AmountFieldsFragment = {
  __typename?: "GoodLeapAmount"
  type: string
  value: number | null
}

export type GetGoodleapStatusQueryVariables = Exact<{
  providerId: Scalars["String"]["input"]
}>

export type GetGoodleapStatusQuery = {
  __typename?: "Query"
  getGoodleapLoanDetails: {
    __typename?: "GoodleapLoanDetails"
    id: string
    createdAt: string
    creditExpiresAt: string
    referenceNumber: string
    status: string
    changes: Array<string> | null
    offerId: string
    installationCategoryId: string
    partnerId: string
    subjectProperty: {
      __typename?: "SubjectProperty"
      address: {
        __typename?: "Address"
        street: string
        street2: string | null
        city: string
        state: StateCode
        zip: string
      }
      mortgageTotalBalances: {
        __typename?: "Currency"
        type: string
        value: number
      } | null
      mortgageTotalPayments: {
        __typename?: "Currency"
        type: string
        value: number
      } | null
    }
    amount: {
      __typename?: "GoodLeapAmount"
      type: string
      value: number | null
    } | null
    maxAmount: {
      __typename?: "GoodLeapAmount"
      type: string
      value: number | null
    } | null
    monthlyPayment: {
      __typename?: "GoodLeapAmount"
      type: string
      value: number | null
    } | null
    estimatedInitialMonthlyPayment: {
      __typename?: "GoodLeapAmount"
      type: string
      value: number | null
    }
    enrollments: Array<{ __typename?: "GoodleapEnrollment"; name: string }>
    borrower: {
      __typename?: "GoodleapBorrower"
      firstName: string
      lastName: string
      email: string
      phones: Array<{ __typename?: "Phone"; value: string; type: Phone_Type }>
      address: {
        __typename?: "Address"
        street: string
        street2: string | null
        city: string
        state: StateCode
        zip: string
      }
    }
    coBorrower: {
      __typename?: "GoodleapBorrower"
      firstName: string
      lastName: string
      email: string
      phones: Array<{ __typename?: "Phone"; value: string; type: Phone_Type }>
      address: {
        __typename?: "Address"
        street: string
        street2: string | null
        city: string
        state: StateCode
        zip: string
      }
    } | null
  }
  getGoodleapStipulations: Array<{
    __typename?: "GoodleapStipulationDetailed"
    id: string
    name: string
    description: string | null
    reasonCodes: Array<string>
    status: string
    type: string
    documentsToClear: Array<any> | null
    attachments: Array<any> | null
    createdAt: string
    updatedAt: string
    domain: string
    appliesTo: string | null
  }>
}

export type GetSungageStatusQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetSungageStatusQuery = {
  __typename?: "Query"
  getSungageApplicationDetails: {
    __typename?: "SungageApplicationDetails"
    status: string
    stipulations: Array<string> | null
  }
}

export type AllActiveLoanFieldsFragment = {
  __typename?: "ActiveLoan"
  id: string
  createdAt: any
  updatedAt: any
  loanDocsSentAt: any | null
  proposalId: string
  loanProductId: string
  amount: number
  status: ActiveLoanStatus | null
  provider: LoanProvider
  providerId: string
  providerMetadata: any | null
  providerStatusEvents: Array<any> | null
  applicants: Array<{
    __typename?: "Applicant"
    id: string
    email: string
    firstName: string
    lastName: string
    isPrimary: boolean
  }> | null
}

export type SendDocumentsForActiveLoanMutationVariables = Exact<{
  activeLoanId: Scalars["ID"]["input"]
}>

export type SendDocumentsForActiveLoanMutation = {
  __typename?: "Mutation"
  sendLoanDocuments: {
    __typename?: "ActiveLoan"
    id: string
    createdAt: any
    updatedAt: any
    loanDocsSentAt: any | null
    proposalId: string
    loanProductId: string
    amount: number
    status: ActiveLoanStatus | null
    provider: LoanProvider
    providerId: string
    providerMetadata: any | null
    providerStatusEvents: Array<any> | null
    applicants: Array<{
      __typename?: "Applicant"
      id: string
      email: string
      firstName: string
      lastName: string
      isPrimary: boolean
    }> | null
  }
}

export type AllBrochureFieldsFragment = {
  __typename?: "Brochure"
  id: string
  proposalId: string
  createdAt: any
  updatedAt: any
  annualSolarProduction: number
  baseGenabilityUtilityRate: number
  dialUtilityRates: Array<number>
  energyOffset: number
  userAdjustedUtilityRate: number | null
  utilityRateEscalationPercentage: number
  months: Array<{
    __typename?: "BrochureMonth"
    month: string
    production_kWh: number
    import_kWh: number
    export_kWh: number
    postSolarUtilityCost_USD: number
    postSolarEnergyCost_USD: number
    postSolarFixedCost_USD: number
    postSolarLoanPayment_USD: number
    preSolarUtilityCost_USD: number
    preSolarEnergyCost_USD: number
    preSolarFixedCost_USD: number
  }>
  afterSolarUtilityBills: Array<{
    __typename?: "BrochureUtilityBill"
    sortOrder: number
    bill: number
    energy: number
    fixed: number
    payment: number | null
  }>
  beforeSolarUtilityBills: Array<{
    __typename?: "BrochureUtilityBill"
    sortOrder: number
    bill: number
    energy: number
    fixed: number
    payment: number | null
  }>
}

export type BrochureUtilityBillFieldsFragment = {
  __typename?: "BrochureUtilityBill"
  sortOrder: number
  bill: number
  energy: number
  fixed: number
  payment: number | null
}

export type BrochureMonthFieldsFragment = {
  __typename?: "BrochureMonth"
  month: string
  production_kWh: number
  import_kWh: number
  export_kWh: number
  postSolarUtilityCost_USD: number
  postSolarEnergyCost_USD: number
  postSolarFixedCost_USD: number
  postSolarLoanPayment_USD: number
  preSolarUtilityCost_USD: number
  preSolarEnergyCost_USD: number
  preSolarFixedCost_USD: number
}

export type GetBrochureQueryVariables = Exact<{
  proposalId: Scalars["ID"]["input"]
}>

export type GetBrochureQuery = {
  __typename?: "Query"
  getBrochure: {
    __typename?: "Brochure"
    id: string
    proposalId: string
    createdAt: any
    updatedAt: any
    annualSolarProduction: number
    baseGenabilityUtilityRate: number
    dialUtilityRates: Array<number>
    energyOffset: number
    userAdjustedUtilityRate: number | null
    utilityRateEscalationPercentage: number
    months: Array<{
      __typename?: "BrochureMonth"
      month: string
      production_kWh: number
      import_kWh: number
      export_kWh: number
      postSolarUtilityCost_USD: number
      postSolarEnergyCost_USD: number
      postSolarFixedCost_USD: number
      postSolarLoanPayment_USD: number
      preSolarUtilityCost_USD: number
      preSolarEnergyCost_USD: number
      preSolarFixedCost_USD: number
    }>
    afterSolarUtilityBills: Array<{
      __typename?: "BrochureUtilityBill"
      sortOrder: number
      bill: number
      energy: number
      fixed: number
      payment: number | null
    }>
    beforeSolarUtilityBills: Array<{
      __typename?: "BrochureUtilityBill"
      sortOrder: number
      bill: number
      energy: number
      fixed: number
      payment: number | null
    }>
  } | null
}

export type GetContractVersionHistoryForProposalQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetContractVersionHistoryForProposalQuery = {
  __typename?: "Query"
  contractVersionHistoryForProposal: Array<{
    __typename?: "ContractVersionHistory"
    versionNumber: number
    isVoid: boolean
    isSigned: boolean
    systemSize: number | null
    totalCost: number | null
    sentAt: any | null
    recipientEmail: string | null
  }>
}

export type AllContractFieldsFragment = {
  __typename?: "Contract"
  id: string
  createdAt: any
  updatedAt: any
  dateSent: any | null
  dateSigned: any | null
  dateSentToPowurOs: any | null
  recipientEmail: string | null
  totalCost: number | null
  systemSize: number | null
  envelopeId: string | null
  proposalId: string
  contractType: string
  contractPackageVersion: number
}

export type GetContractsForProposalQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetContractsForProposalQuery = {
  __typename?: "Query"
  contractsForProposal: Array<{
    __typename?: "Contract"
    id: string
    createdAt: any
    updatedAt: any
    dateSent: any | null
    dateSigned: any | null
    dateSentToPowurOs: any | null
    recipientEmail: string | null
    totalCost: number | null
    systemSize: number | null
    envelopeId: string | null
    proposalId: string
    contractType: string
    contractPackageVersion: number
  }>
}

export type ResendContractMutationVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type ResendContractMutation = {
  __typename?: "Mutation"
  resendContract: {
    __typename?: "Contract"
    id: string
    createdAt: any
    updatedAt: any
    dateSent: any | null
    dateSigned: any | null
    dateSentToPowurOs: any | null
    recipientEmail: string | null
    totalCost: number | null
    systemSize: number | null
    envelopeId: string | null
    proposalId: string
    contractType: string
    contractPackageVersion: number
  }
}

export type SendSupplementalContractMutationVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type SendSupplementalContractMutation = {
  __typename?: "Mutation"
  sendSupplementalContract: {
    __typename?: "Contract"
    id: string
    createdAt: any
    updatedAt: any
    dateSent: any | null
    dateSigned: any | null
    dateSentToPowurOs: any | null
    recipientEmail: string | null
    totalCost: number | null
    systemSize: number | null
    envelopeId: string | null
    proposalId: string
    contractType: string
    contractPackageVersion: number
  }
}

export type MosaicListDisclosuresQueryVariables = Exact<{
  input: MosaicGetDisclosuresBodyDto
}>

export type MosaicListDisclosuresQuery = {
  __typename?: "Query"
  mosaicListDisclosures: {
    __typename?: "MosaicGetDisclosuresResponseDto"
    bundleId: string
    disclosures: Array<{
      __typename?: "MosaicDisclosuresArrayDto"
      assetCode: string | null
      version: string
      assetType: string
      title: string
      scope: string
      contents: Array<{
        __typename?: "MosaicDisclosuresContentArrayDto"
        contentType: string
        title: string
        data: string
      }>
    }>
  }
}

export type GetEnfinFrameQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetEnfinFrameQuery = { __typename?: "Query"; getEnfinFrame: string }

export type GetSungageFrameQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetSungageFrameQuery = {
  __typename?: "Query"
  getSungageFrame: string
}

export type GetSunlightFrameQueryVariables = Exact<{
  input: GetSunlightIframeUrlDto
}>

export type GetSunlightFrameQuery = {
  __typename?: "Query"
  getSunlightFrame: string
}

export type GetGoodLeapDisclosuresQueryVariables = Exact<{
  category: InputMaybe<Scalars["String"]["input"]>
}>

export type GetGoodLeapDisclosuresQuery = {
  __typename?: "Query"
  getGoodLeapDisclosures: {
    __typename?: "GoodLeapGetDisclosuresResponseDto"
    data: Array<{
      __typename?: "GoodLeapDisclosuresDataArrayDto"
      token: string | null
      tokenExpiresAt: string | null
      current: boolean
      id: string
      sections: Array<{
        __typename?: "GoodLeapDisclosuresSectionArrayDto"
        signatureBox: boolean
        boldText: boolean
        checkbox: boolean
        text: string
        sort: number
      }>
      meta: {
        __typename?: "GoodLeapDisclosuresMetaObjectDto"
        cursor: string | null
      }
    }>
    links: {
      __typename?: "GoodleapDisclosuresLinks"
      next: string | null
      prev: string | null
    }
  }
}

export type SendCreditApplicationMutationVariables = Exact<{
  sendCreditApplicationInput: SendCreditApplicationInput
}>

export type SendCreditApplicationMutation = {
  __typename?: "Mutation"
  sendCreditApplication:
    | {
        __typename: "GoodLeapCreateLoanResponseDto"
        offerId: string | null
        referenceNumber: string
        sentLoanDocuments: boolean
        status: string
        type: string | null
        approvedLoanAmount: {
          __typename?: "Currency"
          type: string
          value: number
        } | null
        requestedLoanAmount: {
          __typename?: "Currency"
          type: string
          value: number
        } | null
        stipulations: Array<{
          __typename?: "Stipulation"
          appliesTo: string | null
          createdAt: string | null
          deferred: boolean | null
          description: string | null
          domain: string
          id: string
          name: string
          reasonCodes: Array<string>
          status: string
          type: string
          updatedAt: string | null
          updatedBy: string | null
          attachments: Array<{
            __typename?: "Attachment"
            extension: string
            groupId: string
            id: string
            label: string
            name: string
            status: string
            type: string
          }>
          documentsToClear: Array<{
            __typename?: "Document"
            description: string
            name: string
            type: string
          }>
        }>
      }
    | {
        __typename: "MosaicPostApplicationResponseDto"
        application: {
          __typename?: "MosaicApplicationDto"
          id: string
          status: string
        }
      }
}

export type AddNoteDesignRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}>

export type AddNoteDesignRequestMutation = {
  __typename?: "Mutation"
  addNoteDesignRequest: {
    __typename?: "DesignRequest"
    completedAt: any | null
    createdAt: any
    rejectedAt: any | null
    designUserId: string | null
    enterpriseId: string | null
    id: string
    priority: number
    promisedAt: any | null
    updatedAt: any
    design: { __typename?: "Design"; id: string } | null
    designNotes: Array<{
      __typename?: "DesignNote"
      createdAt: any
      createdById: string
      designRequestId: string
      id: string
      message: string
      reason: string | null
      updatedAt: any
    }>
  }
}

export type CancelDesignRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type CancelDesignRequestMutation = {
  __typename?: "Mutation"
  cancelDesignRequest: { __typename?: "DesignRequest"; id: string }
}

export type ClaimNextDesignRequestMutationVariables = Exact<{
  [key: string]: never
}>

export type ClaimNextDesignRequestMutation = {
  __typename?: "Mutation"
  claimNextDesignRequest: {
    __typename?: "DesignRequest"
    design: { __typename?: "Design"; id: string } | null
  }
}

export type DesignRequestClaimedUntilMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DesignRequestClaimedUntilMutation = {
  __typename?: "Mutation"
  designRequestClaimedUntil: any
}

export type CompleteDesignRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type CompleteDesignRequestMutation = {
  __typename?: "Mutation"
  completeDesignRequest: {
    __typename?: "DesignRequest"
    id: string
    design: { __typename?: "Design"; id: string } | null
  }
}

export type CompleteAndClaimNextDesignRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type CompleteAndClaimNextDesignRequestMutation = {
  __typename?: "Mutation"
  completeDesignRequestAndClaimNext: {
    __typename?: "DesignRequest"
    id: string
    design: { __typename?: "Design"; id: string } | null
  }
}

export type CreateDesignRequestMutationVariables = Exact<{
  proposalId: Scalars["ID"]["input"]
  initialMessage: InputMaybe<Scalars["String"]["input"]>
  requestType: InputMaybe<Scalars["String"]["input"]>
}>

export type CreateDesignRequestMutation = {
  __typename?: "Mutation"
  createDesignRequest: {
    __typename?: "DesignRequest"
    completedAt: any | null
    createdAt: any
    rejectedAt: any | null
    designUserId: string | null
    enterpriseId: string | null
    id: string
    priority: number
    promisedAt: any | null
    updatedAt: any
    design: { __typename?: "Design"; id: string } | null
    designNotes: Array<{
      __typename?: "DesignNote"
      createdAt: any
      createdById: string
      designRequestId: string
      id: string
      message: string
      reason: string | null
      updatedAt: any
    }>
  }
}

export type DuplicateDesignRequestMutationVariables = Exact<{
  designRequestId: Scalars["ID"]["input"]
  message: InputMaybe<Scalars["String"]["input"]>
}>

export type DuplicateDesignRequestMutation = {
  __typename?: "Mutation"
  duplicateDesignRequest: {
    __typename?: "DesignRequest"
    id: string
    design: { __typename?: "Design"; id: string } | null
  }
}

export type EscalateDesignRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}>

export type EscalateDesignRequestMutation = {
  __typename?: "Mutation"
  escalateDesignRequest: {
    __typename?: "DesignRequest"
    id: string
    design: { __typename?: "Design"; id: string } | null
  }
}

export type EscalateDesignRequestAndClaimNextMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}>

export type EscalateDesignRequestAndClaimNextMutation = {
  __typename?: "Mutation"
  escalateDesignRequestAndClaimNext: {
    __typename?: "DesignRequest"
    id: string
    design: { __typename?: "Design"; id: string } | null
  }
}

export type AllDesignRequestFieldsFragment = {
  __typename?: "DesignRequest"
  completedAt: any | null
  createdAt: any
  rejectedAt: any | null
  designUserId: string | null
  enterpriseId: string | null
  id: string
  priority: number
  promisedAt: any | null
  updatedAt: any
  design: { __typename?: "Design"; id: string } | null
  designNotes: Array<{
    __typename?: "DesignNote"
    createdAt: any
    createdById: string
    designRequestId: string
    id: string
    message: string
    reason: string | null
    updatedAt: any
  }>
}

export type AllDesignNoteFieldsFragment = {
  __typename?: "DesignNote"
  createdAt: any
  createdById: string
  designRequestId: string
  id: string
  message: string
  reason: string | null
  updatedAt: any
}

export type AllDesignUserFieldsFragment = {
  __typename?: "DesignUser"
  completedAt: any | null
  createdAt: any
  designId: string
  id: string
  startedAt: any | null
  updatedAt: any
  userId: string
  designRequests: Array<{
    __typename?: "DesignRequest"
    completedAt: any | null
    createdAt: any
    rejectedAt: any | null
    designUserId: string | null
    enterpriseId: string | null
    id: string
    priority: number
    promisedAt: any | null
    updatedAt: any
    design: { __typename?: "Design"; id: string } | null
    designNotes: Array<{
      __typename?: "DesignNote"
      createdAt: any
      createdById: string
      designRequestId: string
      id: string
      message: string
      reason: string | null
      updatedAt: any
    }>
  }>
}

export type AllDesignRequestWithDesignFieldsFragment = {
  __typename?: "DesignRequest"
  completedAt: any | null
  createdAt: any
  rejectedAt: any | null
  designUserId: string | null
  enterpriseId: string | null
  id: string
  priority: number
  promisedAt: any | null
  updatedAt: any
  design: {
    __typename: "Design"
    activatedAt: any | null
    createdAt: any
    edges: any
    id: string
    installAreas: any
    installAreasToPanels: any
    nodes: any
    obstructions: any
    setbacks: any
    panels: any
    completedAt: any | null
    phase: string
    proposalId: string
    shadingAreas: any
    tool: string
    type: string | null
    updatedAt: any
    homeownerRebate: boolean
    homeownerRebateAmount: number
    treeTrimmingRebate: boolean
    treeTrimmingRebateAmount: number
    energyEfficiencyKitRebate: boolean
    energyEfficiencyKitRebateAmount: number
    roofWorkRebate: boolean
    roofWorkRebateAmount: number
    source: DesignSource
    annualProduction: number | null
    annualOffset: number | null
    systemSizeKw: number | null
    extendedWarrantyPowurOsId: number | null
    extendedWarrantyName: string | null
    extendedWarrantySpanishName: string | null
    extendedWarrantyFamily: string | null
    extendedWarrantyCost: number | null
    brochurePositionX: number
    brochurePositionY: number
    brochureZoom: number
    evOutlet: boolean
    evCharger: boolean
    displayImageryProvider: ImagerySource
    designRequestId: string | null
    sunroofCheckedAt: any | null
    openSolarImage: {
      __typename?: "Imagery"
      id: string
      filename: string
      height: number | null
      width: number | null
    } | null
    optimalEstimate:
      | {
          __typename: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        }
      | {
          __typename: "PoisonedEstimate"
          id: string
          createdAt: any
          updatedAt: any
          data: any
          reason: string
          estimate: {
            __typename?: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          } | null
        }
      | null
    poison: { __typename?: "Poison"; reason: string; data: any } | null
  } | null
  designNotes: Array<{
    __typename?: "DesignNote"
    createdAt: any
    createdById: string
    designRequestId: string
    id: string
    message: string
    reason: string | null
    updatedAt: any
  }>
  designUser: {
    __typename?: "DesignUser"
    completedAt: any | null
    createdAt: any
    designId: string
    id: string
    startedAt: any | null
    updatedAt: any
    userId: string
    designRequests: Array<{
      __typename?: "DesignRequest"
      completedAt: any | null
      createdAt: any
      rejectedAt: any | null
      designUserId: string | null
      enterpriseId: string | null
      id: string
      priority: number
      promisedAt: any | null
      updatedAt: any
      design: { __typename?: "Design"; id: string } | null
      designNotes: Array<{
        __typename?: "DesignNote"
        createdAt: any
        createdById: string
        designRequestId: string
        id: string
        message: string
        reason: string | null
        updatedAt: any
      }>
    }>
  } | null
}

export type GetDesignerDataByRequestIdQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetDesignerDataByRequestIdQuery = {
  __typename?: "Query"
  designerDataByRequestId: {
    __typename?: "DesignRequest"
    id: string
    createdAt: any
    updatedAt: any
    design: {
      __typename: "Design"
      id: string
      activatedAt: any | null
      createdAt: any
      edges: any
      installAreas: any
      installAreasToPanels: any
      nodes: any
      obstructions: any
      setbacks: any
      panels: any
      completedAt: any | null
      phase: string
      proposalId: string
      shadingAreas: any
      tool: string
      type: string | null
      updatedAt: any
      homeownerRebate: boolean
      homeownerRebateAmount: number
      treeTrimmingRebate: boolean
      treeTrimmingRebateAmount: number
      energyEfficiencyKitRebate: boolean
      energyEfficiencyKitRebateAmount: number
      roofWorkRebate: boolean
      roofWorkRebateAmount: number
      source: DesignSource
      annualProduction: number | null
      annualOffset: number | null
      systemSizeKw: number | null
      extendedWarrantyPowurOsId: number | null
      extendedWarrantyName: string | null
      extendedWarrantySpanishName: string | null
      extendedWarrantyFamily: string | null
      extendedWarrantyCost: number | null
      brochurePositionX: number
      brochurePositionY: number
      brochureZoom: number
      evOutlet: boolean
      evCharger: boolean
      displayImageryProvider: ImagerySource
      designRequestId: string | null
      sunroofCheckedAt: any | null
      batteryCompatibility: boolean
      solarModuleId: number | null
      inverterId: number | null
      secondaryInverterId: number | null
      inverterManufacturer: string | null
      energyBackupId: number | null
      openSolarImage: {
        __typename?: "Imagery"
        id: string
        filename: string
        height: number | null
        width: number | null
      } | null
      optimalEstimate:
        | {
            __typename: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          }
        | {
            __typename: "PoisonedEstimate"
            id: string
            createdAt: any
            updatedAt: any
            data: any
            reason: string
            estimate: {
              __typename?: "Estimate"
              acAnnual: number
              acMonthly: Array<number>
              createdAt: any
              updatedAt: any
              errors: Array<string>
              id: string
              designId: string | null
              installAreaId: string | null
              solarProfileId: string | null
              acHourly: Array<number>
              solarProfile: {
                __typename?: "GenabilityProfile"
                id: string
                createdAt: any
                updatedAt: any
                type: GenabilityProfileType
                providerProfileId: string
                profileId: string
              } | null
              inputs: {
                __typename?: "PVWatts_Inputs"
                array_type: string
                azimuth: number
                dc_ac_ratio: number | null
                inv_eff: number | null
                lat: number
                lon: number
                losses: number
                module_type: string
                system_capacity: number | null
                tilt: number | null
              } | null
              sscInfo: {
                __typename?: "SscInfo"
                build: string
                version: number
              } | null
              stationInfo: {
                __typename?: "StationInfo"
                city: string
                distance: number | null
                elev: number
                lat: number
                location: string
                lon: number
                solar_resource_file: string
                state: string
                tz: number
              } | null
            } | null
          }
        | null
      poison: { __typename?: "Poison"; reason: string; data: any } | null
      solarModule: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      } | null
      inverter: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      } | null
      secondaryInverter: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      } | null
      designEquipment: Array<{
        __typename?: "DesignEquipmentObject"
        id: string
        createdAt: any
        updatedAt: any
        designId: string
        equipmentId: number
        powurOsEquipmentTypeId: number
        quantity: number
        price: number
        equipment: {
          __typename?: "PricedEquipment"
          id: number
          createdAt: any
          updatedAt: any
          name: string
          catalogNumber: string | null
          wattage: number | null
          powurOsEquipmentTypeId: number
          equipmentTypeId: string
          fallbackPrice: number | null
          powurOsManufacturerId: number
          manufacturerId: string
          warranty: any | null
          parentEquipmentAssociations: any
          childEquipmentAssociations: any
          height: number | null
          width: number | null
          cecWeightedEfficiency: number
          powurOsModuleDataId: number | null
          moduleData: any | null
          powurOsEnergyBackupDataId: number | null
          energyBackupData: any | null
          powurOsInverterDataId: number | null
          inverterData: any | null
          currentProposalPrice: number
          proposalPrices: Array<any>
          description: string | null
          isKit: boolean
          equipmentType: {
            __typename?: "EquipmentType"
            id: string
            createdAt: any
            updatedAt: any
            powurOsId: number
            name: string
          }
          manufacturer: {
            __typename?: "Manufacturer"
            id: string
            createdAt: any
            updatedAt: any
            powurOsId: number
            name: string
          }
          basicAdderAssociations: Array<{
            __typename?: "BasicAdderAssociation"
            adderId: number
            equipmentId: number
            qty: number
          }>
          compatibleInverterManufacturers: Array<{
            __typename?: "CompatibleManufacturer"
            manufacturerId: number
          }>
        }
      }>
      energyBackup: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      } | null
      profiles: Array<{
        __typename?: "GenabilityProfile"
        id: string
        createdAt: any
        updatedAt: any
        type: GenabilityProfileType
        providerProfileId: string
        profileId: string
      }>
    } | null
    designNotes: Array<{
      __typename?: "DesignNote"
      id: string
      createdAt: any
      createdById: string
      message: string
      reason: string | null
    }>
    designUser: { __typename?: "DesignUser"; id: string; userId: string } | null
  }
}

export type PauseDesignRequestMutationVariables = Exact<{
  pauseDesignRequestInput: PauseDesignRequestInput
}>

export type PauseDesignRequestMutation = {
  __typename?: "Mutation"
  pauseDesignRequest: {
    __typename?: "DesignRequest"
    id: string
    pausedUntil: any | null
    timeAdded: number | null
    designNotes: Array<{
      __typename?: "DesignNote"
      reason: string | null
      message: string
    }>
  }
}

export type RejectDesignRequestMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
  message: Scalars["String"]["input"]
}>

export type RejectDesignRequestMutation = {
  __typename?: "Mutation"
  rejectDesignRequest: { __typename?: "DesignRequest"; id: string }
}

export type RequestDesignRevisionMutationVariables = Exact<{
  input: DesignRevisionInput
}>

export type RequestDesignRevisionMutation = {
  __typename?: "Mutation"
  requestDesignRevision: {
    __typename?: "Design"
    designRequest: { __typename?: "DesignRequest"; id: string } | null
  }
}

export type ActivateDesignMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type ActivateDesignMutation = {
  __typename?: "Mutation"
  activateDesign: {
    __typename: "Design"
    activatedAt: any | null
    createdAt: any
    edges: any
    id: string
    installAreas: any
    installAreasToPanels: any
    nodes: any
    obstructions: any
    setbacks: any
    panels: any
    completedAt: any | null
    phase: string
    proposalId: string
    shadingAreas: any
    tool: string
    type: string | null
    updatedAt: any
    homeownerRebate: boolean
    homeownerRebateAmount: number
    treeTrimmingRebate: boolean
    treeTrimmingRebateAmount: number
    energyEfficiencyKitRebate: boolean
    energyEfficiencyKitRebateAmount: number
    roofWorkRebate: boolean
    roofWorkRebateAmount: number
    source: DesignSource
    annualProduction: number | null
    annualOffset: number | null
    systemSizeKw: number | null
    extendedWarrantyPowurOsId: number | null
    extendedWarrantyName: string | null
    extendedWarrantySpanishName: string | null
    extendedWarrantyFamily: string | null
    extendedWarrantyCost: number | null
    brochurePositionX: number
    brochurePositionY: number
    brochureZoom: number
    evOutlet: boolean
    evCharger: boolean
    displayImageryProvider: ImagerySource
    designRequestId: string | null
    sunroofCheckedAt: any | null
    batteryCompatibility: boolean
    solarModuleId: number | null
    inverterId: number | null
    secondaryInverterId: number | null
    inverterManufacturer: string | null
    energyBackupId: number | null
    openSolarImage: {
      __typename?: "Imagery"
      id: string
      filename: string
      height: number | null
      width: number | null
    } | null
    optimalEstimate:
      | {
          __typename: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        }
      | {
          __typename: "PoisonedEstimate"
          id: string
          createdAt: any
          updatedAt: any
          data: any
          reason: string
          estimate: {
            __typename?: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          } | null
        }
      | null
    poison: { __typename?: "Poison"; reason: string; data: any } | null
    solarModule: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    inverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    secondaryInverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    designEquipment: Array<{
      __typename?: "DesignEquipmentObject"
      id: string
      createdAt: any
      updatedAt: any
      designId: string
      equipmentId: number
      powurOsEquipmentTypeId: number
      quantity: number
      price: number
      equipment: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      }
    }>
    energyBackup: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    profiles: Array<{
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      providerProfileId: string
      profileId: string
    }>
  }
}

export type DesignQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DesignQuery = {
  __typename?: "Query"
  design: {
    __typename: "Design"
    activatedAt: any | null
    createdAt: any
    edges: any
    id: string
    installAreas: any
    installAreasToPanels: any
    nodes: any
    obstructions: any
    setbacks: any
    panels: any
    completedAt: any | null
    phase: string
    proposalId: string
    shadingAreas: any
    tool: string
    type: string | null
    updatedAt: any
    homeownerRebate: boolean
    homeownerRebateAmount: number
    treeTrimmingRebate: boolean
    treeTrimmingRebateAmount: number
    energyEfficiencyKitRebate: boolean
    energyEfficiencyKitRebateAmount: number
    roofWorkRebate: boolean
    roofWorkRebateAmount: number
    source: DesignSource
    annualProduction: number | null
    annualOffset: number | null
    systemSizeKw: number | null
    extendedWarrantyPowurOsId: number | null
    extendedWarrantyName: string | null
    extendedWarrantySpanishName: string | null
    extendedWarrantyFamily: string | null
    extendedWarrantyCost: number | null
    brochurePositionX: number
    brochurePositionY: number
    brochureZoom: number
    evOutlet: boolean
    evCharger: boolean
    displayImageryProvider: ImagerySource
    designRequestId: string | null
    sunroofCheckedAt: any | null
    batteryCompatibility: boolean
    solarModuleId: number | null
    inverterId: number | null
    secondaryInverterId: number | null
    inverterManufacturer: string | null
    energyBackupId: number | null
    openSolarImage: {
      __typename?: "Imagery"
      id: string
      filename: string
      height: number | null
      width: number | null
    } | null
    optimalEstimate:
      | {
          __typename: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        }
      | {
          __typename: "PoisonedEstimate"
          id: string
          createdAt: any
          updatedAt: any
          data: any
          reason: string
          estimate: {
            __typename?: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          } | null
        }
      | null
    poison: { __typename?: "Poison"; reason: string; data: any } | null
    solarModule: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    inverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    secondaryInverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    designEquipment: Array<{
      __typename?: "DesignEquipmentObject"
      id: string
      createdAt: any
      updatedAt: any
      designId: string
      equipmentId: number
      powurOsEquipmentTypeId: number
      quantity: number
      price: number
      equipment: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      }
    }>
    energyBackup: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    profiles: Array<{
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      providerProfileId: string
      profileId: string
    }>
  }
}

export type DesignGenabilityStorageIdQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type DesignGenabilityStorageIdQuery = {
  __typename?: "Query"
  design: {
    __typename?: "Design"
    profiles: Array<{
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      profileId: string
      providerProfileId: string
    }>
  }
}

export type GetDesignsQueryVariables = Exact<{
  designsInput: DesignsInput
}>

export type GetDesignsQuery = {
  __typename?: "Query"
  designs: Array<{
    __typename: "Design"
    activatedAt: any | null
    createdAt: any
    edges: any
    id: string
    installAreas: any
    installAreasToPanels: any
    nodes: any
    obstructions: any
    setbacks: any
    panels: any
    completedAt: any | null
    phase: string
    proposalId: string
    shadingAreas: any
    tool: string
    type: string | null
    updatedAt: any
    homeownerRebate: boolean
    homeownerRebateAmount: number
    treeTrimmingRebate: boolean
    treeTrimmingRebateAmount: number
    energyEfficiencyKitRebate: boolean
    energyEfficiencyKitRebateAmount: number
    roofWorkRebate: boolean
    roofWorkRebateAmount: number
    source: DesignSource
    annualProduction: number | null
    annualOffset: number | null
    systemSizeKw: number | null
    extendedWarrantyPowurOsId: number | null
    extendedWarrantyName: string | null
    extendedWarrantySpanishName: string | null
    extendedWarrantyFamily: string | null
    extendedWarrantyCost: number | null
    brochurePositionX: number
    brochurePositionY: number
    brochureZoom: number
    evOutlet: boolean
    evCharger: boolean
    displayImageryProvider: ImagerySource
    designRequestId: string | null
    sunroofCheckedAt: any | null
    batteryCompatibility: boolean
    solarModuleId: number | null
    inverterId: number | null
    secondaryInverterId: number | null
    inverterManufacturer: string | null
    energyBackupId: number | null
    openSolarImage: {
      __typename?: "Imagery"
      id: string
      filename: string
      height: number | null
      width: number | null
    } | null
    optimalEstimate:
      | {
          __typename: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        }
      | {
          __typename: "PoisonedEstimate"
          id: string
          createdAt: any
          updatedAt: any
          data: any
          reason: string
          estimate: {
            __typename?: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          } | null
        }
      | null
    poison: { __typename?: "Poison"; reason: string; data: any } | null
    solarModule: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    inverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    secondaryInverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    designEquipment: Array<{
      __typename?: "DesignEquipmentObject"
      id: string
      createdAt: any
      updatedAt: any
      designId: string
      equipmentId: number
      powurOsEquipmentTypeId: number
      quantity: number
      price: number
      equipment: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      }
    }>
    energyBackup: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    profiles: Array<{
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      providerProfileId: string
      profileId: string
    }>
  }>
}

export type ResetDesignMutationVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type ResetDesignMutation = {
  __typename?: "Mutation"
  resetDesign: {
    __typename: "Design"
    activatedAt: any | null
    createdAt: any
    edges: any
    id: string
    installAreas: any
    installAreasToPanels: any
    nodes: any
    obstructions: any
    setbacks: any
    panels: any
    completedAt: any | null
    phase: string
    proposalId: string
    shadingAreas: any
    tool: string
    type: string | null
    updatedAt: any
    homeownerRebate: boolean
    homeownerRebateAmount: number
    treeTrimmingRebate: boolean
    treeTrimmingRebateAmount: number
    energyEfficiencyKitRebate: boolean
    energyEfficiencyKitRebateAmount: number
    roofWorkRebate: boolean
    roofWorkRebateAmount: number
    source: DesignSource
    annualProduction: number | null
    annualOffset: number | null
    systemSizeKw: number | null
    extendedWarrantyPowurOsId: number | null
    extendedWarrantyName: string | null
    extendedWarrantySpanishName: string | null
    extendedWarrantyFamily: string | null
    extendedWarrantyCost: number | null
    brochurePositionX: number
    brochurePositionY: number
    brochureZoom: number
    evOutlet: boolean
    evCharger: boolean
    displayImageryProvider: ImagerySource
    designRequestId: string | null
    sunroofCheckedAt: any | null
    batteryCompatibility: boolean
    solarModuleId: number | null
    inverterId: number | null
    secondaryInverterId: number | null
    inverterManufacturer: string | null
    energyBackupId: number | null
    openSolarImage: {
      __typename?: "Imagery"
      id: string
      filename: string
      height: number | null
      width: number | null
    } | null
    optimalEstimate:
      | {
          __typename: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        }
      | {
          __typename: "PoisonedEstimate"
          id: string
          createdAt: any
          updatedAt: any
          data: any
          reason: string
          estimate: {
            __typename?: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          } | null
        }
      | null
    poison: { __typename?: "Poison"; reason: string; data: any } | null
    solarModule: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    inverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    secondaryInverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    designEquipment: Array<{
      __typename?: "DesignEquipmentObject"
      id: string
      createdAt: any
      updatedAt: any
      designId: string
      equipmentId: number
      powurOsEquipmentTypeId: number
      quantity: number
      price: number
      equipment: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      }
    }>
    energyBackup: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    profiles: Array<{
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      providerProfileId: string
      profileId: string
    }>
  }
}

export type SavingsQueryVariables = Exact<{
  designId: Scalars["ID"]["input"]
}>

export type SavingsQuery = {
  __typename?: "Query"
  savingsForDesignId:
    | {
        __typename: "PoisonedSavings"
        id: string
        createdAt: any
        updatedAt: any
        data: any
        reason: string
        savings: {
          __typename?: "Savings"
          designId: string
          createdAt: any
          updatedAt: any
          id: string
          inputs: {
            __typename?: "GenabilityAccountAnalysisInputs"
            projectDuration: number
            preSolarMasterTariffId: number
            postSolarMasterTariffId: number
            rateInflation: number
            solarDegradation: number
            fromDateTime: string | null
            genabilityAccountId: string
            optimizedConsumptionProviderProfileId: string | null
            optimizedProductionProviderProfileId: string | null
            consumptionProviderProfileId: string | null
            storageProviderProfileId: string | null
            productionProviderProfileIds: Array<string> | null
            userAdjustedRate: number | null
          }
          outputs: {
            __typename?: "GenabilityAccountAnalysis"
            designId: string | null
            dataStatus: number
            currency: string | null
            summary: {
              __typename?: "GenabilityAccountAnalysisSummary"
              lifeTimeUtilityAfterCost: number | null
              lifeTimeUtilityAvoidedRate: number | null
              lifetimeAvoidedCost: number | null
              lifetimeSolarCost: number | null
              lifetimeWithoutCost: number | null
              netAvoidedCost: number | null
              netAvoidedCostPctOffset: number | null
              netAvoidedKWh: number | null
              netAvoidedKWhPctOffset: number | null
              netAvoidedRate: number | null
              postTotalCost: number
              postTotalKWh: number
              postTotalKWhCost: number
              postTotalKWhRate: number
              postTotalMinCost: number
              postTotalNonBypassableCost: number | null
              postTotalNonMinCost: number | null
              postTotalRate: number | null
              preTotalCost: number
              preTotalKWh: number
              preTotalKWhCost: number
              preTotalKWhRate: number
              preTotalMinCost: number
              preTotalNonBypassableCost: number
              preTotalNonMinCost: number
              preTotalRate: number
            }
            scenarios: Array<{
              __typename?: "GenabilityScenario"
              id: string | null
              name: string | null
              serviceType: string | null
              inputs: Array<{
                __typename?: "GenabilityPropertyData"
                keyName: string
                displayName: string | null
                dataType: DataType | null
                fromDateTime: string | null
                toDateTime: string | null
                dataValue: string | null
                operator: string | null
              }>
              rates: Array<{
                __typename?: "GenabilityTariffRateSimple"
                fromDateTime: string | null
                toDateTime: string | null
                chargeType: string | null
                chargePeriod: string | null
                rateName: string
                scenarios: string | null
                rateBands: Array<{
                  __typename?: "GenabilityTariffRateBand"
                  tariffRateBandId: number | null
                  tariffRateId: number | null
                  rateSequenceNumber: number | null
                  hasConsumptionLimit: boolean | null
                  hasDemandLimit: boolean | null
                  hasPropertyLimit: boolean | null
                  rateAmount: number | null
                  rateUnit: string | null
                  isCredit: boolean
                }> | null
              }> | null
            }>
            series: Array<{
              __typename?: "GenabilitySeries"
              seriesId: number
              fromDateTime: string
              toDateTime: string
              scenario: string
              displayLabel: string
              seriesPeriod: string
              seriesDuration: number
              designId: string | null
              key: string | null
              rate: number | null
              qty: number
              cost: number
            }>
            seriesData: Array<{
              __typename?: "GenabilitySeriesMeasure"
              seriesId: number
              fromDateTime: string
              toDateTime: string
              rate: number | null
              qty: number
              cost: number
            }>
            seriesCosts: Array<{
              __typename?: "GenabilityCalculatedCost"
              masterTariffId: number
              tariffName: string
              totalCost: number
              fromDateTime: string
              toDateTime: string
              accuracy: number
              currency: string
              calculatedCostId: string | null
              summary: {
                __typename?: "GenabilityCalculatedCostSummary"
                export: number | null
                import: number | null
                nonBypassableCost: number | null
                preTaxMinimumCost: number | null
                subTotalCost: number
                taxCost: number
                totalCost: number
                adjustedTotalCost: number
                kWh: number
                kW: number
                ELECTRICITY: {
                  __typename: "GenabilityKWkWh"
                  kW: number
                  kWh: number
                } | null
              }
              items: Array<{
                __typename?: "GenabilityCalculatedCostItem"
                tariffId: number | null
                tariffRateId: number | null
                tariffRateBandId: number | null
                rateSequenceNumber: number | null
                rateName: string | null
                fromDateTime: string
                toDateTime: string
                quantityKey: string
                quantityKeyDescription: string | null
                rateType: string | null
                tierLowerLimit: number | null
                tierUpperLimit: number | null
                itemQuantity: number
                cost: number | null
                rateProration: number | null
                chargeType: string | null
                chargeClass: string | null
                periodType: string | null
                demandInterval: string | null
                duration: number | null
                touId: number | null
                touName: string | null
                seasonId: number | null
                formula: string | null
                transactionType: string | null
              }>
            }>
          } | null
        }
      }
    | {
        __typename: "Savings"
        designId: string
        createdAt: any
        updatedAt: any
        id: string
        inputs: {
          __typename?: "GenabilityAccountAnalysisInputs"
          projectDuration: number
          preSolarMasterTariffId: number
          postSolarMasterTariffId: number
          rateInflation: number
          solarDegradation: number
          fromDateTime: string | null
          genabilityAccountId: string
          optimizedConsumptionProviderProfileId: string | null
          optimizedProductionProviderProfileId: string | null
          consumptionProviderProfileId: string | null
          storageProviderProfileId: string | null
          productionProviderProfileIds: Array<string> | null
          userAdjustedRate: number | null
        }
        outputs: {
          __typename?: "GenabilityAccountAnalysis"
          designId: string | null
          dataStatus: number
          currency: string | null
          summary: {
            __typename?: "GenabilityAccountAnalysisSummary"
            lifeTimeUtilityAfterCost: number | null
            lifeTimeUtilityAvoidedRate: number | null
            lifetimeAvoidedCost: number | null
            lifetimeSolarCost: number | null
            lifetimeWithoutCost: number | null
            netAvoidedCost: number | null
            netAvoidedCostPctOffset: number | null
            netAvoidedKWh: number | null
            netAvoidedKWhPctOffset: number | null
            netAvoidedRate: number | null
            postTotalCost: number
            postTotalKWh: number
            postTotalKWhCost: number
            postTotalKWhRate: number
            postTotalMinCost: number
            postTotalNonBypassableCost: number | null
            postTotalNonMinCost: number | null
            postTotalRate: number | null
            preTotalCost: number
            preTotalKWh: number
            preTotalKWhCost: number
            preTotalKWhRate: number
            preTotalMinCost: number
            preTotalNonBypassableCost: number
            preTotalNonMinCost: number
            preTotalRate: number
          }
          scenarios: Array<{
            __typename?: "GenabilityScenario"
            id: string | null
            name: string | null
            serviceType: string | null
            inputs: Array<{
              __typename?: "GenabilityPropertyData"
              keyName: string
              displayName: string | null
              dataType: DataType | null
              fromDateTime: string | null
              toDateTime: string | null
              dataValue: string | null
              operator: string | null
            }>
            rates: Array<{
              __typename?: "GenabilityTariffRateSimple"
              fromDateTime: string | null
              toDateTime: string | null
              chargeType: string | null
              chargePeriod: string | null
              rateName: string
              scenarios: string | null
              rateBands: Array<{
                __typename?: "GenabilityTariffRateBand"
                tariffRateBandId: number | null
                tariffRateId: number | null
                rateSequenceNumber: number | null
                hasConsumptionLimit: boolean | null
                hasDemandLimit: boolean | null
                hasPropertyLimit: boolean | null
                rateAmount: number | null
                rateUnit: string | null
                isCredit: boolean
              }> | null
            }> | null
          }>
          series: Array<{
            __typename?: "GenabilitySeries"
            seriesId: number
            fromDateTime: string
            toDateTime: string
            scenario: string
            displayLabel: string
            seriesPeriod: string
            seriesDuration: number
            designId: string | null
            key: string | null
            rate: number | null
            qty: number
            cost: number
          }>
          seriesData: Array<{
            __typename?: "GenabilitySeriesMeasure"
            seriesId: number
            fromDateTime: string
            toDateTime: string
            rate: number | null
            qty: number
            cost: number
          }>
          seriesCosts: Array<{
            __typename?: "GenabilityCalculatedCost"
            masterTariffId: number
            tariffName: string
            totalCost: number
            fromDateTime: string
            toDateTime: string
            accuracy: number
            currency: string
            calculatedCostId: string | null
            summary: {
              __typename?: "GenabilityCalculatedCostSummary"
              export: number | null
              import: number | null
              nonBypassableCost: number | null
              preTaxMinimumCost: number | null
              subTotalCost: number
              taxCost: number
              totalCost: number
              adjustedTotalCost: number
              kWh: number
              kW: number
              ELECTRICITY: {
                __typename: "GenabilityKWkWh"
                kW: number
                kWh: number
              } | null
            }
            items: Array<{
              __typename?: "GenabilityCalculatedCostItem"
              tariffId: number | null
              tariffRateId: number | null
              tariffRateBandId: number | null
              rateSequenceNumber: number | null
              rateName: string | null
              fromDateTime: string
              toDateTime: string
              quantityKey: string
              quantityKeyDescription: string | null
              rateType: string | null
              tierLowerLimit: number | null
              tierUpperLimit: number | null
              itemQuantity: number
              cost: number | null
              rateProration: number | null
              chargeType: string | null
              chargeClass: string | null
              periodType: string | null
              demandInterval: string | null
              duration: number | null
              touId: number | null
              touName: string | null
              seasonId: number | null
              formula: string | null
              transactionType: string | null
            }>
          }>
        } | null
      }
    | null
}

export type UpdateDesignMutationVariables = Exact<{
  input: UpdateDesignInput
}>

export type UpdateDesignMutation = {
  __typename?: "Mutation"
  updateDesign: {
    __typename: "Design"
    activatedAt: any | null
    createdAt: any
    edges: any
    id: string
    installAreas: any
    installAreasToPanels: any
    nodes: any
    obstructions: any
    setbacks: any
    panels: any
    completedAt: any | null
    phase: string
    proposalId: string
    shadingAreas: any
    tool: string
    type: string | null
    updatedAt: any
    homeownerRebate: boolean
    homeownerRebateAmount: number
    treeTrimmingRebate: boolean
    treeTrimmingRebateAmount: number
    energyEfficiencyKitRebate: boolean
    energyEfficiencyKitRebateAmount: number
    roofWorkRebate: boolean
    roofWorkRebateAmount: number
    source: DesignSource
    annualProduction: number | null
    annualOffset: number | null
    systemSizeKw: number | null
    extendedWarrantyPowurOsId: number | null
    extendedWarrantyName: string | null
    extendedWarrantySpanishName: string | null
    extendedWarrantyFamily: string | null
    extendedWarrantyCost: number | null
    brochurePositionX: number
    brochurePositionY: number
    brochureZoom: number
    evOutlet: boolean
    evCharger: boolean
    displayImageryProvider: ImagerySource
    designRequestId: string | null
    sunroofCheckedAt: any | null
    batteryCompatibility: boolean
    solarModuleId: number | null
    inverterId: number | null
    secondaryInverterId: number | null
    inverterManufacturer: string | null
    energyBackupId: number | null
    openSolarImage: {
      __typename?: "Imagery"
      id: string
      filename: string
      height: number | null
      width: number | null
    } | null
    optimalEstimate:
      | {
          __typename: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        }
      | {
          __typename: "PoisonedEstimate"
          id: string
          createdAt: any
          updatedAt: any
          data: any
          reason: string
          estimate: {
            __typename?: "Estimate"
            acAnnual: number
            acMonthly: Array<number>
            createdAt: any
            updatedAt: any
            errors: Array<string>
            id: string
            designId: string | null
            installAreaId: string | null
            solarProfileId: string | null
            acHourly: Array<number>
            solarProfile: {
              __typename?: "GenabilityProfile"
              id: string
              createdAt: any
              updatedAt: any
              type: GenabilityProfileType
              providerProfileId: string
              profileId: string
            } | null
            inputs: {
              __typename?: "PVWatts_Inputs"
              array_type: string
              azimuth: number
              dc_ac_ratio: number | null
              inv_eff: number | null
              lat: number
              lon: number
              losses: number
              module_type: string
              system_capacity: number | null
              tilt: number | null
            } | null
            sscInfo: {
              __typename?: "SscInfo"
              build: string
              version: number
            } | null
            stationInfo: {
              __typename?: "StationInfo"
              city: string
              distance: number | null
              elev: number
              lat: number
              location: string
              lon: number
              solar_resource_file: string
              state: string
              tz: number
            } | null
          } | null
        }
      | null
    poison: { __typename?: "Poison"; reason: string; data: any } | null
    solarModule: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    inverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    secondaryInverter: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    designEquipment: Array<{
      __typename?: "DesignEquipmentObject"
      id: string
      createdAt: any
      updatedAt: any
      designId: string
      equipmentId: number
      powurOsEquipmentTypeId: number
      quantity: number
      price: number
      equipment: {
        __typename?: "PricedEquipment"
        id: number
        createdAt: any
        updatedAt: any
        name: string
        catalogNumber: string | null
        wattage: number | null
        powurOsEquipmentTypeId: number
        equipmentTypeId: string
        fallbackPrice: number | null
        powurOsManufacturerId: number
        manufacturerId: string
        warranty: any | null
        parentEquipmentAssociations: any
        childEquipmentAssociations: any
        height: number | null
        width: number | null
        cecWeightedEfficiency: number
        powurOsModuleDataId: number | null
        moduleData: any | null
        powurOsEnergyBackupDataId: number | null
        energyBackupData: any | null
        powurOsInverterDataId: number | null
        inverterData: any | null
        currentProposalPrice: number
        proposalPrices: Array<any>
        description: string | null
        isKit: boolean
        equipmentType: {
          __typename?: "EquipmentType"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        manufacturer: {
          __typename?: "Manufacturer"
          id: string
          createdAt: any
          updatedAt: any
          powurOsId: number
          name: string
        }
        basicAdderAssociations: Array<{
          __typename?: "BasicAdderAssociation"
          adderId: number
          equipmentId: number
          qty: number
        }>
        compatibleInverterManufacturers: Array<{
          __typename?: "CompatibleManufacturer"
          manufacturerId: number
        }>
      }
    }>
    energyBackup: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    } | null
    profiles: Array<{
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      providerProfileId: string
      profileId: string
    }>
  }
}

export type UpdateInverterMutationVariables = Exact<{
  input: UpdateInverterInput
}>

export type UpdateInverterMutation = {
  __typename?: "Mutation"
  updateInverter: { __typename?: "Design"; id: string }
}

export type UpdateModuleMutationVariables = Exact<{
  designId: Scalars["String"]["input"]
  equipmentId: Scalars["Int"]["input"]
}>

export type UpdateModuleMutation = {
  __typename?: "Mutation"
  updateModule: { __typename?: "Design"; id: string }
}

export type UpdateNonPrimaryEquipmentSelectionMutationVariables = Exact<{
  designId: Scalars["String"]["input"]
  equipmentIds: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type UpdateNonPrimaryEquipmentSelectionMutation = {
  __typename?: "Mutation"
  updateNonPrimaryEquipmentSelection: { __typename?: "Design"; id: string }
}

export type UpdateStorageMutationVariables = Exact<{
  input: UpdateStorageInput
}>

export type UpdateStorageMutation = {
  __typename?: "Mutation"
  updateStorage: { __typename?: "Design"; id: string }
}

export type AllDesignFieldsFragment = {
  __typename: "Design"
  activatedAt: any | null
  createdAt: any
  edges: any
  id: string
  installAreas: any
  installAreasToPanels: any
  nodes: any
  obstructions: any
  setbacks: any
  panels: any
  completedAt: any | null
  phase: string
  proposalId: string
  shadingAreas: any
  tool: string
  type: string | null
  updatedAt: any
  homeownerRebate: boolean
  homeownerRebateAmount: number
  treeTrimmingRebate: boolean
  treeTrimmingRebateAmount: number
  energyEfficiencyKitRebate: boolean
  energyEfficiencyKitRebateAmount: number
  roofWorkRebate: boolean
  roofWorkRebateAmount: number
  source: DesignSource
  annualProduction: number | null
  annualOffset: number | null
  systemSizeKw: number | null
  extendedWarrantyPowurOsId: number | null
  extendedWarrantyName: string | null
  extendedWarrantySpanishName: string | null
  extendedWarrantyFamily: string | null
  extendedWarrantyCost: number | null
  brochurePositionX: number
  brochurePositionY: number
  brochureZoom: number
  evOutlet: boolean
  evCharger: boolean
  displayImageryProvider: ImagerySource
  designRequestId: string | null
  sunroofCheckedAt: any | null
  openSolarImage: {
    __typename?: "Imagery"
    id: string
    filename: string
    height: number | null
    width: number | null
  } | null
  optimalEstimate:
    | {
        __typename: "Estimate"
        acAnnual: number
        acMonthly: Array<number>
        createdAt: any
        updatedAt: any
        errors: Array<string>
        id: string
        designId: string | null
        installAreaId: string | null
        solarProfileId: string | null
        acHourly: Array<number>
        solarProfile: {
          __typename?: "GenabilityProfile"
          id: string
          createdAt: any
          updatedAt: any
          type: GenabilityProfileType
          providerProfileId: string
          profileId: string
        } | null
        inputs: {
          __typename?: "PVWatts_Inputs"
          array_type: string
          azimuth: number
          dc_ac_ratio: number | null
          inv_eff: number | null
          lat: number
          lon: number
          losses: number
          module_type: string
          system_capacity: number | null
          tilt: number | null
        } | null
        sscInfo: {
          __typename?: "SscInfo"
          build: string
          version: number
        } | null
        stationInfo: {
          __typename?: "StationInfo"
          city: string
          distance: number | null
          elev: number
          lat: number
          location: string
          lon: number
          solar_resource_file: string
          state: string
          tz: number
        } | null
      }
    | {
        __typename: "PoisonedEstimate"
        id: string
        createdAt: any
        updatedAt: any
        data: any
        reason: string
        estimate: {
          __typename?: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        } | null
      }
    | null
  poison: { __typename?: "Poison"; reason: string; data: any } | null
}

export type AllDesignEquipmentFragment = {
  __typename?: "Design"
  batteryCompatibility: boolean
  solarModuleId: number | null
  inverterId: number | null
  secondaryInverterId: number | null
  inverterManufacturer: string | null
  energyBackupId: number | null
  solarModule: {
    __typename?: "PricedEquipment"
    id: number
    createdAt: any
    updatedAt: any
    name: string
    catalogNumber: string | null
    wattage: number | null
    powurOsEquipmentTypeId: number
    equipmentTypeId: string
    fallbackPrice: number | null
    powurOsManufacturerId: number
    manufacturerId: string
    warranty: any | null
    parentEquipmentAssociations: any
    childEquipmentAssociations: any
    height: number | null
    width: number | null
    cecWeightedEfficiency: number
    powurOsModuleDataId: number | null
    moduleData: any | null
    powurOsEnergyBackupDataId: number | null
    energyBackupData: any | null
    powurOsInverterDataId: number | null
    inverterData: any | null
    currentProposalPrice: number
    proposalPrices: Array<any>
    description: string | null
    isKit: boolean
    equipmentType: {
      __typename?: "EquipmentType"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    manufacturer: {
      __typename?: "Manufacturer"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    basicAdderAssociations: Array<{
      __typename?: "BasicAdderAssociation"
      adderId: number
      equipmentId: number
      qty: number
    }>
    compatibleInverterManufacturers: Array<{
      __typename?: "CompatibleManufacturer"
      manufacturerId: number
    }>
  } | null
  inverter: {
    __typename?: "PricedEquipment"
    id: number
    createdAt: any
    updatedAt: any
    name: string
    catalogNumber: string | null
    wattage: number | null
    powurOsEquipmentTypeId: number
    equipmentTypeId: string
    fallbackPrice: number | null
    powurOsManufacturerId: number
    manufacturerId: string
    warranty: any | null
    parentEquipmentAssociations: any
    childEquipmentAssociations: any
    height: number | null
    width: number | null
    cecWeightedEfficiency: number
    powurOsModuleDataId: number | null
    moduleData: any | null
    powurOsEnergyBackupDataId: number | null
    energyBackupData: any | null
    powurOsInverterDataId: number | null
    inverterData: any | null
    currentProposalPrice: number
    proposalPrices: Array<any>
    description: string | null
    isKit: boolean
    equipmentType: {
      __typename?: "EquipmentType"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    manufacturer: {
      __typename?: "Manufacturer"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    basicAdderAssociations: Array<{
      __typename?: "BasicAdderAssociation"
      adderId: number
      equipmentId: number
      qty: number
    }>
    compatibleInverterManufacturers: Array<{
      __typename?: "CompatibleManufacturer"
      manufacturerId: number
    }>
  } | null
  secondaryInverter: {
    __typename?: "PricedEquipment"
    id: number
    createdAt: any
    updatedAt: any
    name: string
    catalogNumber: string | null
    wattage: number | null
    powurOsEquipmentTypeId: number
    equipmentTypeId: string
    fallbackPrice: number | null
    powurOsManufacturerId: number
    manufacturerId: string
    warranty: any | null
    parentEquipmentAssociations: any
    childEquipmentAssociations: any
    height: number | null
    width: number | null
    cecWeightedEfficiency: number
    powurOsModuleDataId: number | null
    moduleData: any | null
    powurOsEnergyBackupDataId: number | null
    energyBackupData: any | null
    powurOsInverterDataId: number | null
    inverterData: any | null
    currentProposalPrice: number
    proposalPrices: Array<any>
    description: string | null
    isKit: boolean
    equipmentType: {
      __typename?: "EquipmentType"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    manufacturer: {
      __typename?: "Manufacturer"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    basicAdderAssociations: Array<{
      __typename?: "BasicAdderAssociation"
      adderId: number
      equipmentId: number
      qty: number
    }>
    compatibleInverterManufacturers: Array<{
      __typename?: "CompatibleManufacturer"
      manufacturerId: number
    }>
  } | null
  designEquipment: Array<{
    __typename?: "DesignEquipmentObject"
    id: string
    createdAt: any
    updatedAt: any
    designId: string
    equipmentId: number
    powurOsEquipmentTypeId: number
    quantity: number
    price: number
    equipment: {
      __typename?: "PricedEquipment"
      id: number
      createdAt: any
      updatedAt: any
      name: string
      catalogNumber: string | null
      wattage: number | null
      powurOsEquipmentTypeId: number
      equipmentTypeId: string
      fallbackPrice: number | null
      powurOsManufacturerId: number
      manufacturerId: string
      warranty: any | null
      parentEquipmentAssociations: any
      childEquipmentAssociations: any
      height: number | null
      width: number | null
      cecWeightedEfficiency: number
      powurOsModuleDataId: number | null
      moduleData: any | null
      powurOsEnergyBackupDataId: number | null
      energyBackupData: any | null
      powurOsInverterDataId: number | null
      inverterData: any | null
      currentProposalPrice: number
      proposalPrices: Array<any>
      description: string | null
      isKit: boolean
      equipmentType: {
        __typename?: "EquipmentType"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      manufacturer: {
        __typename?: "Manufacturer"
        id: string
        createdAt: any
        updatedAt: any
        powurOsId: number
        name: string
      }
      basicAdderAssociations: Array<{
        __typename?: "BasicAdderAssociation"
        adderId: number
        equipmentId: number
        qty: number
      }>
      compatibleInverterManufacturers: Array<{
        __typename?: "CompatibleManufacturer"
        manufacturerId: number
      }>
    }
  }>
  energyBackup: {
    __typename?: "PricedEquipment"
    id: number
    createdAt: any
    updatedAt: any
    name: string
    catalogNumber: string | null
    wattage: number | null
    powurOsEquipmentTypeId: number
    equipmentTypeId: string
    fallbackPrice: number | null
    powurOsManufacturerId: number
    manufacturerId: string
    warranty: any | null
    parentEquipmentAssociations: any
    childEquipmentAssociations: any
    height: number | null
    width: number | null
    cecWeightedEfficiency: number
    powurOsModuleDataId: number | null
    moduleData: any | null
    powurOsEnergyBackupDataId: number | null
    energyBackupData: any | null
    powurOsInverterDataId: number | null
    inverterData: any | null
    currentProposalPrice: number
    proposalPrices: Array<any>
    description: string | null
    isKit: boolean
    equipmentType: {
      __typename?: "EquipmentType"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    manufacturer: {
      __typename?: "Manufacturer"
      id: string
      createdAt: any
      updatedAt: any
      powurOsId: number
      name: string
    }
    basicAdderAssociations: Array<{
      __typename?: "BasicAdderAssociation"
      adderId: number
      equipmentId: number
      qty: number
    }>
    compatibleInverterManufacturers: Array<{
      __typename?: "CompatibleManufacturer"
      manufacturerId: number
    }>
  } | null
  profiles: Array<{
    __typename?: "GenabilityProfile"
    id: string
    createdAt: any
    updatedAt: any
    type: GenabilityProfileType
    providerProfileId: string
    profileId: string
  }>
}

export type SavingsFieldsFragment = {
  __typename?: "Savings"
  designId: string
  createdAt: any
  updatedAt: any
  id: string
  inputs: {
    __typename?: "GenabilityAccountAnalysisInputs"
    projectDuration: number
    preSolarMasterTariffId: number
    postSolarMasterTariffId: number
    rateInflation: number
    solarDegradation: number
    fromDateTime: string | null
    genabilityAccountId: string
    optimizedConsumptionProviderProfileId: string | null
    optimizedProductionProviderProfileId: string | null
    consumptionProviderProfileId: string | null
    storageProviderProfileId: string | null
    productionProviderProfileIds: Array<string> | null
    userAdjustedRate: number | null
  }
  outputs: {
    __typename?: "GenabilityAccountAnalysis"
    designId: string | null
    dataStatus: number
    currency: string | null
    summary: {
      __typename?: "GenabilityAccountAnalysisSummary"
      lifeTimeUtilityAfterCost: number | null
      lifeTimeUtilityAvoidedRate: number | null
      lifetimeAvoidedCost: number | null
      lifetimeSolarCost: number | null
      lifetimeWithoutCost: number | null
      netAvoidedCost: number | null
      netAvoidedCostPctOffset: number | null
      netAvoidedKWh: number | null
      netAvoidedKWhPctOffset: number | null
      netAvoidedRate: number | null
      postTotalCost: number
      postTotalKWh: number
      postTotalKWhCost: number
      postTotalKWhRate: number
      postTotalMinCost: number
      postTotalNonBypassableCost: number | null
      postTotalNonMinCost: number | null
      postTotalRate: number | null
      preTotalCost: number
      preTotalKWh: number
      preTotalKWhCost: number
      preTotalKWhRate: number
      preTotalMinCost: number
      preTotalNonBypassableCost: number
      preTotalNonMinCost: number
      preTotalRate: number
    }
    scenarios: Array<{
      __typename?: "GenabilityScenario"
      id: string | null
      name: string | null
      serviceType: string | null
      inputs: Array<{
        __typename?: "GenabilityPropertyData"
        keyName: string
        displayName: string | null
        dataType: DataType | null
        fromDateTime: string | null
        toDateTime: string | null
        dataValue: string | null
        operator: string | null
      }>
      rates: Array<{
        __typename?: "GenabilityTariffRateSimple"
        fromDateTime: string | null
        toDateTime: string | null
        chargeType: string | null
        chargePeriod: string | null
        rateName: string
        scenarios: string | null
        rateBands: Array<{
          __typename?: "GenabilityTariffRateBand"
          tariffRateBandId: number | null
          tariffRateId: number | null
          rateSequenceNumber: number | null
          hasConsumptionLimit: boolean | null
          hasDemandLimit: boolean | null
          hasPropertyLimit: boolean | null
          rateAmount: number | null
          rateUnit: string | null
          isCredit: boolean
        }> | null
      }> | null
    }>
    series: Array<{
      __typename?: "GenabilitySeries"
      seriesId: number
      fromDateTime: string
      toDateTime: string
      scenario: string
      displayLabel: string
      seriesPeriod: string
      seriesDuration: number
      designId: string | null
      key: string | null
      rate: number | null
      qty: number
      cost: number
    }>
    seriesData: Array<{
      __typename?: "GenabilitySeriesMeasure"
      seriesId: number
      fromDateTime: string
      toDateTime: string
      rate: number | null
      qty: number
      cost: number
    }>
    seriesCosts: Array<{
      __typename?: "GenabilityCalculatedCost"
      masterTariffId: number
      tariffName: string
      totalCost: number
      fromDateTime: string
      toDateTime: string
      accuracy: number
      currency: string
      calculatedCostId: string | null
      summary: {
        __typename?: "GenabilityCalculatedCostSummary"
        export: number | null
        import: number | null
        nonBypassableCost: number | null
        preTaxMinimumCost: number | null
        subTotalCost: number
        taxCost: number
        totalCost: number
        adjustedTotalCost: number
        kWh: number
        kW: number
        ELECTRICITY: {
          __typename: "GenabilityKWkWh"
          kW: number
          kWh: number
        } | null
      }
      items: Array<{
        __typename?: "GenabilityCalculatedCostItem"
        tariffId: number | null
        tariffRateId: number | null
        tariffRateBandId: number | null
        rateSequenceNumber: number | null
        rateName: string | null
        fromDateTime: string
        toDateTime: string
        quantityKey: string
        quantityKeyDescription: string | null
        rateType: string | null
        tierLowerLimit: number | null
        tierUpperLimit: number | null
        itemQuantity: number
        cost: number | null
        rateProration: number | null
        chargeType: string | null
        chargeClass: string | null
        periodType: string | null
        demandInterval: string | null
        duration: number | null
        touId: number | null
        touName: string | null
        seasonId: number | null
        formula: string | null
        transactionType: string | null
      }>
    }>
  } | null
}

export type GetEquipmentForProposalQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
  equipmentType: InputMaybe<NewEquipmentType>
  inverterManufacturerId: InputMaybe<Scalars["Float"]["input"]>
}>

export type GetEquipmentForProposalQuery = {
  __typename?: "Query"
  equipmentForProposal: Array<{
    __typename?: "NewEquipment"
    id: number
    name: string
    proposalName: string | null
    type: string
    typeId: number
    currentProposalPrice: number
    description: string | null
    manufacturerId: number
    manufacturer: string
    catalogNumber: string
    isKit: boolean
    isBattery: boolean
    isDefault: boolean
    batteryData: any | null
    inverterData: any | null
    evChargerData: any | null
    wattage: number
    height: number | null
    width: number | null
  }>
}

export type GetInvertersForProposalQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetInvertersForProposalQuery = {
  __typename?: "Query"
  invertersForProposal: {
    __typename?: "InvertersForProposalResponse"
    brands: Array<string>
    inverters: Array<{
      __typename?: "NewEquipment"
      id: number
      name: string
      proposalName: string | null
      type: string
      typeId: number
      currentProposalPrice: number
      description: string | null
      manufacturerId: number
      manufacturer: string
      catalogNumber: string
      isKit: boolean
      isBattery: boolean
      isDefault: boolean
      batteryData: any | null
      inverterData: any | null
      evChargerData: any | null
      wattage: number
      height: number | null
      width: number | null
    }>
  }
}

export type GetBaseEquipmentForProposalQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetBaseEquipmentForProposalQuery = {
  __typename?: "Query"
  baseEquipmentForProposal: {
    __typename?: "BaseEquipmentObject"
    moduleId: number | null
    inverters: Array<number>
  }
}

export type SearchEquipmentWithAvailabilityQueryVariables = Exact<{
  searchTerm: Scalars["String"]["input"]
  proposalId: Scalars["String"]["input"]
}>

export type SearchEquipmentWithAvailabilityQuery = {
  __typename?: "Query"
  searchEquipmentWithAvailability: Array<{
    __typename?: "EquipmentAvailabilityResultObject"
    id: string
    name: string
    catalogNumber: string | null
    manufacturerName: string | null
    availabilityStatus: UnavailabilityReason
    unavailabilityReason: string | null
  }>
}

export type EquipmentFieldsFragment = {
  __typename?: "PricedEquipment"
  id: number
  createdAt: any
  updatedAt: any
  name: string
  catalogNumber: string | null
  wattage: number | null
  powurOsEquipmentTypeId: number
  equipmentTypeId: string
  fallbackPrice: number | null
  powurOsManufacturerId: number
  manufacturerId: string
  warranty: any | null
  parentEquipmentAssociations: any
  childEquipmentAssociations: any
  height: number | null
  width: number | null
  cecWeightedEfficiency: number
  powurOsModuleDataId: number | null
  moduleData: any | null
  powurOsEnergyBackupDataId: number | null
  energyBackupData: any | null
  powurOsInverterDataId: number | null
  inverterData: any | null
  currentProposalPrice: number
  proposalPrices: Array<any>
  description: string | null
  isKit: boolean
  equipmentType: {
    __typename?: "EquipmentType"
    id: string
    createdAt: any
    updatedAt: any
    powurOsId: number
    name: string
  }
  manufacturer: {
    __typename?: "Manufacturer"
    id: string
    createdAt: any
    updatedAt: any
    powurOsId: number
    name: string
  }
  basicAdderAssociations: Array<{
    __typename?: "BasicAdderAssociation"
    adderId: number
    equipmentId: number
    qty: number
  }>
  compatibleInverterManufacturers: Array<{
    __typename?: "CompatibleManufacturer"
    manufacturerId: number
  }>
}

export type AllNewEquipmentFieldsFragment = {
  __typename?: "NewEquipment"
  id: number
  name: string
  proposalName: string | null
  type: string
  typeId: number
  currentProposalPrice: number
  description: string | null
  manufacturerId: number
  manufacturer: string
  catalogNumber: string
  isKit: boolean
  isBattery: boolean
  isDefault: boolean
  batteryData: any | null
  inverterData: any | null
  evChargerData: any | null
  wattage: number
  height: number | null
  width: number | null
}

export type EstimateQueryVariables = Exact<{
  findEstimateInput: FindEstimateInput
}>

export type EstimateQuery = {
  __typename?: "Query"
  estimate:
    | {
        __typename: "Estimate"
        acAnnual: number
        acMonthly: Array<number>
        createdAt: any
        updatedAt: any
        errors: Array<string>
        id: string
        designId: string | null
        installAreaId: string | null
        solarProfileId: string | null
        acHourly: Array<number>
        solarProfile: {
          __typename?: "GenabilityProfile"
          id: string
          createdAt: any
          updatedAt: any
          type: GenabilityProfileType
          providerProfileId: string
          profileId: string
        } | null
        inputs: {
          __typename?: "PVWatts_Inputs"
          array_type: string
          azimuth: number
          dc_ac_ratio: number | null
          inv_eff: number | null
          lat: number
          lon: number
          losses: number
          module_type: string
          system_capacity: number | null
          tilt: number | null
        } | null
        sscInfo: {
          __typename?: "SscInfo"
          build: string
          version: number
        } | null
        stationInfo: {
          __typename?: "StationInfo"
          city: string
          distance: number | null
          elev: number
          lat: number
          location: string
          lon: number
          solar_resource_file: string
          state: string
          tz: number
        } | null
      }
    | {
        __typename: "PoisonedEstimate"
        id: string
        createdAt: any
        updatedAt: any
        data: any
        reason: string
        estimate: {
          __typename?: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        } | null
      }
}

export type CreateEstimateOverridesMutationVariables = Exact<{
  input: CreateEstimateOverridesInput
}>

export type CreateEstimateOverridesMutation = {
  __typename?: "Mutation"
  createEstimateOverrides: string
}

export type EstimateFieldsFragment = {
  __typename?: "Estimate"
  acAnnual: number
  acMonthly: Array<number>
  createdAt: any
  updatedAt: any
  errors: Array<string>
  id: string
  designId: string | null
  installAreaId: string | null
  solarProfileId: string | null
  acHourly: Array<number>
  solarProfile: {
    __typename?: "GenabilityProfile"
    id: string
    createdAt: any
    updatedAt: any
    type: GenabilityProfileType
    providerProfileId: string
    profileId: string
  } | null
  inputs: {
    __typename?: "PVWatts_Inputs"
    array_type: string
    azimuth: number
    dc_ac_ratio: number | null
    inv_eff: number | null
    lat: number
    lon: number
    losses: number
    module_type: string
    system_capacity: number | null
    tilt: number | null
  } | null
  sscInfo: { __typename?: "SscInfo"; build: string; version: number } | null
  stationInfo: {
    __typename?: "StationInfo"
    city: string
    distance: number | null
    elev: number
    lat: number
    location: string
    lon: number
    solar_resource_file: string
    state: string
    tz: number
  } | null
}

export type EstimatesForDesignQueryVariables = Exact<{
  designId: Scalars["ID"]["input"]
}>

export type EstimatesForDesignQuery = {
  __typename?: "Query"
  estimatesForDesign: Array<
    | {
        __typename: "Estimate"
        acAnnual: number
        acMonthly: Array<number>
        createdAt: any
        updatedAt: any
        errors: Array<string>
        id: string
        designId: string | null
        installAreaId: string | null
        solarProfileId: string | null
        acHourly: Array<number>
        solarProfile: {
          __typename?: "GenabilityProfile"
          id: string
          createdAt: any
          updatedAt: any
          type: GenabilityProfileType
          providerProfileId: string
          profileId: string
        } | null
        inputs: {
          __typename?: "PVWatts_Inputs"
          array_type: string
          azimuth: number
          dc_ac_ratio: number | null
          inv_eff: number | null
          lat: number
          lon: number
          losses: number
          module_type: string
          system_capacity: number | null
          tilt: number | null
        } | null
        sscInfo: {
          __typename?: "SscInfo"
          build: string
          version: number
        } | null
        stationInfo: {
          __typename?: "StationInfo"
          city: string
          distance: number | null
          elev: number
          lat: number
          location: string
          lon: number
          solar_resource_file: string
          state: string
          tz: number
        } | null
      }
    | {
        __typename: "PoisonedEstimate"
        id: string
        createdAt: any
        updatedAt: any
        data: any
        reason: string
        estimate: {
          __typename?: "Estimate"
          acAnnual: number
          acMonthly: Array<number>
          createdAt: any
          updatedAt: any
          errors: Array<string>
          id: string
          designId: string | null
          installAreaId: string | null
          solarProfileId: string | null
          acHourly: Array<number>
          solarProfile: {
            __typename?: "GenabilityProfile"
            id: string
            createdAt: any
            updatedAt: any
            type: GenabilityProfileType
            providerProfileId: string
            profileId: string
          } | null
          inputs: {
            __typename?: "PVWatts_Inputs"
            array_type: string
            azimuth: number
            dc_ac_ratio: number | null
            inv_eff: number | null
            lat: number
            lon: number
            losses: number
            module_type: string
            system_capacity: number | null
            tilt: number | null
          } | null
          sscInfo: {
            __typename?: "SscInfo"
            build: string
            version: number
          } | null
          stationInfo: {
            __typename?: "StationInfo"
            city: string
            distance: number | null
            elev: number
            lat: number
            location: string
            lon: number
            solar_resource_file: string
            state: string
            tz: number
          } | null
        } | null
      }
  >
}

export type GetIncentivesByProposalIdQueryVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type GetIncentivesByProposalIdQuery = {
  __typename?: "Query"
  getIncentivesByProposalId: Array<{
    __typename: "ProposalIncentive"
    createdAt: any
    updatedAt: any
    incentiveId: string
    proposalId: string
    applyToLoan: boolean
    showOnBrochure: boolean
    value: number
    incentive: {
      __typename?: "Incentive"
      id: string
      createdAt: any
      updatedAt: any
      activatedAt: any | null
      activeInZipCodes: Array<string>
      applicabilityMaxValue: number | null
      applicabilityMinValue: number | null
      applicabilityName: string | null
      canApplyToLoan: boolean
      customerClass: string
      customDisplayName: string | null
      documents: string | null
      eligibility: string
      endDate: string | null
      incentiveCategory: IncentiveCategory
      incentiveId: number | null
      incentiveName: string
      incentiveType: string
      incentivePaidTo: string | null
      isExhausted: boolean
      isPaidAsLumpSum: boolean
      isSungageRebate: boolean
      jurisdiction: string
      lseCode: string | null
      lseId: number | null
      lseName: string | null
      masterIncentiveId: number | null
      paymentCap: number | null
      paymentDuration: number
      percentCostCap: number | null
      projectType: string
      projectTypeExclusive: boolean | null
      quantityKeyCap: string | null
      rate: number
      rateUnit: string
      requirements: string | null
      serviceType: string | null
      startDate: string
      state: string
      summary: string
      tariffCode: string | null
      turnedOnByDefaultAt: any | null
      source: string
      applicabilities: Array<{
        __typename?: "Applicability"
        applicabilityKey: string
        description: string
        displayName: string
        maxValue: string | null
        minValue: string | null
        operator: string | null
        requiredValue: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
      }> | null
      percentCostCapKey: {
        __typename?: "PropertyKey"
        dataType: string | null
        description: string | null
        displayName: string | null
        entityId: number | null
        entityType: string | null
        family: string | null
        formulaDetail: string | null
        keyName: string | null
        keyspace: string | null
        lookbackIntervalQuantity: number | null
        lookbackQuantity: number | null
        lookbackSeasonId: number | null
        lookbackPeriod: string | null
        lookbackTimeOfUseId: number | null
        quantityUnit: string | null
        subKeyName: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
      } | null
      quantityKey: {
        __typename?: "PropertyKey"
        dataType: string | null
        description: string | null
        displayName: string | null
        entityId: number | null
        entityType: string | null
        family: string | null
        formulaDetail: string | null
        keyName: string | null
        keyspace: string | null
        lookbackIntervalQuantity: number | null
        lookbackQuantity: number | null
        lookbackSeasonId: number | null
        lookbackPeriod: string | null
        lookbackTimeOfUseId: number | null
        quantityUnit: string | null
        subKeyName: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
      }
      requiredData: Array<{
        __typename?: "Applicability"
        applicabilityKey: string
        description: string
        displayName: string
        maxValue: string | null
        minValue: string | null
        operator: string | null
        requiredValue: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
      }> | null
    }
  }>
}

export type GetSelectIncentivesModalQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetSelectIncentivesModalQuery = {
  __typename?: "Query"
  getSelectIncentivesModal: {
    __typename?: "GetSelectIncentivesModal"
    listed: Array<{
      __typename: "ProposalIncentive"
      createdAt: any
      updatedAt: any
      incentiveId: string
      proposalId: string
      applyToLoan: boolean
      showOnBrochure: boolean
      value: number
      incentive: {
        __typename?: "Incentive"
        id: string
        createdAt: any
        updatedAt: any
        activatedAt: any | null
        activeInZipCodes: Array<string>
        applicabilityMaxValue: number | null
        applicabilityMinValue: number | null
        applicabilityName: string | null
        canApplyToLoan: boolean
        customerClass: string
        customDisplayName: string | null
        documents: string | null
        eligibility: string
        endDate: string | null
        incentiveCategory: IncentiveCategory
        incentiveId: number | null
        incentiveName: string
        incentiveType: string
        incentivePaidTo: string | null
        isExhausted: boolean
        isPaidAsLumpSum: boolean
        isSungageRebate: boolean
        jurisdiction: string
        lseCode: string | null
        lseId: number | null
        lseName: string | null
        masterIncentiveId: number | null
        paymentCap: number | null
        paymentDuration: number
        percentCostCap: number | null
        projectType: string
        projectTypeExclusive: boolean | null
        quantityKeyCap: string | null
        rate: number
        rateUnit: string
        requirements: string | null
        serviceType: string | null
        startDate: string
        state: string
        summary: string
        tariffCode: string | null
        turnedOnByDefaultAt: any | null
        source: string
        applicabilities: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
        percentCostCapKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        }
        requiredData: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
      }
    }>
    unlisted: Array<{
      __typename: "ProposalIncentive"
      createdAt: any
      updatedAt: any
      incentiveId: string
      proposalId: string
      applyToLoan: boolean
      showOnBrochure: boolean
      value: number
      incentive: {
        __typename?: "Incentive"
        id: string
        createdAt: any
        updatedAt: any
        activatedAt: any | null
        activeInZipCodes: Array<string>
        applicabilityMaxValue: number | null
        applicabilityMinValue: number | null
        applicabilityName: string | null
        canApplyToLoan: boolean
        customerClass: string
        customDisplayName: string | null
        documents: string | null
        eligibility: string
        endDate: string | null
        incentiveCategory: IncentiveCategory
        incentiveId: number | null
        incentiveName: string
        incentiveType: string
        incentivePaidTo: string | null
        isExhausted: boolean
        isPaidAsLumpSum: boolean
        isSungageRebate: boolean
        jurisdiction: string
        lseCode: string | null
        lseId: number | null
        lseName: string | null
        masterIncentiveId: number | null
        paymentCap: number | null
        paymentDuration: number
        percentCostCap: number | null
        projectType: string
        projectTypeExclusive: boolean | null
        quantityKeyCap: string | null
        rate: number
        rateUnit: string
        requirements: string | null
        serviceType: string | null
        startDate: string
        state: string
        summary: string
        tariffCode: string | null
        turnedOnByDefaultAt: any | null
        source: string
        applicabilities: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
        percentCostCapKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        }
        requiredData: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
      }
    }>
  }
}

export type CancelGoodleapLoanMutationVariables = Exact<{
  loanProviderId: Scalars["String"]["input"]
}>

export type CancelGoodleapLoanMutation = {
  __typename?: "Mutation"
  cancelGoodleapLoan: boolean
}

export type CreateLoanProductMutationVariables = Exact<{
  input: CreateLoanProductInput
}>

export type CreateLoanProductMutation = {
  __typename?: "Mutation"
  createLoanProduct: { __typename?: "LoanProduct"; id: string }
}

export type FindLoanProductsForProposalQueryVariables = Exact<{
  proposalId: Scalars["ID"]["input"]
  provider: Scalars["String"]["input"]
}>

export type FindLoanProductsForProposalQuery = {
  __typename?: "Query"
  findLoanProductsForProposal: {
    __typename: "LoanProductOptions"
    providers: Array<LoanProvider>
    products: Array<{
      __typename?: "LoanProduct"
      id: string
      createdAt: any
      updatedAt: any
      escalator: number | null
      provider: LoanProvider
      rate: number
      term: number
      statesPossible: Array<StateCode>
      statesActive: Array<StateCode>
      powurOsCurrentDealerFee: number
      powurOsCurrentPowurMargin: number
      powurOsDealerFeePlusMargin: number
      powurOsLoanId: number | null
      powurOsLoanProviderId: number | null
      productName: string
      providerId: string
      providerFee: number
      providerMeta: any | null
      providerName: string | null
      minimumLoanAmount: number | null
      maximumLoanAmount: number | null
      introPaymentFactor: number
      minimumCreditScore: number | null
      activatedAt: any | null
      syncHistory: any | null
      loanType: string
    }>
  }
}

export type FindPossibleTpoLoanProductTypesForProposalQueryVariables = Exact<{
  proposalId: Scalars["ID"]["input"]
}>

export type FindPossibleTpoLoanProductTypesForProposalQuery = {
  __typename?: "Query"
  findPossibleTpoLoanProductTypesForProposal: Array<string>
}

export type AllLoanProductFieldsFragment = {
  __typename?: "LoanProduct"
  id: string
  createdAt: any
  updatedAt: any
  escalator: number | null
  provider: LoanProvider
  rate: number
  term: number
  statesPossible: Array<StateCode>
  statesActive: Array<StateCode>
  powurOsCurrentDealerFee: number
  powurOsCurrentPowurMargin: number
  powurOsDealerFeePlusMargin: number
  powurOsLoanId: number | null
  powurOsLoanProviderId: number | null
  productName: string
  providerId: string
  providerFee: number
  providerMeta: any | null
  providerName: string | null
  minimumLoanAmount: number | null
  maximumLoanAmount: number | null
  introPaymentFactor: number
  minimumCreditScore: number | null
  activatedAt: any | null
  syncHistory: any | null
  loanType: string
}

export type SunlightInfoQueryVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type SunlightInfoQuery = {
  __typename?: "Query"
  getSunlightProjectStatus: {
    __typename?: "SunlightGetStatusResponse"
    returnCode: string
    projects: Array<{
      __typename?: "ProjectBodyResponse"
      id: string
      externalId: string
      hashId: string
      stage: string
      ownerEmail: string
      term: number
      isACH: boolean
      isCreditAuthorized: boolean
      projectStatus: string | null
      installerName: string | null
      requestedLoanAmount: number
      statusText: string
      stips: Array<{
        __typename?: "StipsBodyResponse"
        id: string
        name: string
        status: string
        description: string
        installerOnlyEmail: boolean
        isStipSuppressed: boolean
      }> | null
    }>
  }
}

export type SearchLoanProductsQueryVariables = Exact<{
  searchTerms: SearchLoanProductInput
}>

export type SearchLoanProductsQuery = {
  __typename?: "Query"
  searchLoanProducts: Array<{
    __typename?: "LoanProduct"
    id: string
    createdAt: any
    updatedAt: any
    escalator: number | null
    provider: LoanProvider
    rate: number
    term: number
    statesPossible: Array<StateCode>
    statesActive: Array<StateCode>
    powurOsCurrentDealerFee: number
    powurOsCurrentPowurMargin: number
    powurOsDealerFeePlusMargin: number
    powurOsLoanId: number | null
    powurOsLoanProviderId: number | null
    productName: string
    providerId: string
    providerFee: number
    providerMeta: any | null
    providerName: string | null
    minimumLoanAmount: number | null
    maximumLoanAmount: number | null
    introPaymentFactor: number
    minimumCreditScore: number | null
    activatedAt: any | null
    syncHistory: any | null
    loanType: string
  }>
}

export type SubmitChangeOrderMutationVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type SubmitChangeOrderMutation = {
  __typename?: "Mutation"
  SubmitChangeOrder: { __typename?: "SubmitChangeOrderResponse"; id: string }
}

export type GetWarrantyPricingQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type GetWarrantyPricingQuery = {
  __typename?: "Query"
  getWarrantyPricing: Array<{
    __typename?: "PowurOsWarrantyPricing"
    id: number
    cost: number
    name: string
    eligible: boolean
    family: string
    localizedName: string
  }>
}

export type AllPropertyFieldsFragment = {
  __typename?: "PropertyKey"
  dataType: string | null
  description: string | null
  displayName: string | null
  entityId: number | null
  entityType: string | null
  family: string | null
  formulaDetail: string | null
  keyName: string | null
  keyspace: string | null
  lookbackIntervalQuantity: number | null
  lookbackQuantity: number | null
  lookbackSeasonId: number | null
  lookbackPeriod: string | null
  lookbackTimeOfUseId: number | null
  quantityUnit: string | null
  subKeyName: string | null
  choices: Array<{
    __typename?: "Choice"
    name: string | null
    displayName: string | null
    value: string
    displayValue: string | null
    dataValue: string | null
    likelihood: number | null
  }> | null
}

export type AllApplicabilityFieldsFragment = {
  __typename?: "Applicability"
  applicabilityKey: string
  description: string
  displayName: string
  maxValue: string | null
  minValue: string | null
  operator: string | null
  requiredValue: string | null
  choices: Array<{
    __typename?: "Choice"
    name: string | null
    displayName: string | null
    value: string
    displayValue: string | null
    dataValue: string | null
    likelihood: number | null
  }> | null
  quantityKey: {
    __typename?: "PropertyKey"
    dataType: string | null
    description: string | null
    displayName: string | null
    entityId: number | null
    entityType: string | null
    family: string | null
    formulaDetail: string | null
    keyName: string | null
    keyspace: string | null
    lookbackIntervalQuantity: number | null
    lookbackQuantity: number | null
    lookbackSeasonId: number | null
    lookbackPeriod: string | null
    lookbackTimeOfUseId: number | null
    quantityUnit: string | null
    subKeyName: string | null
    choices: Array<{
      __typename?: "Choice"
      name: string | null
      displayName: string | null
      value: string
      displayValue: string | null
      dataValue: string | null
      likelihood: number | null
    }> | null
  } | null
}

export type AllIncentiveFieldsFragment = {
  __typename?: "Incentive"
  id: string
  createdAt: any
  updatedAt: any
  activatedAt: any | null
  activeInZipCodes: Array<string>
  applicabilityMaxValue: number | null
  applicabilityMinValue: number | null
  applicabilityName: string | null
  canApplyToLoan: boolean
  customerClass: string
  customDisplayName: string | null
  documents: string | null
  eligibility: string
  endDate: string | null
  incentiveCategory: IncentiveCategory
  incentiveId: number | null
  incentiveName: string
  incentiveType: string
  incentivePaidTo: string | null
  isExhausted: boolean
  isPaidAsLumpSum: boolean
  isSungageRebate: boolean
  jurisdiction: string
  lseCode: string | null
  lseId: number | null
  lseName: string | null
  masterIncentiveId: number | null
  paymentCap: number | null
  paymentDuration: number
  percentCostCap: number | null
  projectType: string
  projectTypeExclusive: boolean | null
  quantityKeyCap: string | null
  rate: number
  rateUnit: string
  requirements: string | null
  serviceType: string | null
  startDate: string
  state: string
  summary: string
  tariffCode: string | null
  turnedOnByDefaultAt: any | null
  source: string
  applicabilities: Array<{
    __typename?: "Applicability"
    applicabilityKey: string
    description: string
    displayName: string
    maxValue: string | null
    minValue: string | null
    operator: string | null
    requiredValue: string | null
    choices: Array<{
      __typename?: "Choice"
      name: string | null
      displayName: string | null
      value: string
      displayValue: string | null
      dataValue: string | null
      likelihood: number | null
    }> | null
    quantityKey: {
      __typename?: "PropertyKey"
      dataType: string | null
      description: string | null
      displayName: string | null
      entityId: number | null
      entityType: string | null
      family: string | null
      formulaDetail: string | null
      keyName: string | null
      keyspace: string | null
      lookbackIntervalQuantity: number | null
      lookbackQuantity: number | null
      lookbackSeasonId: number | null
      lookbackPeriod: string | null
      lookbackTimeOfUseId: number | null
      quantityUnit: string | null
      subKeyName: string | null
      choices: Array<{
        __typename?: "Choice"
        name: string | null
        displayName: string | null
        value: string
        displayValue: string | null
        dataValue: string | null
        likelihood: number | null
      }> | null
    } | null
  }> | null
  percentCostCapKey: {
    __typename?: "PropertyKey"
    dataType: string | null
    description: string | null
    displayName: string | null
    entityId: number | null
    entityType: string | null
    family: string | null
    formulaDetail: string | null
    keyName: string | null
    keyspace: string | null
    lookbackIntervalQuantity: number | null
    lookbackQuantity: number | null
    lookbackSeasonId: number | null
    lookbackPeriod: string | null
    lookbackTimeOfUseId: number | null
    quantityUnit: string | null
    subKeyName: string | null
    choices: Array<{
      __typename?: "Choice"
      name: string | null
      displayName: string | null
      value: string
      displayValue: string | null
      dataValue: string | null
      likelihood: number | null
    }> | null
  } | null
  quantityKey: {
    __typename?: "PropertyKey"
    dataType: string | null
    description: string | null
    displayName: string | null
    entityId: number | null
    entityType: string | null
    family: string | null
    formulaDetail: string | null
    keyName: string | null
    keyspace: string | null
    lookbackIntervalQuantity: number | null
    lookbackQuantity: number | null
    lookbackSeasonId: number | null
    lookbackPeriod: string | null
    lookbackTimeOfUseId: number | null
    quantityUnit: string | null
    subKeyName: string | null
    choices: Array<{
      __typename?: "Choice"
      name: string | null
      displayName: string | null
      value: string
      displayValue: string | null
      dataValue: string | null
      likelihood: number | null
    }> | null
  }
  requiredData: Array<{
    __typename?: "Applicability"
    applicabilityKey: string
    description: string
    displayName: string
    maxValue: string | null
    minValue: string | null
    operator: string | null
    requiredValue: string | null
    choices: Array<{
      __typename?: "Choice"
      name: string | null
      displayName: string | null
      value: string
      displayValue: string | null
      dataValue: string | null
      likelihood: number | null
    }> | null
    quantityKey: {
      __typename?: "PropertyKey"
      dataType: string | null
      description: string | null
      displayName: string | null
      entityId: number | null
      entityType: string | null
      family: string | null
      formulaDetail: string | null
      keyName: string | null
      keyspace: string | null
      lookbackIntervalQuantity: number | null
      lookbackQuantity: number | null
      lookbackSeasonId: number | null
      lookbackPeriod: string | null
      lookbackTimeOfUseId: number | null
      quantityUnit: string | null
      subKeyName: string | null
      choices: Array<{
        __typename?: "Choice"
        name: string | null
        displayName: string | null
        value: string
        displayValue: string | null
        dataValue: string | null
        likelihood: number | null
      }> | null
    } | null
  }> | null
}

export type AllAdderFieldsFragment = {
  __typename?: "Adder"
  id: string
  title: string
  unit: number | null
  needsModuleCount: boolean
  priceList: any | null
  relatedPowurOsAdderId: number | null
  relatedAdder: any | null
  doesMountingTypeRequireInstaller: boolean
  powurOsId: number
  createdAt: any
  updatedAt: any
  category: any | null
  lenderCategories: any | null
  powurOsCategoryId: number
  proposalType: number | null
  proposalUseTypeId: number | null
  isVariable: boolean
  isCustom: boolean
}

export type AllProposalAdderFieldsFragment = {
  __typename?: "ProposalAdderObject"
  selected: boolean
  customQuantity: number | null
  customPrice: number | null
  createdAt: any
  updatedAt: any
  proposalId: string
  powurOsAdderId: number
  cost: number
  isVariable: boolean
  adder: {
    __typename?: "Adder"
    id: string
    title: string
    unit: number | null
    needsModuleCount: boolean
    priceList: any | null
    relatedPowurOsAdderId: number | null
    relatedAdder: any | null
    doesMountingTypeRequireInstaller: boolean
    powurOsId: number
    createdAt: any
    updatedAt: any
    category: any | null
    lenderCategories: any | null
    powurOsCategoryId: number
    proposalType: number | null
    proposalUseTypeId: number | null
    isVariable: boolean
    isCustom: boolean
  }
}

export type AllProposalIncentiveFieldsFragment = {
  __typename: "ProposalIncentive"
  createdAt: any
  updatedAt: any
  incentiveId: string
  proposalId: string
  applyToLoan: boolean
  showOnBrochure: boolean
  value: number
  incentive: {
    __typename?: "Incentive"
    id: string
    createdAt: any
    updatedAt: any
    activatedAt: any | null
    activeInZipCodes: Array<string>
    applicabilityMaxValue: number | null
    applicabilityMinValue: number | null
    applicabilityName: string | null
    canApplyToLoan: boolean
    customerClass: string
    customDisplayName: string | null
    documents: string | null
    eligibility: string
    endDate: string | null
    incentiveCategory: IncentiveCategory
    incentiveId: number | null
    incentiveName: string
    incentiveType: string
    incentivePaidTo: string | null
    isExhausted: boolean
    isPaidAsLumpSum: boolean
    isSungageRebate: boolean
    jurisdiction: string
    lseCode: string | null
    lseId: number | null
    lseName: string | null
    masterIncentiveId: number | null
    paymentCap: number | null
    paymentDuration: number
    percentCostCap: number | null
    projectType: string
    projectTypeExclusive: boolean | null
    quantityKeyCap: string | null
    rate: number
    rateUnit: string
    requirements: string | null
    serviceType: string | null
    startDate: string
    state: string
    summary: string
    tariffCode: string | null
    turnedOnByDefaultAt: any | null
    source: string
    applicabilities: Array<{
      __typename?: "Applicability"
      applicabilityKey: string
      description: string
      displayName: string
      maxValue: string | null
      minValue: string | null
      operator: string | null
      requiredValue: string | null
      choices: Array<{
        __typename?: "Choice"
        name: string | null
        displayName: string | null
        value: string
        displayValue: string | null
        dataValue: string | null
        likelihood: number | null
      }> | null
      quantityKey: {
        __typename?: "PropertyKey"
        dataType: string | null
        description: string | null
        displayName: string | null
        entityId: number | null
        entityType: string | null
        family: string | null
        formulaDetail: string | null
        keyName: string | null
        keyspace: string | null
        lookbackIntervalQuantity: number | null
        lookbackQuantity: number | null
        lookbackSeasonId: number | null
        lookbackPeriod: string | null
        lookbackTimeOfUseId: number | null
        quantityUnit: string | null
        subKeyName: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
      } | null
    }> | null
    percentCostCapKey: {
      __typename?: "PropertyKey"
      dataType: string | null
      description: string | null
      displayName: string | null
      entityId: number | null
      entityType: string | null
      family: string | null
      formulaDetail: string | null
      keyName: string | null
      keyspace: string | null
      lookbackIntervalQuantity: number | null
      lookbackQuantity: number | null
      lookbackSeasonId: number | null
      lookbackPeriod: string | null
      lookbackTimeOfUseId: number | null
      quantityUnit: string | null
      subKeyName: string | null
      choices: Array<{
        __typename?: "Choice"
        name: string | null
        displayName: string | null
        value: string
        displayValue: string | null
        dataValue: string | null
        likelihood: number | null
      }> | null
    } | null
    quantityKey: {
      __typename?: "PropertyKey"
      dataType: string | null
      description: string | null
      displayName: string | null
      entityId: number | null
      entityType: string | null
      family: string | null
      formulaDetail: string | null
      keyName: string | null
      keyspace: string | null
      lookbackIntervalQuantity: number | null
      lookbackQuantity: number | null
      lookbackSeasonId: number | null
      lookbackPeriod: string | null
      lookbackTimeOfUseId: number | null
      quantityUnit: string | null
      subKeyName: string | null
      choices: Array<{
        __typename?: "Choice"
        name: string | null
        displayName: string | null
        value: string
        displayValue: string | null
        dataValue: string | null
        likelihood: number | null
      }> | null
    }
    requiredData: Array<{
      __typename?: "Applicability"
      applicabilityKey: string
      description: string
      displayName: string
      maxValue: string | null
      minValue: string | null
      operator: string | null
      requiredValue: string | null
      choices: Array<{
        __typename?: "Choice"
        name: string | null
        displayName: string | null
        value: string
        displayValue: string | null
        dataValue: string | null
        likelihood: number | null
      }> | null
      quantityKey: {
        __typename?: "PropertyKey"
        dataType: string | null
        description: string | null
        displayName: string | null
        entityId: number | null
        entityType: string | null
        family: string | null
        formulaDetail: string | null
        keyName: string | null
        keyspace: string | null
        lookbackIntervalQuantity: number | null
        lookbackQuantity: number | null
        lookbackSeasonId: number | null
        lookbackPeriod: string | null
        lookbackTimeOfUseId: number | null
        quantityUnit: string | null
        subKeyName: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
      } | null
    }> | null
  }
}

export type AllProposalLineItemFieldsFragment = {
  __typename: "ProposalLineItem"
  id: string
  createdAt: any
  updatedAt: any
  displayName: string
  type: string
  subType: string | null
  cost: number
  quantity: number
  taxable: boolean
  powurOsId: number | null
  children: Array<{
    __typename: "ProposalLineItem"
    id: string
    createdAt: any
    updatedAt: any
    displayName: string
    type: string
    subType: string | null
    cost: number
    quantity: number
    taxable: boolean
    powurOsId: number | null
  }>
}

export type AllAddressFieldsFragment = {
  __typename?: "DisplayAddress"
  id: string
  updatedAt: any
  createdAt: any
  category: string
  city: string
  lat: number
  long: number
  postal: string
  projectId: number | null
  state: string
  street: string
}

export type AllProposalFieldsFragment = {
  __typename: "Proposal"
  annualEnergyUse: number | null
  allowChangeOrderEquipment: boolean
  createdAt: any
  currentStatus: string | null
  displayAddressId: string
  downPayment: number | null
  id: string
  mentorId: string | null
  primaryPresenter: number | null
  secondaryPresenter: number | null
  monthlyEnergyCost: Array<number>
  monthlyEnergyManualFlags: Array<boolean>
  monthlyEnergyUse: Array<number>
  smartEstimateBanner: string | null
  genabilityDefaultContractedRate: number | null
  slug: string
  systemType: SystemType | null
  secondarySystem: boolean
  newConstruction: boolean
  updatedAt: any
  utilityRateEscalationPercentage: number
  sellerId: string
  selectedLoanProductId: string | null
  newCustomerIncentive: boolean
  preferredLanguage: string
  margin: number
  powurProjectId: number
  enterpriseLogoUrl: string | null
  userAdjustedAfterSolarContractedRate: number | null
  userAdjustedBeforeSolarContractedRate: number | null
  userAdjustedUtilityRate: number | null
  name: string | null
  financeType: string | null
  financeProductId: string | null
  leadSource: string | null
  fundingGroup: string | null
  displayAddress: {
    __typename?: "DisplayAddress"
    id: string
    updatedAt: any
    createdAt: any
    category: string
    city: string
    lat: number
    long: number
    postal: string
    projectId: number | null
    state: string
    street: string
  }
  proposalCost: {
    __typename?: "ProposalCost"
    id: string
    createdAt: any
    updatedAt: any
    designCost: number
    exciseTax: number
    proposalId: string
    salesTax: number
    totalCost: number
    batteryCost: number
    lineItems: Array<{
      __typename: "ProposalLineItem"
      id: string
      createdAt: any
      updatedAt: any
      displayName: string
      type: string
      subType: string | null
      cost: number
      quantity: number
      taxable: boolean
      powurOsId: number | null
      children: Array<{
        __typename: "ProposalLineItem"
        id: string
        createdAt: any
        updatedAt: any
        displayName: string
        type: string
        subType: string | null
        cost: number
        quantity: number
        taxable: boolean
        powurOsId: number | null
      }>
    }>
  }
  mentor: {
    __typename?: "User"
    id: string
    powurUserId: number | null
    permissions: Array<Permission>
    email: string
    phone: string | null
    createdAt: any
    updatedAt: any
    firstName: string
    lastName: string
    bio: string | null
    enterpriseId: string | null
    profileImage: {
      __typename?: "ProfileImg"
      bucket: string | null
      sizes: {
        __typename?: "ImageSizes"
        large: string | null
        thumb: string | null
        retina: string | null
        preview: string | null
        original: string | null
      } | null
    } | null
    licenses: Array<{
      __typename?: "License"
      id: string
      createdAt: any
      updatedAt: any
      externalId: string
      state: string
      name: string
      identifier: string
      expiresAt: any
      userId: string
    }> | null
    externalIds: Array<{
      __typename?: "ExternalIdentifier"
      id: string
      createdAt: any
      updatedAt: any
      provider: ExternalProvider
      identifier: string
      metadata: any
      userId: string
      proposalId: string | null
    }> | null
  } | null
  usageProfile: {
    __typename?: "GenabilityProfile"
    id: string
    createdAt: any
    updatedAt: any
    type: GenabilityProfileType
    profileId: string
    providerProfileId: string
  } | null
  genabilityUsageEstimate: {
    __typename?: "GenabilityCalculatedCost"
    calculatedCostId: string | null
    masterTariffId: number
    tariffName: string
    totalCost: number
    fromDateTime: string
    toDateTime: string
    currency: string
    accuracy: number
    summary: {
      __typename?: "GenabilityCalculatedCostSummary"
      preTaxMinimumCost: number | null
      subTotalCost: number
      taxCost: number
      totalCost: number
      adjustedTotalCost: number
      nonBypassableCost: number | null
      kWh: number
      kW: number
      import: number | null
      export: number | null
      ELECTRICITY: {
        __typename?: "GenabilityKWkWh"
        kWh: number
        kW: number
      } | null
    }
    items: Array<{
      __typename?: "GenabilityCalculatedCostItem"
      fromDateTime: string
      toDateTime: string
      quantityKey: string
      rateAmount: number
      itemQuantity: number
      cost: number | null
      chargeClass: string | null
      chargeType: string | null
    }>
    assumptions: Array<{
      __typename?: "GenabilityPropertyData"
      keyName: string
      dataValue: string | null
      displayName: string | null
      description: string | null
      dataType: DataType | null
      dataFactor: number | null
      fromDateTime: string | null
      toDateTime: string | null
      duration: number | null
      unit: string | null
      accuracy: number | null
      operator: string | null
    }>
  } | null
  shortLink: {
    __typename?: "ShortLink"
    expiresAt: any
    url: string
    slug: string
  } | null
  proposalAdders: Array<{
    __typename?: "ProposalAdderObject"
    selected: boolean
    customQuantity: number | null
    customPrice: number | null
    createdAt: any
    updatedAt: any
    proposalId: string
    powurOsAdderId: number
    cost: number
    isVariable: boolean
    adder: {
      __typename?: "Adder"
      id: string
      title: string
      unit: number | null
      needsModuleCount: boolean
      priceList: any | null
      relatedPowurOsAdderId: number | null
      relatedAdder: any | null
      doesMountingTypeRequireInstaller: boolean
      powurOsId: number
      createdAt: any
      updatedAt: any
      category: any | null
      lenderCategories: any | null
      powurOsCategoryId: number
      proposalType: number | null
      proposalUseTypeId: number | null
      isVariable: boolean
      isCustom: boolean
    }
  }>
  seller: {
    __typename?: "User"
    id: string
    powurUserId: number | null
    permissions: Array<Permission>
    email: string
    phone: string | null
    createdAt: any
    updatedAt: any
    firstName: string
    lastName: string
    bio: string | null
    enterpriseId: string | null
    profileImage: {
      __typename?: "ProfileImg"
      bucket: string | null
      sizes: {
        __typename?: "ImageSizes"
        large: string | null
        thumb: string | null
        retina: string | null
        preview: string | null
        original: string | null
      } | null
    } | null
    licenses: Array<{
      __typename?: "License"
      id: string
      createdAt: any
      updatedAt: any
      externalId: string
      state: string
      name: string
      identifier: string
      expiresAt: any
      userId: string
    }> | null
    externalIds: Array<{
      __typename?: "ExternalIdentifier"
      id: string
      createdAt: any
      updatedAt: any
      provider: ExternalProvider
      identifier: string
      metadata: any
      userId: string
      proposalId: string | null
    }> | null
  }
  homeowner: {
    __typename?: "ProjectHomeowner"
    id: string
    createdAt: any
    updatedAt: any
    powurProjectId: number
    firstName: string
    lastName: string
    email: string
    phone: string | null
  }
  postSolarUtilityRate: {
    __typename?: "UtilityRate"
    id: string
    createdAt: any
    updatedAt: any
    masterTariffId: number
    tariffName: string
    lseName: string
    lseId: number
    tariffCode: string
    hasContractedRates: boolean | null
    hasTimeOfUseRates: boolean | null
    utilityCompany: {
      __typename?: "UtilityCompany"
      id: string
      ptcTduId: string | null
    } | null
  } | null
  site: {
    __typename?: "Site"
    id: string
    createdAt: any
    updatedAt: any
    latitude: number
    longitude: number
    streetViewLatitude: number | null
    streetViewLongitude: number | null
    address: string
    state: StateCode
    street: string
    locality: string
    postalCode: string
    postalCodeSuffix: string
    genabilityAccountId: string | null
    isEnergyCommunity: boolean
    isEnergyCommunityManuallySetAt: any | null
    imagery: Array<
      | {
          __typename: "Imagery"
          id: string
          createdAt: any
          updatedAt: any
          filename: string
          imageDate: string | null
          source: ImagerySource
          height: number | null
          width: number | null
          zoomLevel: number | null
          positionedX: number | null
          positionedY: number | null
          positionedZoom: number | null
        }
      | { __typename: "PoisonedImagery"; reason: string; data: any }
    >
  }
  utilityRate: {
    __typename?: "UtilityRate"
    id: string
    createdAt: any
    updatedAt: any
    masterTariffId: number
    tariffName: string
    hasContractedRates: boolean | null
    lseName: string
    lseId: number
    tariffCode: string
    hasTimeOfUseRates: boolean | null
    utilityCompany: {
      __typename?: "UtilityCompany"
      id: string
      ptcTduId: string | null
    } | null
  } | null
  selectedLoanProduct: {
    __typename?: "LoanProduct"
    id: string
    createdAt: any
    updatedAt: any
    escalator: number | null
    provider: LoanProvider
    rate: number
    term: number
    statesPossible: Array<StateCode>
    statesActive: Array<StateCode>
    powurOsCurrentDealerFee: number
    powurOsCurrentPowurMargin: number
    powurOsDealerFeePlusMargin: number
    powurOsLoanId: number | null
    powurOsLoanProviderId: number | null
    productName: string
    providerId: string
    providerFee: number
    providerMeta: any | null
    providerName: string | null
    minimumLoanAmount: number | null
    maximumLoanAmount: number | null
    introPaymentFactor: number
    minimumCreditScore: number | null
    activatedAt: any | null
    syncHistory: any | null
    loanType: string
  } | null
  designs: Array<{
    __typename?: "Design"
    id: string
    createdAt: any
    name: string | null
    activatedAt: any | null
    solarModule: { __typename?: "PricedEquipment"; name: string } | null
    designRequest: {
      __typename?: "DesignRequest"
      id: string
      promisedAt: any | null
      completedAt: any | null
      rejectedAt: any | null
      designNotes: Array<{
        __typename?: "DesignNote"
        id: string
        message: string
        reason: string | null
        createdAt: any
        createdById: string
      }>
    } | null
    designers: Array<{ __typename?: "DesignUser"; id: string }>
  }>
  incentives: Array<{
    __typename: "ProposalIncentive"
    createdAt: any
    updatedAt: any
    incentiveId: string
    proposalId: string
    applyToLoan: boolean
    showOnBrochure: boolean
    value: number
    incentive: {
      __typename?: "Incentive"
      id: string
      createdAt: any
      updatedAt: any
      activatedAt: any | null
      activeInZipCodes: Array<string>
      applicabilityMaxValue: number | null
      applicabilityMinValue: number | null
      applicabilityName: string | null
      canApplyToLoan: boolean
      customerClass: string
      customDisplayName: string | null
      documents: string | null
      eligibility: string
      endDate: string | null
      incentiveCategory: IncentiveCategory
      incentiveId: number | null
      incentiveName: string
      incentiveType: string
      incentivePaidTo: string | null
      isExhausted: boolean
      isPaidAsLumpSum: boolean
      isSungageRebate: boolean
      jurisdiction: string
      lseCode: string | null
      lseId: number | null
      lseName: string | null
      masterIncentiveId: number | null
      paymentCap: number | null
      paymentDuration: number
      percentCostCap: number | null
      projectType: string
      projectTypeExclusive: boolean | null
      quantityKeyCap: string | null
      rate: number
      rateUnit: string
      requirements: string | null
      serviceType: string | null
      startDate: string
      state: string
      summary: string
      tariffCode: string | null
      turnedOnByDefaultAt: any | null
      source: string
      applicabilities: Array<{
        __typename?: "Applicability"
        applicabilityKey: string
        description: string
        displayName: string
        maxValue: string | null
        minValue: string | null
        operator: string | null
        requiredValue: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
      }> | null
      percentCostCapKey: {
        __typename?: "PropertyKey"
        dataType: string | null
        description: string | null
        displayName: string | null
        entityId: number | null
        entityType: string | null
        family: string | null
        formulaDetail: string | null
        keyName: string | null
        keyspace: string | null
        lookbackIntervalQuantity: number | null
        lookbackQuantity: number | null
        lookbackSeasonId: number | null
        lookbackPeriod: string | null
        lookbackTimeOfUseId: number | null
        quantityUnit: string | null
        subKeyName: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
      } | null
      quantityKey: {
        __typename?: "PropertyKey"
        dataType: string | null
        description: string | null
        displayName: string | null
        entityId: number | null
        entityType: string | null
        family: string | null
        formulaDetail: string | null
        keyName: string | null
        keyspace: string | null
        lookbackIntervalQuantity: number | null
        lookbackQuantity: number | null
        lookbackSeasonId: number | null
        lookbackPeriod: string | null
        lookbackTimeOfUseId: number | null
        quantityUnit: string | null
        subKeyName: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
      }
      requiredData: Array<{
        __typename?: "Applicability"
        applicabilityKey: string
        description: string
        displayName: string
        maxValue: string | null
        minValue: string | null
        operator: string | null
        requiredValue: string | null
        choices: Array<{
          __typename?: "Choice"
          name: string | null
          displayName: string | null
          value: string
          displayValue: string | null
          dataValue: string | null
          likelihood: number | null
        }> | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
      }> | null
    }
  }> | null
  activeLoans: Array<{
    __typename?: "ActiveLoan"
    id: string
    createdAt: any
    updatedAt: any
    loanDocsSentAt: any | null
    proposalId: string
    loanProductId: string
    amount: number
    status: ActiveLoanStatus | null
    provider: LoanProvider
    providerId: string
    providerMetadata: any | null
    providerStatusEvents: Array<any> | null
    applicants: Array<{
      __typename?: "Applicant"
      id: string
      email: string
      firstName: string
      lastName: string
      isPrimary: boolean
    }> | null
  }> | null
  enterprise: {
    __typename?: "Enterprise"
    id: string
    name: string
    shouldCobrand: boolean
    marginVisibility: string | null
    commissionVisibility: string | null
    cobrandSettings: {
      __typename?: "EnterpriseCobrandSettingsObject"
      enterpriseId: string
      brochureSlides: Array<{
        __typename?: "BrochureSlidesObject"
        name: string
        url: string | null
      }>
    } | null
  } | null
  enterpriseSettings: {
    __typename?: "EnterpriseSettings"
    marginFixed: boolean
    proposalMargin: number
    managerMarginAdjustment: boolean
    managerMinimumMargin: number
    orgHoldbackPpw: number | null
    sellerPowurlinePpw: number | null
    entBaselinePpw: number | null
    compType: string | null
  } | null
}

export type MinimalProposalFieldsFragment = {
  __typename: "Proposal"
  id: string
  createdAt: any
  slug: string
  name: string | null
  displayAddress: {
    __typename?: "DisplayAddress"
    id: string
    updatedAt: any
    createdAt: any
    category: string
    city: string
    lat: number
    long: number
    postal: string
    projectId: number | null
    state: string
    street: string
  }
  seller: { __typename?: "User"; firstName: string; lastName: string }
  mentor: { __typename?: "User"; firstName: string; lastName: string } | null
  homeowner: {
    __typename?: "ProjectHomeowner"
    id: string
    createdAt: any
    updatedAt: any
    powurProjectId: number
    firstName: string
    lastName: string
    email: string
    phone: string | null
  }
  site: {
    __typename?: "Site"
    id: string
    createdAt: any
    updatedAt: any
    latitude: number
    longitude: number
    streetViewLatitude: number | null
    streetViewLongitude: number | null
    address: string
    state: StateCode
    street: string
    locality: string
    postalCode: string
    postalCodeSuffix: string
    genabilityAccountId: string | null
    isEnergyCommunity: boolean
    isEnergyCommunityManuallySetAt: any | null
    imagery: Array<
      | {
          __typename: "Imagery"
          id: string
          createdAt: any
          updatedAt: any
          filename: string
          imageDate: string | null
          source: ImagerySource
          height: number | null
          width: number | null
          zoomLevel: number | null
          positionedX: number | null
          positionedY: number | null
          positionedZoom: number | null
        }
      | { __typename: "PoisonedImagery"; reason: string; data: any }
    >
  }
  proposalStatuses: Array<{
    __typename?: "ProposalStatus"
    createdAt: any
    id: string
    message: string
    proposalId: string
    status: ProposalStatusType
    updatedAt: any
    updatedBy: string
  }> | null
}

export type ProposalCostFieldsFragment = {
  __typename?: "ProposalCost"
  id: string
  createdAt: any
  updatedAt: any
  designCost: number
  exciseTax: number
  proposalId: string
  salesTax: number
  totalCost: number
  batteryCost: number
  lineItems: Array<{
    __typename: "ProposalLineItem"
    id: string
    createdAt: any
    updatedAt: any
    displayName: string
    type: string
    subType: string | null
    cost: number
    quantity: number
    taxable: boolean
    powurOsId: number | null
    children: Array<{
      __typename: "ProposalLineItem"
      id: string
      createdAt: any
      updatedAt: any
      displayName: string
      type: string
      subType: string | null
      cost: number
      quantity: number
      taxable: boolean
      powurOsId: number | null
    }>
  }>
}

export type GetProposalQueryVariables = Exact<{
  findProposalInput: FindProposalInput
}>

export type GetProposalQuery = {
  __typename?: "Query"
  proposal: {
    __typename: "Proposal"
    annualEnergyUse: number | null
    allowChangeOrderEquipment: boolean
    createdAt: any
    currentStatus: string | null
    displayAddressId: string
    downPayment: number | null
    id: string
    mentorId: string | null
    primaryPresenter: number | null
    secondaryPresenter: number | null
    monthlyEnergyCost: Array<number>
    monthlyEnergyManualFlags: Array<boolean>
    monthlyEnergyUse: Array<number>
    smartEstimateBanner: string | null
    genabilityDefaultContractedRate: number | null
    slug: string
    systemType: SystemType | null
    secondarySystem: boolean
    newConstruction: boolean
    updatedAt: any
    utilityRateEscalationPercentage: number
    sellerId: string
    selectedLoanProductId: string | null
    newCustomerIncentive: boolean
    preferredLanguage: string
    margin: number
    powurProjectId: number
    enterpriseLogoUrl: string | null
    userAdjustedAfterSolarContractedRate: number | null
    userAdjustedBeforeSolarContractedRate: number | null
    userAdjustedUtilityRate: number | null
    name: string | null
    financeType: string | null
    financeProductId: string | null
    leadSource: string | null
    fundingGroup: string | null
    displayAddress: {
      __typename?: "DisplayAddress"
      id: string
      updatedAt: any
      createdAt: any
      category: string
      city: string
      lat: number
      long: number
      postal: string
      projectId: number | null
      state: string
      street: string
    }
    proposalCost: {
      __typename?: "ProposalCost"
      id: string
      createdAt: any
      updatedAt: any
      designCost: number
      exciseTax: number
      proposalId: string
      salesTax: number
      totalCost: number
      batteryCost: number
      lineItems: Array<{
        __typename: "ProposalLineItem"
        id: string
        createdAt: any
        updatedAt: any
        displayName: string
        type: string
        subType: string | null
        cost: number
        quantity: number
        taxable: boolean
        powurOsId: number | null
        children: Array<{
          __typename: "ProposalLineItem"
          id: string
          createdAt: any
          updatedAt: any
          displayName: string
          type: string
          subType: string | null
          cost: number
          quantity: number
          taxable: boolean
          powurOsId: number | null
        }>
      }>
    }
    mentor: {
      __typename?: "User"
      id: string
      powurUserId: number | null
      permissions: Array<Permission>
      email: string
      phone: string | null
      createdAt: any
      updatedAt: any
      firstName: string
      lastName: string
      bio: string | null
      enterpriseId: string | null
      profileImage: {
        __typename?: "ProfileImg"
        bucket: string | null
        sizes: {
          __typename?: "ImageSizes"
          large: string | null
          thumb: string | null
          retina: string | null
          preview: string | null
          original: string | null
        } | null
      } | null
      licenses: Array<{
        __typename?: "License"
        id: string
        createdAt: any
        updatedAt: any
        externalId: string
        state: string
        name: string
        identifier: string
        expiresAt: any
        userId: string
      }> | null
      externalIds: Array<{
        __typename?: "ExternalIdentifier"
        id: string
        createdAt: any
        updatedAt: any
        provider: ExternalProvider
        identifier: string
        metadata: any
        userId: string
        proposalId: string | null
      }> | null
    } | null
    usageProfile: {
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      profileId: string
      providerProfileId: string
    } | null
    genabilityUsageEstimate: {
      __typename?: "GenabilityCalculatedCost"
      calculatedCostId: string | null
      masterTariffId: number
      tariffName: string
      totalCost: number
      fromDateTime: string
      toDateTime: string
      currency: string
      accuracy: number
      summary: {
        __typename?: "GenabilityCalculatedCostSummary"
        preTaxMinimumCost: number | null
        subTotalCost: number
        taxCost: number
        totalCost: number
        adjustedTotalCost: number
        nonBypassableCost: number | null
        kWh: number
        kW: number
        import: number | null
        export: number | null
        ELECTRICITY: {
          __typename?: "GenabilityKWkWh"
          kWh: number
          kW: number
        } | null
      }
      items: Array<{
        __typename?: "GenabilityCalculatedCostItem"
        fromDateTime: string
        toDateTime: string
        quantityKey: string
        rateAmount: number
        itemQuantity: number
        cost: number | null
        chargeClass: string | null
        chargeType: string | null
      }>
      assumptions: Array<{
        __typename?: "GenabilityPropertyData"
        keyName: string
        dataValue: string | null
        displayName: string | null
        description: string | null
        dataType: DataType | null
        dataFactor: number | null
        fromDateTime: string | null
        toDateTime: string | null
        duration: number | null
        unit: string | null
        accuracy: number | null
        operator: string | null
      }>
    } | null
    shortLink: {
      __typename?: "ShortLink"
      expiresAt: any
      url: string
      slug: string
    } | null
    proposalAdders: Array<{
      __typename?: "ProposalAdderObject"
      selected: boolean
      customQuantity: number | null
      customPrice: number | null
      createdAt: any
      updatedAt: any
      proposalId: string
      powurOsAdderId: number
      cost: number
      isVariable: boolean
      adder: {
        __typename?: "Adder"
        id: string
        title: string
        unit: number | null
        needsModuleCount: boolean
        priceList: any | null
        relatedPowurOsAdderId: number | null
        relatedAdder: any | null
        doesMountingTypeRequireInstaller: boolean
        powurOsId: number
        createdAt: any
        updatedAt: any
        category: any | null
        lenderCategories: any | null
        powurOsCategoryId: number
        proposalType: number | null
        proposalUseTypeId: number | null
        isVariable: boolean
        isCustom: boolean
      }
    }>
    seller: {
      __typename?: "User"
      id: string
      powurUserId: number | null
      permissions: Array<Permission>
      email: string
      phone: string | null
      createdAt: any
      updatedAt: any
      firstName: string
      lastName: string
      bio: string | null
      enterpriseId: string | null
      profileImage: {
        __typename?: "ProfileImg"
        bucket: string | null
        sizes: {
          __typename?: "ImageSizes"
          large: string | null
          thumb: string | null
          retina: string | null
          preview: string | null
          original: string | null
        } | null
      } | null
      licenses: Array<{
        __typename?: "License"
        id: string
        createdAt: any
        updatedAt: any
        externalId: string
        state: string
        name: string
        identifier: string
        expiresAt: any
        userId: string
      }> | null
      externalIds: Array<{
        __typename?: "ExternalIdentifier"
        id: string
        createdAt: any
        updatedAt: any
        provider: ExternalProvider
        identifier: string
        metadata: any
        userId: string
        proposalId: string | null
      }> | null
    }
    homeowner: {
      __typename?: "ProjectHomeowner"
      id: string
      createdAt: any
      updatedAt: any
      powurProjectId: number
      firstName: string
      lastName: string
      email: string
      phone: string | null
    }
    postSolarUtilityRate: {
      __typename?: "UtilityRate"
      id: string
      createdAt: any
      updatedAt: any
      masterTariffId: number
      tariffName: string
      lseName: string
      lseId: number
      tariffCode: string
      hasContractedRates: boolean | null
      hasTimeOfUseRates: boolean | null
      utilityCompany: {
        __typename?: "UtilityCompany"
        id: string
        ptcTduId: string | null
      } | null
    } | null
    site: {
      __typename?: "Site"
      id: string
      createdAt: any
      updatedAt: any
      latitude: number
      longitude: number
      streetViewLatitude: number | null
      streetViewLongitude: number | null
      address: string
      state: StateCode
      street: string
      locality: string
      postalCode: string
      postalCodeSuffix: string
      genabilityAccountId: string | null
      isEnergyCommunity: boolean
      isEnergyCommunityManuallySetAt: any | null
      imagery: Array<
        | {
            __typename: "Imagery"
            id: string
            createdAt: any
            updatedAt: any
            filename: string
            imageDate: string | null
            source: ImagerySource
            height: number | null
            width: number | null
            zoomLevel: number | null
            positionedX: number | null
            positionedY: number | null
            positionedZoom: number | null
          }
        | { __typename: "PoisonedImagery"; reason: string; data: any }
      >
    }
    utilityRate: {
      __typename?: "UtilityRate"
      id: string
      createdAt: any
      updatedAt: any
      masterTariffId: number
      tariffName: string
      hasContractedRates: boolean | null
      lseName: string
      lseId: number
      tariffCode: string
      hasTimeOfUseRates: boolean | null
      utilityCompany: {
        __typename?: "UtilityCompany"
        id: string
        ptcTduId: string | null
      } | null
    } | null
    selectedLoanProduct: {
      __typename?: "LoanProduct"
      id: string
      createdAt: any
      updatedAt: any
      escalator: number | null
      provider: LoanProvider
      rate: number
      term: number
      statesPossible: Array<StateCode>
      statesActive: Array<StateCode>
      powurOsCurrentDealerFee: number
      powurOsCurrentPowurMargin: number
      powurOsDealerFeePlusMargin: number
      powurOsLoanId: number | null
      powurOsLoanProviderId: number | null
      productName: string
      providerId: string
      providerFee: number
      providerMeta: any | null
      providerName: string | null
      minimumLoanAmount: number | null
      maximumLoanAmount: number | null
      introPaymentFactor: number
      minimumCreditScore: number | null
      activatedAt: any | null
      syncHistory: any | null
      loanType: string
    } | null
    designs: Array<{
      __typename?: "Design"
      id: string
      createdAt: any
      name: string | null
      activatedAt: any | null
      solarModule: { __typename?: "PricedEquipment"; name: string } | null
      designRequest: {
        __typename?: "DesignRequest"
        id: string
        promisedAt: any | null
        completedAt: any | null
        rejectedAt: any | null
        designNotes: Array<{
          __typename?: "DesignNote"
          id: string
          message: string
          reason: string | null
          createdAt: any
          createdById: string
        }>
      } | null
      designers: Array<{ __typename?: "DesignUser"; id: string }>
    }>
    incentives: Array<{
      __typename: "ProposalIncentive"
      createdAt: any
      updatedAt: any
      incentiveId: string
      proposalId: string
      applyToLoan: boolean
      showOnBrochure: boolean
      value: number
      incentive: {
        __typename?: "Incentive"
        id: string
        createdAt: any
        updatedAt: any
        activatedAt: any | null
        activeInZipCodes: Array<string>
        applicabilityMaxValue: number | null
        applicabilityMinValue: number | null
        applicabilityName: string | null
        canApplyToLoan: boolean
        customerClass: string
        customDisplayName: string | null
        documents: string | null
        eligibility: string
        endDate: string | null
        incentiveCategory: IncentiveCategory
        incentiveId: number | null
        incentiveName: string
        incentiveType: string
        incentivePaidTo: string | null
        isExhausted: boolean
        isPaidAsLumpSum: boolean
        isSungageRebate: boolean
        jurisdiction: string
        lseCode: string | null
        lseId: number | null
        lseName: string | null
        masterIncentiveId: number | null
        paymentCap: number | null
        paymentDuration: number
        percentCostCap: number | null
        projectType: string
        projectTypeExclusive: boolean | null
        quantityKeyCap: string | null
        rate: number
        rateUnit: string
        requirements: string | null
        serviceType: string | null
        startDate: string
        state: string
        summary: string
        tariffCode: string | null
        turnedOnByDefaultAt: any | null
        source: string
        applicabilities: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
        percentCostCapKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        }
        requiredData: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
      }
    }> | null
    activeLoans: Array<{
      __typename?: "ActiveLoan"
      id: string
      createdAt: any
      updatedAt: any
      loanDocsSentAt: any | null
      proposalId: string
      loanProductId: string
      amount: number
      status: ActiveLoanStatus | null
      provider: LoanProvider
      providerId: string
      providerMetadata: any | null
      providerStatusEvents: Array<any> | null
      applicants: Array<{
        __typename?: "Applicant"
        id: string
        email: string
        firstName: string
        lastName: string
        isPrimary: boolean
      }> | null
    }> | null
    enterprise: {
      __typename?: "Enterprise"
      id: string
      name: string
      shouldCobrand: boolean
      marginVisibility: string | null
      commissionVisibility: string | null
      cobrandSettings: {
        __typename?: "EnterpriseCobrandSettingsObject"
        enterpriseId: string
        brochureSlides: Array<{
          __typename?: "BrochureSlidesObject"
          name: string
          url: string | null
        }>
      } | null
    } | null
    enterpriseSettings: {
      __typename?: "EnterpriseSettings"
      marginFixed: boolean
      proposalMargin: number
      managerMarginAdjustment: boolean
      managerMinimumMargin: number
      orgHoldbackPpw: number | null
      sellerPowurlinePpw: number | null
      entBaselinePpw: number | null
      compType: string | null
    } | null
  }
}

export type RefreshProposalMutationVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type RefreshProposalMutation = {
  __typename?: "Mutation"
  refreshProposal: boolean
}

export type UpdateProposalMutationVariables = Exact<{
  updateProposalInput: UpdateProposalInput
}>

export type UpdateProposalMutation = {
  __typename?: "Mutation"
  updateProposal: {
    __typename: "Proposal"
    annualEnergyUse: number | null
    allowChangeOrderEquipment: boolean
    createdAt: any
    currentStatus: string | null
    displayAddressId: string
    downPayment: number | null
    id: string
    mentorId: string | null
    primaryPresenter: number | null
    secondaryPresenter: number | null
    monthlyEnergyCost: Array<number>
    monthlyEnergyManualFlags: Array<boolean>
    monthlyEnergyUse: Array<number>
    smartEstimateBanner: string | null
    genabilityDefaultContractedRate: number | null
    slug: string
    systemType: SystemType | null
    secondarySystem: boolean
    newConstruction: boolean
    updatedAt: any
    utilityRateEscalationPercentage: number
    sellerId: string
    selectedLoanProductId: string | null
    newCustomerIncentive: boolean
    preferredLanguage: string
    margin: number
    powurProjectId: number
    enterpriseLogoUrl: string | null
    userAdjustedAfterSolarContractedRate: number | null
    userAdjustedBeforeSolarContractedRate: number | null
    userAdjustedUtilityRate: number | null
    name: string | null
    financeType: string | null
    financeProductId: string | null
    leadSource: string | null
    fundingGroup: string | null
    displayAddress: {
      __typename?: "DisplayAddress"
      id: string
      updatedAt: any
      createdAt: any
      category: string
      city: string
      lat: number
      long: number
      postal: string
      projectId: number | null
      state: string
      street: string
    }
    proposalCost: {
      __typename?: "ProposalCost"
      id: string
      createdAt: any
      updatedAt: any
      designCost: number
      exciseTax: number
      proposalId: string
      salesTax: number
      totalCost: number
      batteryCost: number
      lineItems: Array<{
        __typename: "ProposalLineItem"
        id: string
        createdAt: any
        updatedAt: any
        displayName: string
        type: string
        subType: string | null
        cost: number
        quantity: number
        taxable: boolean
        powurOsId: number | null
        children: Array<{
          __typename: "ProposalLineItem"
          id: string
          createdAt: any
          updatedAt: any
          displayName: string
          type: string
          subType: string | null
          cost: number
          quantity: number
          taxable: boolean
          powurOsId: number | null
        }>
      }>
    }
    mentor: {
      __typename?: "User"
      id: string
      powurUserId: number | null
      permissions: Array<Permission>
      email: string
      phone: string | null
      createdAt: any
      updatedAt: any
      firstName: string
      lastName: string
      bio: string | null
      enterpriseId: string | null
      profileImage: {
        __typename?: "ProfileImg"
        bucket: string | null
        sizes: {
          __typename?: "ImageSizes"
          large: string | null
          thumb: string | null
          retina: string | null
          preview: string | null
          original: string | null
        } | null
      } | null
      licenses: Array<{
        __typename?: "License"
        id: string
        createdAt: any
        updatedAt: any
        externalId: string
        state: string
        name: string
        identifier: string
        expiresAt: any
        userId: string
      }> | null
      externalIds: Array<{
        __typename?: "ExternalIdentifier"
        id: string
        createdAt: any
        updatedAt: any
        provider: ExternalProvider
        identifier: string
        metadata: any
        userId: string
        proposalId: string | null
      }> | null
    } | null
    usageProfile: {
      __typename?: "GenabilityProfile"
      id: string
      createdAt: any
      updatedAt: any
      type: GenabilityProfileType
      profileId: string
      providerProfileId: string
    } | null
    genabilityUsageEstimate: {
      __typename?: "GenabilityCalculatedCost"
      calculatedCostId: string | null
      masterTariffId: number
      tariffName: string
      totalCost: number
      fromDateTime: string
      toDateTime: string
      currency: string
      accuracy: number
      summary: {
        __typename?: "GenabilityCalculatedCostSummary"
        preTaxMinimumCost: number | null
        subTotalCost: number
        taxCost: number
        totalCost: number
        adjustedTotalCost: number
        nonBypassableCost: number | null
        kWh: number
        kW: number
        import: number | null
        export: number | null
        ELECTRICITY: {
          __typename?: "GenabilityKWkWh"
          kWh: number
          kW: number
        } | null
      }
      items: Array<{
        __typename?: "GenabilityCalculatedCostItem"
        fromDateTime: string
        toDateTime: string
        quantityKey: string
        rateAmount: number
        itemQuantity: number
        cost: number | null
        chargeClass: string | null
        chargeType: string | null
      }>
      assumptions: Array<{
        __typename?: "GenabilityPropertyData"
        keyName: string
        dataValue: string | null
        displayName: string | null
        description: string | null
        dataType: DataType | null
        dataFactor: number | null
        fromDateTime: string | null
        toDateTime: string | null
        duration: number | null
        unit: string | null
        accuracy: number | null
        operator: string | null
      }>
    } | null
    shortLink: {
      __typename?: "ShortLink"
      expiresAt: any
      url: string
      slug: string
    } | null
    proposalAdders: Array<{
      __typename?: "ProposalAdderObject"
      selected: boolean
      customQuantity: number | null
      customPrice: number | null
      createdAt: any
      updatedAt: any
      proposalId: string
      powurOsAdderId: number
      cost: number
      isVariable: boolean
      adder: {
        __typename?: "Adder"
        id: string
        title: string
        unit: number | null
        needsModuleCount: boolean
        priceList: any | null
        relatedPowurOsAdderId: number | null
        relatedAdder: any | null
        doesMountingTypeRequireInstaller: boolean
        powurOsId: number
        createdAt: any
        updatedAt: any
        category: any | null
        lenderCategories: any | null
        powurOsCategoryId: number
        proposalType: number | null
        proposalUseTypeId: number | null
        isVariable: boolean
        isCustom: boolean
      }
    }>
    seller: {
      __typename?: "User"
      id: string
      powurUserId: number | null
      permissions: Array<Permission>
      email: string
      phone: string | null
      createdAt: any
      updatedAt: any
      firstName: string
      lastName: string
      bio: string | null
      enterpriseId: string | null
      profileImage: {
        __typename?: "ProfileImg"
        bucket: string | null
        sizes: {
          __typename?: "ImageSizes"
          large: string | null
          thumb: string | null
          retina: string | null
          preview: string | null
          original: string | null
        } | null
      } | null
      licenses: Array<{
        __typename?: "License"
        id: string
        createdAt: any
        updatedAt: any
        externalId: string
        state: string
        name: string
        identifier: string
        expiresAt: any
        userId: string
      }> | null
      externalIds: Array<{
        __typename?: "ExternalIdentifier"
        id: string
        createdAt: any
        updatedAt: any
        provider: ExternalProvider
        identifier: string
        metadata: any
        userId: string
        proposalId: string | null
      }> | null
    }
    homeowner: {
      __typename?: "ProjectHomeowner"
      id: string
      createdAt: any
      updatedAt: any
      powurProjectId: number
      firstName: string
      lastName: string
      email: string
      phone: string | null
    }
    postSolarUtilityRate: {
      __typename?: "UtilityRate"
      id: string
      createdAt: any
      updatedAt: any
      masterTariffId: number
      tariffName: string
      lseName: string
      lseId: number
      tariffCode: string
      hasContractedRates: boolean | null
      hasTimeOfUseRates: boolean | null
      utilityCompany: {
        __typename?: "UtilityCompany"
        id: string
        ptcTduId: string | null
      } | null
    } | null
    site: {
      __typename?: "Site"
      id: string
      createdAt: any
      updatedAt: any
      latitude: number
      longitude: number
      streetViewLatitude: number | null
      streetViewLongitude: number | null
      address: string
      state: StateCode
      street: string
      locality: string
      postalCode: string
      postalCodeSuffix: string
      genabilityAccountId: string | null
      isEnergyCommunity: boolean
      isEnergyCommunityManuallySetAt: any | null
      imagery: Array<
        | {
            __typename: "Imagery"
            id: string
            createdAt: any
            updatedAt: any
            filename: string
            imageDate: string | null
            source: ImagerySource
            height: number | null
            width: number | null
            zoomLevel: number | null
            positionedX: number | null
            positionedY: number | null
            positionedZoom: number | null
          }
        | { __typename: "PoisonedImagery"; reason: string; data: any }
      >
    }
    utilityRate: {
      __typename?: "UtilityRate"
      id: string
      createdAt: any
      updatedAt: any
      masterTariffId: number
      tariffName: string
      hasContractedRates: boolean | null
      lseName: string
      lseId: number
      tariffCode: string
      hasTimeOfUseRates: boolean | null
      utilityCompany: {
        __typename?: "UtilityCompany"
        id: string
        ptcTduId: string | null
      } | null
    } | null
    selectedLoanProduct: {
      __typename?: "LoanProduct"
      id: string
      createdAt: any
      updatedAt: any
      escalator: number | null
      provider: LoanProvider
      rate: number
      term: number
      statesPossible: Array<StateCode>
      statesActive: Array<StateCode>
      powurOsCurrentDealerFee: number
      powurOsCurrentPowurMargin: number
      powurOsDealerFeePlusMargin: number
      powurOsLoanId: number | null
      powurOsLoanProviderId: number | null
      productName: string
      providerId: string
      providerFee: number
      providerMeta: any | null
      providerName: string | null
      minimumLoanAmount: number | null
      maximumLoanAmount: number | null
      introPaymentFactor: number
      minimumCreditScore: number | null
      activatedAt: any | null
      syncHistory: any | null
      loanType: string
    } | null
    designs: Array<{
      __typename?: "Design"
      id: string
      createdAt: any
      name: string | null
      activatedAt: any | null
      solarModule: { __typename?: "PricedEquipment"; name: string } | null
      designRequest: {
        __typename?: "DesignRequest"
        id: string
        promisedAt: any | null
        completedAt: any | null
        rejectedAt: any | null
        designNotes: Array<{
          __typename?: "DesignNote"
          id: string
          message: string
          reason: string | null
          createdAt: any
          createdById: string
        }>
      } | null
      designers: Array<{ __typename?: "DesignUser"; id: string }>
    }>
    incentives: Array<{
      __typename: "ProposalIncentive"
      createdAt: any
      updatedAt: any
      incentiveId: string
      proposalId: string
      applyToLoan: boolean
      showOnBrochure: boolean
      value: number
      incentive: {
        __typename?: "Incentive"
        id: string
        createdAt: any
        updatedAt: any
        activatedAt: any | null
        activeInZipCodes: Array<string>
        applicabilityMaxValue: number | null
        applicabilityMinValue: number | null
        applicabilityName: string | null
        canApplyToLoan: boolean
        customerClass: string
        customDisplayName: string | null
        documents: string | null
        eligibility: string
        endDate: string | null
        incentiveCategory: IncentiveCategory
        incentiveId: number | null
        incentiveName: string
        incentiveType: string
        incentivePaidTo: string | null
        isExhausted: boolean
        isPaidAsLumpSum: boolean
        isSungageRebate: boolean
        jurisdiction: string
        lseCode: string | null
        lseId: number | null
        lseName: string | null
        masterIncentiveId: number | null
        paymentCap: number | null
        paymentDuration: number
        percentCostCap: number | null
        projectType: string
        projectTypeExclusive: boolean | null
        quantityKeyCap: string | null
        rate: number
        rateUnit: string
        requirements: string | null
        serviceType: string | null
        startDate: string
        state: string
        summary: string
        tariffCode: string | null
        turnedOnByDefaultAt: any | null
        source: string
        applicabilities: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
        percentCostCapKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        } | null
        quantityKey: {
          __typename?: "PropertyKey"
          dataType: string | null
          description: string | null
          displayName: string | null
          entityId: number | null
          entityType: string | null
          family: string | null
          formulaDetail: string | null
          keyName: string | null
          keyspace: string | null
          lookbackIntervalQuantity: number | null
          lookbackQuantity: number | null
          lookbackSeasonId: number | null
          lookbackPeriod: string | null
          lookbackTimeOfUseId: number | null
          quantityUnit: string | null
          subKeyName: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
        }
        requiredData: Array<{
          __typename?: "Applicability"
          applicabilityKey: string
          description: string
          displayName: string
          maxValue: string | null
          minValue: string | null
          operator: string | null
          requiredValue: string | null
          choices: Array<{
            __typename?: "Choice"
            name: string | null
            displayName: string | null
            value: string
            displayValue: string | null
            dataValue: string | null
            likelihood: number | null
          }> | null
          quantityKey: {
            __typename?: "PropertyKey"
            dataType: string | null
            description: string | null
            displayName: string | null
            entityId: number | null
            entityType: string | null
            family: string | null
            formulaDetail: string | null
            keyName: string | null
            keyspace: string | null
            lookbackIntervalQuantity: number | null
            lookbackQuantity: number | null
            lookbackSeasonId: number | null
            lookbackPeriod: string | null
            lookbackTimeOfUseId: number | null
            quantityUnit: string | null
            subKeyName: string | null
            choices: Array<{
              __typename?: "Choice"
              name: string | null
              displayName: string | null
              value: string
              displayValue: string | null
              dataValue: string | null
              likelihood: number | null
            }> | null
          } | null
        }> | null
      }
    }> | null
    activeLoans: Array<{
      __typename?: "ActiveLoan"
      id: string
      createdAt: any
      updatedAt: any
      loanDocsSentAt: any | null
      proposalId: string
      loanProductId: string
      amount: number
      status: ActiveLoanStatus | null
      provider: LoanProvider
      providerId: string
      providerMetadata: any | null
      providerStatusEvents: Array<any> | null
      applicants: Array<{
        __typename?: "Applicant"
        id: string
        email: string
        firstName: string
        lastName: string
        isPrimary: boolean
      }> | null
    }> | null
    enterprise: {
      __typename?: "Enterprise"
      id: string
      name: string
      shouldCobrand: boolean
      marginVisibility: string | null
      commissionVisibility: string | null
      cobrandSettings: {
        __typename?: "EnterpriseCobrandSettingsObject"
        enterpriseId: string
        brochureSlides: Array<{
          __typename?: "BrochureSlidesObject"
          name: string
          url: string | null
        }>
      } | null
    } | null
    enterpriseSettings: {
      __typename?: "EnterpriseSettings"
      marginFixed: boolean
      proposalMargin: number
      managerMarginAdjustment: boolean
      managerMinimumMargin: number
      orgHoldbackPpw: number | null
      sellerPowurlinePpw: number | null
      entBaselinePpw: number | null
      compType: string | null
    } | null
  }
}

export type UpdateTotalCostByPricePerWattMutationVariables = Exact<{
  proposalId: Scalars["String"]["input"]
  pricePerWatt: Scalars["Float"]["input"]
}>

export type UpdateTotalCostByPricePerWattMutation = {
  __typename?: "Mutation"
  updateTotalCostByPricePerWatt: {
    __typename?: "BaseProposal"
    id: string
    margin: number
    totalCost: number
  }
}

export type AllProposalStatusFieldsFragment = {
  __typename?: "ProposalStatus"
  createdAt: any
  id: string
  message: string
  proposalId: string
  status: ProposalStatusType
  updatedAt: any
  updatedBy: string
}

export type FindProposalStatusesQueryVariables = Exact<{
  proposalId: Scalars["String"]["input"]
}>

export type FindProposalStatusesQuery = {
  __typename?: "Query"
  getProposalStatusEvents: Array<{
    __typename?: "ProposalStatus"
    id: string
    createdAt: any
    updatedAt: any
    message: string
    status: ProposalStatusType
    updatedBy: string
    proposalId: string
  }>
}

export type PublishProposalMutationVariables = Exact<{
  publishProposalInput: PublishProposalInput
}>

export type PublishProposalMutation = {
  __typename?: "Mutation"
  updateStatusProposalPublished: {
    __typename?: "ProposalStatus"
    id: string
    createdAt: any
    updatedAt: any
    message: string
    status: ProposalStatusType
    updatedBy: string
    proposalId: string
  }
}

export type RequestContractMutationVariables = Exact<{
  data: CreateProposalStatusInput
}>

export type RequestContractMutation = {
  __typename?: "Mutation"
  updateStatusProposalContractRequested: {
    __typename?: "ProposalStatus"
    id: string
    createdAt: any
    updatedAt: any
    message: string
    status: ProposalStatusType
    updatedBy: string
    proposalId: string
  }
}

export type ConfirmSummaryMutationVariables = Exact<{
  createProposalStatusInput: CreateProposalStatusInput
}>

export type ConfirmSummaryMutation = {
  __typename?: "Mutation"
  updateStatusSummaryConfirmed: {
    __typename?: "ProposalStatus"
    id: string
    createdAt: any
    updatedAt: any
    message: string
    status: ProposalStatusType
    updatedBy: string
    proposalId: string
  }
}

export type AllQuoteFieldsFragment = {
  __typename?: "Quote"
  id: string
  createdAt: any
  updatedAt: any
  loanAmount: number | null
  buyoutAmount: number | null
  paydownAmount: number | null
  poisonId: string | null
  monthlyPayments: Array<any> | null
  monthlyInitialPayment: number
  monthlyAdjustedPayment: number
  loanProductId: string
  paydownPercentage: number | null
  alternateMonthlyPayment: number | null
  finalMonthlyPayment: number | null
  finalEscalatedMonthlyPayment: number | null
  paymentFactors: any | null
  proposalId: string
  prepaid: number | null
  solarRate: number
  productionRate: number
  totalProjectCost: number | null
  goodleapJson: {
    __typename?: "GoodLeapPaymentsResponse"
    offerId: string
    disclaimerText: string | null
    loanAmount: {
      __typename?: "GoodLeapAmount"
      value: number | null
      type: string
    }
    calculations: Array<{
      __typename?: "GoodLeapCalculation"
      type: string
      interval: string
      paymentDescription: string | null
      paydownAmount: {
        __typename?: "GoodLeapAmount"
        value: number | null
        type: string
      } | null
      amount: {
        __typename?: "GoodLeapAmount"
        value: number | null
        type: string
      }
      roundedAmount: {
        __typename?: "GoodLeapAmount"
        value: number | null
        type: string
      }
    }>
  } | null
}

export type GetQuotesForProposalQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetQuotesForProposalQuery = {
  __typename?: "Query"
  getQuotesForProposal: Array<
    | {
        __typename: "PoisonedQuote"
        id: string
        createdAt: any
        updatedAt: any
        data: any
        reason: string
        quote: {
          __typename?: "Quote"
          id: string
          createdAt: any
          updatedAt: any
          loanAmount: number | null
          buyoutAmount: number | null
          paydownAmount: number | null
          poisonId: string | null
          monthlyPayments: Array<any> | null
          monthlyInitialPayment: number
          monthlyAdjustedPayment: number
          loanProductId: string
          paydownPercentage: number | null
          alternateMonthlyPayment: number | null
          finalMonthlyPayment: number | null
          finalEscalatedMonthlyPayment: number | null
          paymentFactors: any | null
          proposalId: string
          prepaid: number | null
          solarRate: number
          productionRate: number
          totalProjectCost: number | null
          goodleapJson: {
            __typename?: "GoodLeapPaymentsResponse"
            offerId: string
            disclaimerText: string | null
            loanAmount: {
              __typename?: "GoodLeapAmount"
              value: number | null
              type: string
            }
            calculations: Array<{
              __typename?: "GoodLeapCalculation"
              type: string
              interval: string
              paymentDescription: string | null
              paydownAmount: {
                __typename?: "GoodLeapAmount"
                value: number | null
                type: string
              } | null
              amount: {
                __typename?: "GoodLeapAmount"
                value: number | null
                type: string
              }
              roundedAmount: {
                __typename?: "GoodLeapAmount"
                value: number | null
                type: string
              }
            }>
          } | null
        }
      }
    | {
        __typename: "Quote"
        id: string
        createdAt: any
        updatedAt: any
        loanAmount: number | null
        buyoutAmount: number | null
        paydownAmount: number | null
        poisonId: string | null
        monthlyPayments: Array<any> | null
        monthlyInitialPayment: number
        monthlyAdjustedPayment: number
        loanProductId: string
        paydownPercentage: number | null
        alternateMonthlyPayment: number | null
        finalMonthlyPayment: number | null
        finalEscalatedMonthlyPayment: number | null
        paymentFactors: any | null
        proposalId: string
        prepaid: number | null
        solarRate: number
        productionRate: number
        totalProjectCost: number | null
        goodleapJson: {
          __typename?: "GoodLeapPaymentsResponse"
          offerId: string
          disclaimerText: string | null
          loanAmount: {
            __typename?: "GoodLeapAmount"
            value: number | null
            type: string
          }
          calculations: Array<{
            __typename?: "GoodLeapCalculation"
            type: string
            interval: string
            paymentDescription: string | null
            paydownAmount: {
              __typename?: "GoodLeapAmount"
              value: number | null
              type: string
            } | null
            amount: {
              __typename?: "GoodLeapAmount"
              value: number | null
              type: string
            }
            roundedAmount: {
              __typename?: "GoodLeapAmount"
              value: number | null
              type: string
            }
          }>
        } | null
      }
  >
}

export type AllImageryFieldsFragment = {
  __typename?: "Imagery"
  id: string
  createdAt: any
  updatedAt: any
  filename: string
  imageDate: string | null
  source: ImagerySource
  height: number | null
  width: number | null
  zoomLevel: number | null
  positionedX: number | null
  positionedY: number | null
  positionedZoom: number | null
}

export type AllSiteFieldsFragment = {
  __typename?: "Site"
  id: string
  createdAt: any
  updatedAt: any
  latitude: number
  longitude: number
  streetViewLatitude: number | null
  streetViewLongitude: number | null
  address: string
  state: StateCode
  street: string
  locality: string
  postalCode: string
  postalCodeSuffix: string
  genabilityAccountId: string | null
  isEnergyCommunity: boolean
  isEnergyCommunityManuallySetAt: any | null
  imagery: Array<
    | {
        __typename: "Imagery"
        id: string
        createdAt: any
        updatedAt: any
        filename: string
        imageDate: string | null
        source: ImagerySource
        height: number | null
        width: number | null
        zoomLevel: number | null
        positionedX: number | null
        positionedY: number | null
        positionedZoom: number | null
      }
    | { __typename: "PoisonedImagery"; reason: string; data: any }
  >
}

export type GetSiteQueryVariables = Exact<{
  id: Scalars["ID"]["input"]
}>

export type GetSiteQuery = {
  __typename?: "Query"
  site: {
    __typename: "Site"
    id: string
    createdAt: any
    updatedAt: any
    latitude: number
    longitude: number
    streetViewLatitude: number | null
    streetViewLongitude: number | null
    address: string
    state: StateCode
    street: string
    locality: string
    postalCode: string
    postalCodeSuffix: string
    genabilityAccountId: string | null
    isEnergyCommunity: boolean
    isEnergyCommunityManuallySetAt: any | null
    imagery: Array<
      | {
          __typename: "Imagery"
          id: string
          createdAt: any
          updatedAt: any
          filename: string
          imageDate: string | null
          source: ImagerySource
          height: number | null
          width: number | null
          zoomLevel: number | null
          positionedX: number | null
          positionedY: number | null
          positionedZoom: number | null
        }
      | { __typename: "PoisonedImagery"; reason: string; data: any }
    >
  }
}

export type GetSitesQueryVariables = Exact<{ [key: string]: never }>

export type GetSitesQuery = {
  __typename?: "Query"
  sites: Array<{
    __typename?: "Site"
    id: string
    createdAt: any
    updatedAt: any
    latitude: number
    longitude: number
    streetViewLatitude: number | null
    streetViewLongitude: number | null
    address: string
    state: StateCode
    street: string
    locality: string
    postalCode: string
    postalCodeSuffix: string
    genabilityAccountId: string | null
    isEnergyCommunity: boolean
    isEnergyCommunityManuallySetAt: any | null
    imagery: Array<
      | {
          __typename: "Imagery"
          id: string
          createdAt: any
          updatedAt: any
          filename: string
          imageDate: string | null
          source: ImagerySource
          height: number | null
          width: number | null
          zoomLevel: number | null
          positionedX: number | null
          positionedY: number | null
          positionedZoom: number | null
        }
      | { __typename: "PoisonedImagery"; reason: string; data: any }
    >
  }>
}

export type UpdateSiteMutationVariables = Exact<{
  updateSiteInput: UpdateSiteInput
}>

export type UpdateSiteMutation = {
  __typename?: "Mutation"
  updateSite: {
    __typename: "Site"
    id: string
    createdAt: any
    updatedAt: any
    latitude: number
    longitude: number
    streetViewLatitude: number | null
    streetViewLongitude: number | null
    address: string
    state: StateCode
    street: string
    locality: string
    postalCode: string
    postalCodeSuffix: string
    genabilityAccountId: string | null
    isEnergyCommunity: boolean
    isEnergyCommunityManuallySetAt: any | null
    imagery: Array<
      | {
          __typename: "Imagery"
          id: string
          createdAt: any
          updatedAt: any
          filename: string
          imageDate: string | null
          source: ImagerySource
          height: number | null
          width: number | null
          zoomLevel: number | null
          positionedX: number | null
          positionedY: number | null
          positionedZoom: number | null
        }
      | { __typename: "PoisonedImagery"; reason: string; data: any }
    >
  }
}

export type AllUserFieldsFragment = {
  __typename?: "User"
  id: string
  powurUserId: number | null
  permissions: Array<Permission>
  email: string
  phone: string | null
  createdAt: any
  updatedAt: any
  firstName: string
  lastName: string
  bio: string | null
  enterpriseId: string | null
  profileImage: {
    __typename?: "ProfileImg"
    bucket: string | null
    sizes: {
      __typename?: "ImageSizes"
      large: string | null
      thumb: string | null
      retina: string | null
      preview: string | null
      original: string | null
    } | null
  } | null
  licenses: Array<{
    __typename?: "License"
    id: string
    createdAt: any
    updatedAt: any
    externalId: string
    state: string
    name: string
    identifier: string
    expiresAt: any
    userId: string
  }> | null
  externalIds: Array<{
    __typename?: "ExternalIdentifier"
    id: string
    createdAt: any
    updatedAt: any
    provider: ExternalProvider
    identifier: string
    metadata: any
    userId: string
    proposalId: string | null
  }> | null
}

export type SearchUsersQueryVariables = Exact<{
  searchTerms: SearchUserInput
}>

export type SearchUsersQuery = {
  __typename?: "Query"
  searchUsers: Array<{
    __typename?: "User"
    id: string
    powurUserId: number | null
    permissions: Array<Permission>
    email: string
    phone: string | null
    createdAt: any
    updatedAt: any
    firstName: string
    lastName: string
    bio: string | null
    enterpriseId: string | null
    profileImage: {
      __typename?: "ProfileImg"
      bucket: string | null
      sizes: {
        __typename?: "ImageSizes"
        large: string | null
        thumb: string | null
        retina: string | null
        preview: string | null
        original: string | null
      } | null
    } | null
    licenses: Array<{
      __typename?: "License"
      id: string
      createdAt: any
      updatedAt: any
      externalId: string
      state: string
      name: string
      identifier: string
      expiresAt: any
      userId: string
    }> | null
    externalIds: Array<{
      __typename?: "ExternalIdentifier"
      id: string
      createdAt: any
      updatedAt: any
      provider: ExternalProvider
      identifier: string
      metadata: any
      userId: string
      proposalId: string | null
    }> | null
  }>
}

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput
  id: Scalars["ID"]["input"]
}>

export type UpdateUserMutation = {
  __typename?: "Mutation"
  updateUser: {
    __typename: "User"
    id: string
    powurUserId: number | null
    permissions: Array<Permission>
    email: string
    phone: string | null
    createdAt: any
    updatedAt: any
    firstName: string
    lastName: string
    bio: string | null
    enterpriseId: string | null
    profileImage: {
      __typename?: "ProfileImg"
      bucket: string | null
      sizes: {
        __typename?: "ImageSizes"
        large: string | null
        thumb: string | null
        retina: string | null
        preview: string | null
        original: string | null
      } | null
    } | null
    licenses: Array<{
      __typename?: "License"
      id: string
      createdAt: any
      updatedAt: any
      externalId: string
      state: string
      name: string
      identifier: string
      expiresAt: any
      userId: string
    }> | null
    externalIds: Array<{
      __typename?: "ExternalIdentifier"
      id: string
      createdAt: any
      updatedAt: any
      provider: ExternalProvider
      identifier: string
      metadata: any
      userId: string
      proposalId: string | null
    }> | null
  }
}

export type AllUtilityRateFieldsFragment = {
  __typename?: "UtilityRate"
  id: string
  createdAt: any
  updatedAt: any
  activatedAt: any | null
  billingPeriod: string
  chargePeriod: string | null
  chargeTypes: string | null
  closedDate: string | null
  currency: string
  customerClass: string | null
  customerCount: number | null
  customerCountSource: string | null
  customerLikelihood: number | null
  effectiveDate: string | null
  effectiveOnRule: string | null
  endDate: string | null
  hasContractedRates: boolean | null
  hasNetMetering: boolean | null
  hasRateApplicability: boolean | null
  hasTariffApplicability: boolean | null
  hasTieredRates: boolean | null
  hasTimeOfUseRates: boolean | null
  isSolarPvEligible: boolean
  isActive: boolean
  isNEM3: boolean
  lseCode: string | null
  lseId: number
  lseName: string
  masterTariffId: number
  maxMonthlyConsumption: number | null
  maxMonthlyDemand: number | null
  minMonthlyConsumption: number | null
  minMonthlyDemand: number | null
  priorTariffId: number | null
  privacy: string | null
  serviceType: string | null
  tariffBookName: string | null
  tariffCode: string
  tariffId: number
  tariffName: string
  tariffType: string | null
  territoryId: number | null
  timeZone: string
  utilityCompanyId: string | null
  utilityRateZipCodeLikelihoods: Array<{
    __typename?: "UtilityRateZipCodeLikelihood"
    createdAt: any
    updatedAt: any
    zipcode: string
    rateTariffId: number
    likelihood: number | null
  }> | null
}

export type GetUtilityRatesForCompanyQueryVariables = Exact<{
  lseId: Scalars["String"]["input"]
}>

export type GetUtilityRatesForCompanyQuery = {
  __typename?: "Query"
  utilityTariffsForCompany: Array<{
    __typename?: "UtilityRate"
    id: string
    createdAt: any
    updatedAt: any
    activatedAt: any | null
    billingPeriod: string
    chargePeriod: string | null
    chargeTypes: string | null
    closedDate: string | null
    currency: string
    customerClass: string | null
    customerCount: number | null
    customerCountSource: string | null
    customerLikelihood: number | null
    effectiveDate: string | null
    effectiveOnRule: string | null
    endDate: string | null
    hasContractedRates: boolean | null
    hasNetMetering: boolean | null
    hasRateApplicability: boolean | null
    hasTariffApplicability: boolean | null
    hasTieredRates: boolean | null
    hasTimeOfUseRates: boolean | null
    isSolarPvEligible: boolean
    isActive: boolean
    isNEM3: boolean
    lseCode: string | null
    lseId: number
    lseName: string
    masterTariffId: number
    maxMonthlyConsumption: number | null
    maxMonthlyDemand: number | null
    minMonthlyConsumption: number | null
    minMonthlyDemand: number | null
    priorTariffId: number | null
    privacy: string | null
    serviceType: string | null
    tariffBookName: string | null
    tariffCode: string
    tariffId: number
    tariffName: string
    tariffType: string | null
    territoryId: number | null
    timeZone: string
    utilityCompanyId: string | null
    utilityRateZipCodeLikelihoods: Array<{
      __typename?: "UtilityRateZipCodeLikelihood"
      createdAt: any
      updatedAt: any
      zipcode: string
      rateTariffId: number
      likelihood: number | null
    }> | null
  }>
}

export const AllGlBorrowerFieldsFragmentDoc = `
    fragment AllGlBorrowerFields on GoodleapLoanDetails {
  borrower {
    firstName
    lastName
    email
    phones {
      value
      type
    }
    address {
      street
      street2
      city
      state
      zip
    }
  }
  coBorrower {
    firstName
    lastName
    email
    phones {
      value
      type
    }
    address {
      street
      street2
      city
      state
      zip
    }
  }
}
    `
export const CurrencyFieldsFragmentDoc = `
    fragment CurrencyFields on Currency {
  type
  value
}
    `
export const AmountFieldsFragmentDoc = `
    fragment AmountFields on GoodLeapAmount {
  type
  value
}
    `
export const BrochureMonthFieldsFragmentDoc = `
    fragment BrochureMonthFields on BrochureMonth {
  month
  production_kWh
  import_kWh
  export_kWh
  postSolarUtilityCost_USD
  postSolarEnergyCost_USD
  postSolarFixedCost_USD
  postSolarLoanPayment_USD
  preSolarUtilityCost_USD
  preSolarEnergyCost_USD
  preSolarFixedCost_USD
}
    `
export const BrochureUtilityBillFieldsFragmentDoc = `
    fragment BrochureUtilityBillFields on BrochureUtilityBill {
  sortOrder
  bill
  energy
  fixed
  payment
}
    `
export const AllBrochureFieldsFragmentDoc = `
    fragment AllBrochureFields on Brochure {
  id
  proposalId
  createdAt
  updatedAt
  annualSolarProduction
  baseGenabilityUtilityRate
  dialUtilityRates
  energyOffset
  userAdjustedUtilityRate
  utilityRateEscalationPercentage
  months {
    ...BrochureMonthFields
  }
  afterSolarUtilityBills {
    ...BrochureUtilityBillFields
  }
  beforeSolarUtilityBills {
    ...BrochureUtilityBillFields
  }
}
    `
export const AllContractFieldsFragmentDoc = `
    fragment AllContractFields on Contract {
  id
  createdAt
  updatedAt
  dateSent
  dateSigned
  dateSentToPowurOs
  recipientEmail
  totalCost
  systemSize
  envelopeId
  proposalId
  contractType
  contractPackageVersion
}
    `
export const EstimateFieldsFragmentDoc = `
    fragment EstimateFields on Estimate {
  acAnnual
  acMonthly
  createdAt
  updatedAt
  errors
  id
  designId
  installAreaId
  solarProfileId
  solarProfile {
    id
    createdAt
    updatedAt
    type
    providerProfileId
    profileId
  }
  inputs {
    array_type
    azimuth
    dc_ac_ratio
    inv_eff
    lat
    lon
    losses
    module_type
    system_capacity
    tilt
  }
  sscInfo {
    build
    version
  }
  stationInfo {
    city
    distance
    elev
    lat
    location
    lon
    solar_resource_file
    state
    tz
  }
  acHourly
}
    `
export const AllDesignFieldsFragmentDoc = `
    fragment AllDesignFields on Design {
  __typename
  activatedAt
  createdAt
  edges
  id
  installAreas
  installAreasToPanels
  nodes
  obstructions
  setbacks
  panels
  completedAt
  phase
  proposalId
  shadingAreas
  tool
  type
  updatedAt
  homeownerRebate
  homeownerRebateAmount
  treeTrimmingRebate
  treeTrimmingRebateAmount
  energyEfficiencyKitRebate
  energyEfficiencyKitRebateAmount
  roofWorkRebate
  roofWorkRebateAmount
  source
  annualProduction
  annualOffset
  systemSizeKw
  extendedWarrantyPowurOsId
  extendedWarrantyName
  extendedWarrantySpanishName
  extendedWarrantyFamily
  extendedWarrantyCost
  brochurePositionX
  brochurePositionY
  brochureZoom
  evOutlet
  evCharger
  displayImageryProvider
  designRequestId
  sunroofCheckedAt
  openSolarImage {
    id
    filename
    height
    width
  }
  optimalEstimate {
    __typename
    ... on Estimate {
      ...EstimateFields
    }
    ... on PoisonedEstimate {
      id
      createdAt
      updatedAt
      data
      reason
      estimate {
        ...EstimateFields
      }
    }
  }
  poison {
    reason
    data
  }
}
    `
export const AllDesignNoteFieldsFragmentDoc = `
    fragment AllDesignNoteFields on DesignNote {
  createdAt
  createdById
  designRequestId
  id
  message
  reason
  updatedAt
}
    `
export const AllDesignRequestFieldsFragmentDoc = `
    fragment AllDesignRequestFields on DesignRequest {
  completedAt
  createdAt
  rejectedAt
  design {
    id
  }
  designNotes {
    ...AllDesignNoteFields
  }
  designUserId
  enterpriseId
  id
  priority
  promisedAt
  updatedAt
}
    `
export const AllDesignUserFieldsFragmentDoc = `
    fragment AllDesignUserFields on DesignUser {
  completedAt
  createdAt
  designId
  designRequests {
    ...AllDesignRequestFields
  }
  id
  startedAt
  updatedAt
  userId
}
    `
export const AllDesignRequestWithDesignFieldsFragmentDoc = `
    fragment AllDesignRequestWithDesignFields on DesignRequest {
  completedAt
  createdAt
  rejectedAt
  design {
    ...AllDesignFields
  }
  designNotes {
    ...AllDesignNoteFields
  }
  designUser {
    ...AllDesignUserFields
  }
  designUserId
  enterpriseId
  id
  priority
  promisedAt
  updatedAt
}
    `
export const EquipmentFieldsFragmentDoc = `
    fragment EquipmentFields on PricedEquipment {
  id
  createdAt
  updatedAt
  name
  catalogNumber
  wattage
  powurOsEquipmentTypeId
  equipmentTypeId
  fallbackPrice
  equipmentType {
    id
    createdAt
    updatedAt
    powurOsId
    name
  }
  powurOsManufacturerId
  manufacturerId
  manufacturer {
    id
    createdAt
    updatedAt
    powurOsId
    name
  }
  warranty
  parentEquipmentAssociations
  childEquipmentAssociations
  height
  width
  cecWeightedEfficiency
  powurOsModuleDataId
  moduleData
  powurOsEnergyBackupDataId
  energyBackupData
  powurOsInverterDataId
  inverterData
  currentProposalPrice
  proposalPrices
  description
  basicAdderAssociations {
    adderId
    equipmentId
    qty
  }
  compatibleInverterManufacturers {
    manufacturerId
  }
  isKit
}
    `
export const AllDesignEquipmentFragmentDoc = `
    fragment AllDesignEquipment on Design {
  batteryCompatibility
  solarModuleId
  solarModule {
    ...EquipmentFields
  }
  inverterId
  secondaryInverterId
  inverterManufacturer
  inverter {
    ...EquipmentFields
  }
  secondaryInverter {
    ...EquipmentFields
  }
  designEquipment {
    id
    createdAt
    updatedAt
    designId
    equipmentId
    powurOsEquipmentTypeId
    quantity
    price
    equipment {
      ...EquipmentFields
    }
  }
  energyBackupId
  energyBackup {
    ...EquipmentFields
  }
  profiles {
    id
    createdAt
    updatedAt
    type
    providerProfileId
    profileId
  }
}
    `
export const SavingsFieldsFragmentDoc = `
    fragment SavingsFields on Savings {
  inputs {
    projectDuration
    preSolarMasterTariffId
    postSolarMasterTariffId
    rateInflation
    solarDegradation
    fromDateTime
    genabilityAccountId
    optimizedConsumptionProviderProfileId
    optimizedProductionProviderProfileId
    consumptionProviderProfileId
    storageProviderProfileId
    productionProviderProfileIds
    userAdjustedRate
  }
  outputs {
    designId
    dataStatus
    currency
    summary {
      lifeTimeUtilityAfterCost
      lifeTimeUtilityAvoidedRate
      lifetimeAvoidedCost
      lifetimeSolarCost
      lifetimeWithoutCost
      netAvoidedCost
      netAvoidedCostPctOffset
      netAvoidedKWh
      netAvoidedKWhPctOffset
      netAvoidedRate
      postTotalCost
      postTotalKWh
      postTotalKWhCost
      postTotalKWhRate
      postTotalMinCost
      postTotalNonBypassableCost
      postTotalNonMinCost
      postTotalRate
      preTotalCost
      preTotalKWh
      preTotalKWhCost
      preTotalKWhRate
      preTotalMinCost
      preTotalNonBypassableCost
      preTotalNonMinCost
      preTotalRate
    }
    scenarios {
      id
      name
      serviceType
      inputs {
        keyName
        displayName
        dataType
        fromDateTime
        toDateTime
        dataValue
        operator
      }
      rates {
        fromDateTime
        toDateTime
        chargeType
        chargePeriod
        rateName
        rateBands {
          tariffRateBandId
          tariffRateId
          rateSequenceNumber
          hasConsumptionLimit
          hasDemandLimit
          hasPropertyLimit
          rateAmount
          rateUnit
          isCredit
        }
        scenarios
      }
    }
    series {
      seriesId
      fromDateTime
      toDateTime
      scenario
      displayLabel
      seriesPeriod
      seriesDuration
      designId
      key
      rate
      qty
      cost
    }
    seriesData {
      seriesId
      fromDateTime
      toDateTime
      rate
      qty
      cost
    }
    seriesCosts {
      masterTariffId
      tariffName
      totalCost
      fromDateTime
      toDateTime
      accuracy
      currency
      calculatedCostId
      summary {
        ELECTRICITY {
          kW
          kWh
          __typename
        }
        export
        import
        nonBypassableCost
        preTaxMinimumCost
        subTotalCost
        taxCost
        totalCost
        adjustedTotalCost
        kWh
        kW
      }
      items {
        tariffId
        tariffRateId
        tariffRateBandId
        rateSequenceNumber
        rateName
        fromDateTime
        toDateTime
        quantityKey
        quantityKeyDescription
        rateType
        tierLowerLimit
        tierUpperLimit
        itemQuantity
        cost
        rateProration
        chargeType
        chargeClass
        periodType
        demandInterval
        duration
        touId
        touName
        seasonId
        formula
        transactionType
      }
    }
  }
  designId
  createdAt
  updatedAt
  id
}
    `
export const AllNewEquipmentFieldsFragmentDoc = `
    fragment AllNewEquipmentFields on NewEquipment {
  id
  name
  proposalName
  type
  typeId
  currentProposalPrice
  description
  manufacturerId
  manufacturer
  catalogNumber
  isKit
  isBattery
  isDefault
  batteryData
  inverterData
  evChargerData
  wattage
  height
  width
}
    `
export const AllAddressFieldsFragmentDoc = `
    fragment AllAddressFields on DisplayAddress {
  id
  updatedAt
  createdAt
  category
  city
  lat
  long
  postal
  projectId
  state
  street
}
    `
export const AllProposalLineItemFieldsFragmentDoc = `
    fragment AllProposalLineItemFields on ProposalLineItem {
  __typename
  id
  createdAt
  updatedAt
  displayName
  type
  subType
  cost
  quantity
  taxable
  powurOsId
  children {
    __typename
    id
    createdAt
    updatedAt
    displayName
    type
    subType
    cost
    quantity
    taxable
    powurOsId
  }
}
    `
export const ProposalCostFieldsFragmentDoc = `
    fragment ProposalCostFields on ProposalCost {
  id
  createdAt
  updatedAt
  designCost
  exciseTax
  proposalId
  salesTax
  totalCost
  batteryCost
  lineItems {
    ...AllProposalLineItemFields
  }
}
    `
export const AllUserFieldsFragmentDoc = `
    fragment AllUserFields on User {
  id
  powurUserId
  permissions
  email
  phone
  createdAt
  updatedAt
  firstName
  lastName
  bio
  enterpriseId
  profileImage {
    bucket
    sizes {
      large
      thumb
      retina
      preview
      original
    }
  }
  licenses {
    id
    createdAt
    updatedAt
    externalId
    state
    name
    identifier
    expiresAt
    userId
  }
  externalIds {
    id
    createdAt
    updatedAt
    provider
    identifier
    metadata
    userId
    proposalId
  }
}
    `
export const AllAdderFieldsFragmentDoc = `
    fragment AllAdderFields on Adder {
  id
  title
  unit
  needsModuleCount
  priceList
  relatedPowurOsAdderId
  relatedAdder
  doesMountingTypeRequireInstaller
  powurOsId
  createdAt
  updatedAt
  category
  lenderCategories
  powurOsCategoryId
  proposalType
  proposalUseTypeId
  isVariable
  isCustom
}
    `
export const AllProposalAdderFieldsFragmentDoc = `
    fragment AllProposalAdderFields on ProposalAdderObject {
  selected
  customQuantity
  customPrice
  createdAt
  updatedAt
  proposalId
  powurOsAdderId
  cost
  isVariable
  adder {
    ...AllAdderFields
  }
}
    `
export const AllImageryFieldsFragmentDoc = `
    fragment AllImageryFields on Imagery {
  id
  createdAt
  updatedAt
  filename
  imageDate
  source
  height
  width
  zoomLevel
  positionedX
  positionedY
  positionedZoom
}
    `
export const AllSiteFieldsFragmentDoc = `
    fragment AllSiteFields on Site {
  id
  createdAt
  updatedAt
  latitude
  longitude
  streetViewLatitude
  streetViewLongitude
  address
  state
  street
  locality
  postalCode
  postalCodeSuffix
  genabilityAccountId
  isEnergyCommunity
  isEnergyCommunityManuallySetAt
  imagery {
    __typename
    ... on Imagery {
      ...AllImageryFields
    }
    ... on PoisonedImagery {
      reason
      data
    }
  }
}
    `
export const AllLoanProductFieldsFragmentDoc = `
    fragment AllLoanProductFields on LoanProduct {
  id
  createdAt
  updatedAt
  escalator
  provider
  rate
  term
  statesPossible
  statesActive
  powurOsCurrentDealerFee
  powurOsCurrentPowurMargin
  powurOsDealerFeePlusMargin
  powurOsLoanId
  powurOsLoanProviderId
  productName
  providerId
  providerFee
  providerMeta
  providerName
  minimumLoanAmount
  maximumLoanAmount
  introPaymentFactor
  minimumCreditScore
  activatedAt
  syncHistory
  loanType
}
    `
export const AllPropertyFieldsFragmentDoc = `
    fragment AllPropertyFields on PropertyKey {
  choices {
    name
    displayName
    value
    displayValue
    dataValue
    likelihood
  }
  dataType
  description
  displayName
  entityId
  entityType
  family
  formulaDetail
  keyName
  keyspace
  lookbackIntervalQuantity
  lookbackQuantity
  lookbackSeasonId
  lookbackPeriod
  lookbackTimeOfUseId
  quantityUnit
  subKeyName
}
    `
export const AllApplicabilityFieldsFragmentDoc = `
    fragment AllApplicabilityFields on Applicability {
  applicabilityKey
  choices {
    name
    displayName
    value
    displayValue
    dataValue
    likelihood
  }
  description
  displayName
  maxValue
  minValue
  operator
  quantityKey {
    ...AllPropertyFields
  }
  requiredValue
}
    `
export const AllIncentiveFieldsFragmentDoc = `
    fragment AllIncentiveFields on Incentive {
  id
  createdAt
  updatedAt
  activatedAt
  activeInZipCodes
  applicabilities {
    ...AllApplicabilityFields
  }
  applicabilityMaxValue
  applicabilityMinValue
  applicabilityName
  canApplyToLoan
  customerClass
  customDisplayName
  documents
  eligibility
  endDate
  incentiveCategory
  incentiveId
  incentiveName
  incentiveType
  incentivePaidTo
  isExhausted
  isPaidAsLumpSum
  isSungageRebate
  jurisdiction
  lseCode
  lseId
  lseName
  masterIncentiveId
  paymentCap
  paymentDuration
  percentCostCap
  percentCostCapKey {
    ...AllPropertyFields
  }
  projectType
  projectTypeExclusive
  quantityKey {
    ...AllPropertyFields
  }
  quantityKeyCap
  rate
  rateUnit
  requiredData {
    ...AllApplicabilityFields
  }
  requirements
  serviceType
  startDate
  state
  summary
  tariffCode
  turnedOnByDefaultAt
  source
}
    `
export const AllProposalIncentiveFieldsFragmentDoc = `
    fragment AllProposalIncentiveFields on ProposalIncentive {
  __typename
  createdAt
  updatedAt
  incentiveId
  incentive {
    ...AllIncentiveFields
  }
  proposalId
  applyToLoan
  showOnBrochure
  value
}
    `
export const AllActiveLoanFieldsFragmentDoc = `
    fragment AllActiveLoanFields on ActiveLoan {
  id
  createdAt
  updatedAt
  loanDocsSentAt
  proposalId
  loanProductId
  applicants {
    id
    email
    firstName
    lastName
    isPrimary
  }
  amount
  status
  provider
  providerId
  providerMetadata
  providerStatusEvents
}
    `
export const AllProposalFieldsFragmentDoc = `
    fragment AllProposalFields on Proposal {
  __typename
  annualEnergyUse
  allowChangeOrderEquipment
  createdAt
  currentStatus
  displayAddress {
    ...AllAddressFields
  }
  displayAddressId
  downPayment
  proposalCost {
    ...ProposalCostFields
  }
  id
  mentor {
    ...AllUserFields
  }
  mentorId
  primaryPresenter
  secondaryPresenter
  monthlyEnergyCost
  monthlyEnergyManualFlags
  monthlyEnergyUse
  smartEstimateBanner
  usageProfile {
    id
    createdAt
    updatedAt
    type
    profileId
    providerProfileId
  }
  genabilityDefaultContractedRate
  genabilityUsageEstimate {
    calculatedCostId
    masterTariffId
    tariffName
    totalCost
    fromDateTime
    toDateTime
    currency
    summary {
      ELECTRICITY {
        kWh
        kW
      }
      preTaxMinimumCost
      subTotalCost
      taxCost
      totalCost
      adjustedTotalCost
      nonBypassableCost
      kWh
      kW
      import
      export
    }
    accuracy
    items {
      fromDateTime
      toDateTime
      quantityKey
      rateAmount
      itemQuantity
      cost
      chargeClass
      chargeType
    }
    assumptions {
      keyName
      dataValue
      displayName
      description
      dataType
      dataFactor
      fromDateTime
      toDateTime
      duration
      unit
      accuracy
      operator
    }
  }
  shortLink {
    expiresAt
    url
    slug
  }
  slug
  systemType
  secondarySystem
  newConstruction
  updatedAt
  utilityRateEscalationPercentage
  proposalAdders {
    ...AllProposalAdderFields
  }
  seller {
    ...AllUserFields
  }
  sellerId
  homeowner {
    id
    createdAt
    updatedAt
    powurProjectId
    firstName
    lastName
    email
    phone
  }
  postSolarUtilityRate {
    id
    createdAt
    updatedAt
    masterTariffId
    tariffName
    lseName
    lseId
    tariffCode
    hasContractedRates
    hasTimeOfUseRates
    utilityCompany {
      id
      ptcTduId
    }
  }
  site {
    ...AllSiteFields
  }
  utilityRate {
    id
    createdAt
    updatedAt
    masterTariffId
    tariffName
    hasContractedRates
    lseName
    lseId
    tariffCode
    hasContractedRates
    hasTimeOfUseRates
    utilityCompany {
      id
      ptcTduId
    }
  }
  selectedLoanProduct {
    ...AllLoanProductFields
  }
  selectedLoanProductId
  designs {
    id
    createdAt
    name
    activatedAt
    solarModule {
      name
    }
    designRequest {
      id
      promisedAt
      completedAt
      rejectedAt
      designNotes {
        id
        message
        reason
        createdAt
        createdById
      }
    }
    designers {
      id
    }
  }
  incentives {
    ...AllProposalIncentiveFields
  }
  site {
    ...AllSiteFields
  }
  newCustomerIncentive
  preferredLanguage
  activeLoans {
    ...AllActiveLoanFields
  }
  enterprise {
    id
    name
    shouldCobrand
    cobrandSettings {
      enterpriseId
      brochureSlides {
        name
        url
      }
    }
    marginVisibility
    commissionVisibility
  }
  enterpriseSettings {
    marginFixed
    proposalMargin
    managerMarginAdjustment
    managerMinimumMargin
    orgHoldbackPpw
    sellerPowurlinePpw
    entBaselinePpw
    compType
  }
  displayAddress {
    ...AllAddressFields
  }
  margin
  powurProjectId
  enterpriseLogoUrl
  userAdjustedAfterSolarContractedRate
  userAdjustedBeforeSolarContractedRate
  userAdjustedUtilityRate
  name
  financeType
  financeProductId
  leadSource
  fundingGroup
}
    `
export const AllProposalStatusFieldsFragmentDoc = `
    fragment AllProposalStatusFields on ProposalStatus {
  createdAt
  id
  message
  proposalId
  status
  updatedAt
  updatedBy
}
    `
export const MinimalProposalFieldsFragmentDoc = `
    fragment MinimalProposalFields on Proposal {
  __typename
  id
  createdAt
  displayAddress {
    ...AllAddressFields
  }
  seller {
    firstName
    lastName
  }
  mentor {
    firstName
    lastName
  }
  slug
  homeowner {
    id
    createdAt
    updatedAt
    powurProjectId
    firstName
    lastName
    email
    phone
  }
  site {
    ...AllSiteFields
  }
  proposalStatuses {
    ...AllProposalStatusFields
  }
  name
}
    `
export const AllQuoteFieldsFragmentDoc = `
    fragment AllQuoteFields on Quote {
  id
  createdAt
  updatedAt
  loanAmount
  buyoutAmount
  paydownAmount
  poisonId
  monthlyPayments
  monthlyInitialPayment
  monthlyAdjustedPayment
  loanProductId
  paydownPercentage
  alternateMonthlyPayment
  finalMonthlyPayment
  finalEscalatedMonthlyPayment
  paymentFactors
  proposalId
  prepaid
  loanAmount
  solarRate
  productionRate
  totalProjectCost
  goodleapJson {
    offerId
    loanAmount {
      value
      type
    }
    disclaimerText
    calculations {
      paydownAmount {
        value
        type
      }
      amount {
        value
        type
      }
      roundedAmount {
        value
        type
      }
      type
      interval
      paymentDescription
    }
  }
}
    `
export const AllUtilityRateFieldsFragmentDoc = `
    fragment AllUtilityRateFields on UtilityRate {
  id
  createdAt
  updatedAt
  activatedAt
  billingPeriod
  chargePeriod
  chargeTypes
  closedDate
  currency
  customerClass
  customerCount
  customerCountSource
  customerLikelihood
  effectiveDate
  effectiveOnRule
  endDate
  hasContractedRates
  hasNetMetering
  hasRateApplicability
  hasTariffApplicability
  hasTieredRates
  hasTimeOfUseRates
  isSolarPvEligible
  isActive
  isNEM3
  lseCode
  lseId
  lseName
  masterTariffId
  maxMonthlyConsumption
  maxMonthlyDemand
  minMonthlyConsumption
  minMonthlyDemand
  priorTariffId
  privacy
  serviceType
  tariffBookName
  tariffCode
  tariffId
  tariffName
  tariffType
  territoryId
  timeZone
  utilityCompanyId
  utilityRateZipCodeLikelihoods {
    createdAt
    updatedAt
    zipcode
    rateTariffId
    likelihood
  }
}
    `
export const GetEnfinStatusDocument = `
    query GetEnfinStatus($providerId: String!) {
  getEnfinApplicationDetails(providerId: $providerId) {
    appStatus
  }
}
    `
export const useGetEnfinStatusQuery = <
  TData = GetEnfinStatusQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetEnfinStatusQueryVariables,
  options?: UseQueryOptions<GetEnfinStatusQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetEnfinStatusQuery, TError, TData>(
    ["GetEnfinStatus", variables],
    fetcher<GetEnfinStatusQuery, GetEnfinStatusQueryVariables>(
      client,
      GetEnfinStatusDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetGoodleapStatusDocument = `
    query GetGoodleapStatus($providerId: String!) {
  getGoodleapLoanDetails(providerId: $providerId) {
    id
    createdAt
    creditExpiresAt
    referenceNumber
    subjectProperty {
      address {
        street
        street2
        city
        state
        zip
      }
      mortgageTotalBalances {
        ...CurrencyFields
      }
      mortgageTotalPayments {
        ...CurrencyFields
      }
    }
    ...AllGlBorrowerFields
    amount {
      ...AmountFields
    }
    maxAmount {
      ...AmountFields
    }
    status
    changes
    offerId
    installationCategoryId
    partnerId
    monthlyPayment {
      ...AmountFields
    }
    estimatedInitialMonthlyPayment {
      ...AmountFields
    }
    enrollments {
      name
    }
  }
  getGoodleapStipulations(providerId: $providerId) {
    id
    name
    description
    reasonCodes
    status
    type
    documentsToClear
    attachments
    createdAt
    updatedAt
    domain
    appliesTo
  }
}
    ${CurrencyFieldsFragmentDoc}
${AllGlBorrowerFieldsFragmentDoc}
${AmountFieldsFragmentDoc}`
export const useGetGoodleapStatusQuery = <
  TData = GetGoodleapStatusQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetGoodleapStatusQueryVariables,
  options?: UseQueryOptions<GetGoodleapStatusQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetGoodleapStatusQuery, TError, TData>(
    ["GetGoodleapStatus", variables],
    fetcher<GetGoodleapStatusQuery, GetGoodleapStatusQueryVariables>(
      client,
      GetGoodleapStatusDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetSungageStatusDocument = `
    query GetSungageStatus($proposalId: String!) {
  getSungageApplicationDetails(proposalId: $proposalId) {
    status
    stipulations
  }
}
    `
export const useGetSungageStatusQuery = <
  TData = GetSungageStatusQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetSungageStatusQueryVariables,
  options?: UseQueryOptions<GetSungageStatusQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetSungageStatusQuery, TError, TData>(
    ["GetSungageStatus", variables],
    fetcher<GetSungageStatusQuery, GetSungageStatusQueryVariables>(
      client,
      GetSungageStatusDocument,
      variables,
      headers,
    ),
    options,
  )
export const SendDocumentsForActiveLoanDocument = `
    mutation SendDocumentsForActiveLoan($activeLoanId: ID!) {
  sendLoanDocuments(activeLoanId: $activeLoanId) {
    ...AllActiveLoanFields
  }
}
    ${AllActiveLoanFieldsFragmentDoc}`
export const useSendDocumentsForActiveLoanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    SendDocumentsForActiveLoanMutation,
    TError,
    SendDocumentsForActiveLoanMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    SendDocumentsForActiveLoanMutation,
    TError,
    SendDocumentsForActiveLoanMutationVariables,
    TContext
  >(
    ["SendDocumentsForActiveLoan"],
    (variables?: SendDocumentsForActiveLoanMutationVariables) =>
      fetcher<
        SendDocumentsForActiveLoanMutation,
        SendDocumentsForActiveLoanMutationVariables
      >(client, SendDocumentsForActiveLoanDocument, variables, headers)(),
    options,
  )
export const GetBrochureDocument = `
    query GetBrochure($proposalId: ID!) {
  getBrochure(proposalId: $proposalId) {
    ...AllBrochureFields
  }
}
    ${AllBrochureFieldsFragmentDoc}
${BrochureMonthFieldsFragmentDoc}
${BrochureUtilityBillFieldsFragmentDoc}`
export const useGetBrochureQuery = <TData = GetBrochureQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetBrochureQueryVariables,
  options?: UseQueryOptions<GetBrochureQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetBrochureQuery, TError, TData>(
    ["GetBrochure", variables],
    fetcher<GetBrochureQuery, GetBrochureQueryVariables>(
      client,
      GetBrochureDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetContractVersionHistoryForProposalDocument = `
    query GetContractVersionHistoryForProposal($proposalId: String!) {
  contractVersionHistoryForProposal(proposalId: $proposalId) {
    versionNumber
    isVoid
    isSigned
    systemSize
    totalCost
    sentAt
    recipientEmail
  }
}
    `
export const useGetContractVersionHistoryForProposalQuery = <
  TData = GetContractVersionHistoryForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetContractVersionHistoryForProposalQueryVariables,
  options?: UseQueryOptions<
    GetContractVersionHistoryForProposalQuery,
    TError,
    TData
  >,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetContractVersionHistoryForProposalQuery, TError, TData>(
    ["GetContractVersionHistoryForProposal", variables],
    fetcher<
      GetContractVersionHistoryForProposalQuery,
      GetContractVersionHistoryForProposalQueryVariables
    >(client, GetContractVersionHistoryForProposalDocument, variables, headers),
    options,
  )
export const GetContractsForProposalDocument = `
    query GetContractsForProposal($proposalId: String!) {
  contractsForProposal(proposalId: $proposalId) {
    ...AllContractFields
  }
}
    ${AllContractFieldsFragmentDoc}`
export const useGetContractsForProposalQuery = <
  TData = GetContractsForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetContractsForProposalQueryVariables,
  options?: UseQueryOptions<GetContractsForProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetContractsForProposalQuery, TError, TData>(
    ["GetContractsForProposal", variables],
    fetcher<GetContractsForProposalQuery, GetContractsForProposalQueryVariables>(
      client,
      GetContractsForProposalDocument,
      variables,
      headers,
    ),
    options,
  )
export const ResendContractDocument = `
    mutation ResendContract($id: String!) {
  resendContract(id: $id) {
    ...AllContractFields
  }
}
    ${AllContractFieldsFragmentDoc}`
export const useResendContractMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ResendContractMutation,
    TError,
    ResendContractMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    ResendContractMutation,
    TError,
    ResendContractMutationVariables,
    TContext
  >(
    ["ResendContract"],
    (variables?: ResendContractMutationVariables) =>
      fetcher<ResendContractMutation, ResendContractMutationVariables>(
        client,
        ResendContractDocument,
        variables,
        headers,
      )(),
    options,
  )
export const SendSupplementalContractDocument = `
    mutation SendSupplementalContract($id: String!) {
  sendSupplementalContract(id: $id) {
    ...AllContractFields
  }
}
    ${AllContractFieldsFragmentDoc}`
export const useSendSupplementalContractMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    SendSupplementalContractMutation,
    TError,
    SendSupplementalContractMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    SendSupplementalContractMutation,
    TError,
    SendSupplementalContractMutationVariables,
    TContext
  >(
    ["SendSupplementalContract"],
    (variables?: SendSupplementalContractMutationVariables) =>
      fetcher<
        SendSupplementalContractMutation,
        SendSupplementalContractMutationVariables
      >(client, SendSupplementalContractDocument, variables, headers)(),
    options,
  )
export const MosaicListDisclosuresDocument = `
    query mosaicListDisclosures($input: MosaicGetDisclosuresBodyDto!) {
  mosaicListDisclosures(input: $input) {
    disclosures {
      assetCode
      version
      assetType
      title
      scope
      contents {
        contentType
        title
        data
      }
    }
    bundleId
  }
}
    `
export const useMosaicListDisclosuresQuery = <
  TData = MosaicListDisclosuresQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: MosaicListDisclosuresQueryVariables,
  options?: UseQueryOptions<MosaicListDisclosuresQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<MosaicListDisclosuresQuery, TError, TData>(
    ["mosaicListDisclosures", variables],
    fetcher<MosaicListDisclosuresQuery, MosaicListDisclosuresQueryVariables>(
      client,
      MosaicListDisclosuresDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetEnfinFrameDocument = `
    query getEnfinFrame($proposalId: String!) {
  getEnfinFrame(proposalId: $proposalId)
}
    `
export const useGetEnfinFrameQuery = <
  TData = GetEnfinFrameQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetEnfinFrameQueryVariables,
  options?: UseQueryOptions<GetEnfinFrameQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetEnfinFrameQuery, TError, TData>(
    ["getEnfinFrame", variables],
    fetcher<GetEnfinFrameQuery, GetEnfinFrameQueryVariables>(
      client,
      GetEnfinFrameDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetSungageFrameDocument = `
    query getSungageFrame($proposalId: String!) {
  getSungageFrame(proposalId: $proposalId)
}
    `
export const useGetSungageFrameQuery = <
  TData = GetSungageFrameQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetSungageFrameQueryVariables,
  options?: UseQueryOptions<GetSungageFrameQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetSungageFrameQuery, TError, TData>(
    ["getSungageFrame", variables],
    fetcher<GetSungageFrameQuery, GetSungageFrameQueryVariables>(
      client,
      GetSungageFrameDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetSunlightFrameDocument = `
    query getSunlightFrame($input: GetSunlightIframeUrlDto!) {
  getSunlightFrame(input: $input)
}
    `
export const useGetSunlightFrameQuery = <
  TData = GetSunlightFrameQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetSunlightFrameQueryVariables,
  options?: UseQueryOptions<GetSunlightFrameQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetSunlightFrameQuery, TError, TData>(
    ["getSunlightFrame", variables],
    fetcher<GetSunlightFrameQuery, GetSunlightFrameQueryVariables>(
      client,
      GetSunlightFrameDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetGoodLeapDisclosuresDocument = `
    query getGoodLeapDisclosures($category: String) {
  getGoodLeapDisclosures(category: $category) {
    data {
      token
      tokenExpiresAt
      sections {
        signatureBox
        boldText
        checkbox
        text
        sort
        boldText
      }
      current
      id
      meta {
        cursor
      }
    }
    links {
      next
      prev
    }
  }
}
    `
export const useGetGoodLeapDisclosuresQuery = <
  TData = GetGoodLeapDisclosuresQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables?: GetGoodLeapDisclosuresQueryVariables,
  options?: UseQueryOptions<GetGoodLeapDisclosuresQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetGoodLeapDisclosuresQuery, TError, TData>(
    variables === undefined
      ? ["getGoodLeapDisclosures"]
      : ["getGoodLeapDisclosures", variables],
    fetcher<GetGoodLeapDisclosuresQuery, GetGoodLeapDisclosuresQueryVariables>(
      client,
      GetGoodLeapDisclosuresDocument,
      variables,
      headers,
    ),
    options,
  )
export const SendCreditApplicationDocument = `
    mutation SendCreditApplication($sendCreditApplicationInput: SendCreditApplicationInput!) {
  sendCreditApplication(input: $sendCreditApplicationInput) {
    ... on GoodLeapCreateLoanResponseDto {
      __typename
      approvedLoanAmount {
        type
        value
      }
      offerId
      referenceNumber
      requestedLoanAmount {
        type
        value
      }
      sentLoanDocuments
      status
      stipulations {
        appliesTo
        attachments {
          extension
          groupId
          id
          label
          name
          status
          type
        }
        createdAt
        deferred
        description
        documentsToClear {
          description
          name
          type
        }
        domain
        id
        name
        reasonCodes
        status
        type
        updatedAt
        updatedBy
      }
      type
    }
    ... on MosaicPostApplicationResponseDto {
      __typename
      application {
        id
        status
      }
    }
  }
}
    `
export const useSendCreditApplicationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    SendCreditApplicationMutation,
    TError,
    SendCreditApplicationMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    SendCreditApplicationMutation,
    TError,
    SendCreditApplicationMutationVariables,
    TContext
  >(
    ["SendCreditApplication"],
    (variables?: SendCreditApplicationMutationVariables) =>
      fetcher<
        SendCreditApplicationMutation,
        SendCreditApplicationMutationVariables
      >(client, SendCreditApplicationDocument, variables, headers)(),
    options,
  )
export const AddNoteDesignRequestDocument = `
    mutation AddNoteDesignRequest($id: ID!, $message: String!) {
  addNoteDesignRequest(id: $id, message: $message) {
    ...AllDesignRequestFields
  }
}
    ${AllDesignRequestFieldsFragmentDoc}
${AllDesignNoteFieldsFragmentDoc}`
export const useAddNoteDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    AddNoteDesignRequestMutation,
    TError,
    AddNoteDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    AddNoteDesignRequestMutation,
    TError,
    AddNoteDesignRequestMutationVariables,
    TContext
  >(
    ["AddNoteDesignRequest"],
    (variables?: AddNoteDesignRequestMutationVariables) =>
      fetcher<
        AddNoteDesignRequestMutation,
        AddNoteDesignRequestMutationVariables
      >(client, AddNoteDesignRequestDocument, variables, headers)(),
    options,
  )
export const CancelDesignRequestDocument = `
    mutation CancelDesignRequest($id: ID!) {
  cancelDesignRequest(id: $id) {
    id
  }
}
    `
export const useCancelDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CancelDesignRequestMutation,
    TError,
    CancelDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CancelDesignRequestMutation,
    TError,
    CancelDesignRequestMutationVariables,
    TContext
  >(
    ["CancelDesignRequest"],
    (variables?: CancelDesignRequestMutationVariables) =>
      fetcher<CancelDesignRequestMutation, CancelDesignRequestMutationVariables>(
        client,
        CancelDesignRequestDocument,
        variables,
        headers,
      )(),
    options,
  )
export const ClaimNextDesignRequestDocument = `
    mutation ClaimNextDesignRequest {
  claimNextDesignRequest {
    design {
      id
    }
  }
}
    `
export const useClaimNextDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ClaimNextDesignRequestMutation,
    TError,
    ClaimNextDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    ClaimNextDesignRequestMutation,
    TError,
    ClaimNextDesignRequestMutationVariables,
    TContext
  >(
    ["ClaimNextDesignRequest"],
    (variables?: ClaimNextDesignRequestMutationVariables) =>
      fetcher<
        ClaimNextDesignRequestMutation,
        ClaimNextDesignRequestMutationVariables
      >(client, ClaimNextDesignRequestDocument, variables, headers)(),
    options,
  )
export const DesignRequestClaimedUntilDocument = `
    mutation DesignRequestClaimedUntil($id: ID!) {
  designRequestClaimedUntil(id: $id)
}
    `
export const useDesignRequestClaimedUntilMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    DesignRequestClaimedUntilMutation,
    TError,
    DesignRequestClaimedUntilMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    DesignRequestClaimedUntilMutation,
    TError,
    DesignRequestClaimedUntilMutationVariables,
    TContext
  >(
    ["DesignRequestClaimedUntil"],
    (variables?: DesignRequestClaimedUntilMutationVariables) =>
      fetcher<
        DesignRequestClaimedUntilMutation,
        DesignRequestClaimedUntilMutationVariables
      >(client, DesignRequestClaimedUntilDocument, variables, headers)(),
    options,
  )
export const CompleteDesignRequestDocument = `
    mutation CompleteDesignRequest($id: ID!) {
  completeDesignRequest(id: $id) {
    id
    design {
      id
    }
  }
}
    `
export const useCompleteDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CompleteDesignRequestMutation,
    TError,
    CompleteDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CompleteDesignRequestMutation,
    TError,
    CompleteDesignRequestMutationVariables,
    TContext
  >(
    ["CompleteDesignRequest"],
    (variables?: CompleteDesignRequestMutationVariables) =>
      fetcher<
        CompleteDesignRequestMutation,
        CompleteDesignRequestMutationVariables
      >(client, CompleteDesignRequestDocument, variables, headers)(),
    options,
  )
export const CompleteAndClaimNextDesignRequestDocument = `
    mutation CompleteAndClaimNextDesignRequest($id: ID!) {
  completeDesignRequestAndClaimNext(id: $id) {
    id
    design {
      id
    }
  }
}
    `
export const useCompleteAndClaimNextDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CompleteAndClaimNextDesignRequestMutation,
    TError,
    CompleteAndClaimNextDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CompleteAndClaimNextDesignRequestMutation,
    TError,
    CompleteAndClaimNextDesignRequestMutationVariables,
    TContext
  >(
    ["CompleteAndClaimNextDesignRequest"],
    (variables?: CompleteAndClaimNextDesignRequestMutationVariables) =>
      fetcher<
        CompleteAndClaimNextDesignRequestMutation,
        CompleteAndClaimNextDesignRequestMutationVariables
      >(client, CompleteAndClaimNextDesignRequestDocument, variables, headers)(),
    options,
  )
export const CreateDesignRequestDocument = `
    mutation CreateDesignRequest($proposalId: ID!, $initialMessage: String, $requestType: String) {
  createDesignRequest(
    proposalId: $proposalId
    initialMessage: $initialMessage
    requestType: $requestType
  ) {
    ...AllDesignRequestFields
  }
}
    ${AllDesignRequestFieldsFragmentDoc}
${AllDesignNoteFieldsFragmentDoc}`
export const useCreateDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CreateDesignRequestMutation,
    TError,
    CreateDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CreateDesignRequestMutation,
    TError,
    CreateDesignRequestMutationVariables,
    TContext
  >(
    ["CreateDesignRequest"],
    (variables?: CreateDesignRequestMutationVariables) =>
      fetcher<CreateDesignRequestMutation, CreateDesignRequestMutationVariables>(
        client,
        CreateDesignRequestDocument,
        variables,
        headers,
      )(),
    options,
  )
export const DuplicateDesignRequestDocument = `
    mutation DuplicateDesignRequest($designRequestId: ID!, $message: String) {
  duplicateDesignRequest(designRequestId: $designRequestId, message: $message) {
    id
    design {
      id
    }
  }
}
    `
export const useDuplicateDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    DuplicateDesignRequestMutation,
    TError,
    DuplicateDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    DuplicateDesignRequestMutation,
    TError,
    DuplicateDesignRequestMutationVariables,
    TContext
  >(
    ["DuplicateDesignRequest"],
    (variables?: DuplicateDesignRequestMutationVariables) =>
      fetcher<
        DuplicateDesignRequestMutation,
        DuplicateDesignRequestMutationVariables
      >(client, DuplicateDesignRequestDocument, variables, headers)(),
    options,
  )
export const EscalateDesignRequestDocument = `
    mutation EscalateDesignRequest($id: ID!, $message: String!) {
  escalateDesignRequest(id: $id, message: $message) {
    id
    design {
      id
    }
  }
}
    `
export const useEscalateDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    EscalateDesignRequestMutation,
    TError,
    EscalateDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    EscalateDesignRequestMutation,
    TError,
    EscalateDesignRequestMutationVariables,
    TContext
  >(
    ["EscalateDesignRequest"],
    (variables?: EscalateDesignRequestMutationVariables) =>
      fetcher<
        EscalateDesignRequestMutation,
        EscalateDesignRequestMutationVariables
      >(client, EscalateDesignRequestDocument, variables, headers)(),
    options,
  )
export const EscalateDesignRequestAndClaimNextDocument = `
    mutation EscalateDesignRequestAndClaimNext($id: ID!, $message: String!) {
  escalateDesignRequestAndClaimNext(id: $id, message: $message) {
    id
    design {
      id
    }
  }
}
    `
export const useEscalateDesignRequestAndClaimNextMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    EscalateDesignRequestAndClaimNextMutation,
    TError,
    EscalateDesignRequestAndClaimNextMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    EscalateDesignRequestAndClaimNextMutation,
    TError,
    EscalateDesignRequestAndClaimNextMutationVariables,
    TContext
  >(
    ["EscalateDesignRequestAndClaimNext"],
    (variables?: EscalateDesignRequestAndClaimNextMutationVariables) =>
      fetcher<
        EscalateDesignRequestAndClaimNextMutation,
        EscalateDesignRequestAndClaimNextMutationVariables
      >(client, EscalateDesignRequestAndClaimNextDocument, variables, headers)(),
    options,
  )
export const GetDesignerDataByRequestIdDocument = `
    query GetDesignerDataByRequestId($id: ID!) {
  designerDataByRequestId(id: $id) {
    id
    createdAt
    updatedAt
    design {
      id
    }
    designNotes {
      id
      createdAt
      createdById
      message
      reason
    }
    designUser {
      id
      userId
    }
    design {
      ...AllDesignFields
      ...AllDesignEquipment
    }
  }
}
    ${AllDesignFieldsFragmentDoc}
${EstimateFieldsFragmentDoc}
${AllDesignEquipmentFragmentDoc}
${EquipmentFieldsFragmentDoc}`
export const useGetDesignerDataByRequestIdQuery = <
  TData = GetDesignerDataByRequestIdQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetDesignerDataByRequestIdQueryVariables,
  options?: UseQueryOptions<GetDesignerDataByRequestIdQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetDesignerDataByRequestIdQuery, TError, TData>(
    ["GetDesignerDataByRequestId", variables],
    fetcher<
      GetDesignerDataByRequestIdQuery,
      GetDesignerDataByRequestIdQueryVariables
    >(client, GetDesignerDataByRequestIdDocument, variables, headers),
    options,
  )
export const PauseDesignRequestDocument = `
    mutation pauseDesignRequest($pauseDesignRequestInput: PauseDesignRequestInput!) {
  pauseDesignRequest(pauseDesignRequestInput: $pauseDesignRequestInput) {
    id
    pausedUntil
    timeAdded
    designNotes {
      reason
      message
    }
  }
}
    `
export const usePauseDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    PauseDesignRequestMutation,
    TError,
    PauseDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    PauseDesignRequestMutation,
    TError,
    PauseDesignRequestMutationVariables,
    TContext
  >(
    ["pauseDesignRequest"],
    (variables?: PauseDesignRequestMutationVariables) =>
      fetcher<PauseDesignRequestMutation, PauseDesignRequestMutationVariables>(
        client,
        PauseDesignRequestDocument,
        variables,
        headers,
      )(),
    options,
  )
export const RejectDesignRequestDocument = `
    mutation RejectDesignRequest($id: ID!, $message: String!) {
  rejectDesignRequest(id: $id, message: $message) {
    id
  }
}
    `
export const useRejectDesignRequestMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    RejectDesignRequestMutation,
    TError,
    RejectDesignRequestMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    RejectDesignRequestMutation,
    TError,
    RejectDesignRequestMutationVariables,
    TContext
  >(
    ["RejectDesignRequest"],
    (variables?: RejectDesignRequestMutationVariables) =>
      fetcher<RejectDesignRequestMutation, RejectDesignRequestMutationVariables>(
        client,
        RejectDesignRequestDocument,
        variables,
        headers,
      )(),
    options,
  )
export const RequestDesignRevisionDocument = `
    mutation RequestDesignRevision($input: DesignRevisionInput!) {
  requestDesignRevision(input: $input) {
    designRequest {
      id
    }
  }
}
    `
export const useRequestDesignRevisionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    RequestDesignRevisionMutation,
    TError,
    RequestDesignRevisionMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    RequestDesignRevisionMutation,
    TError,
    RequestDesignRevisionMutationVariables,
    TContext
  >(
    ["RequestDesignRevision"],
    (variables?: RequestDesignRevisionMutationVariables) =>
      fetcher<
        RequestDesignRevisionMutation,
        RequestDesignRevisionMutationVariables
      >(client, RequestDesignRevisionDocument, variables, headers)(),
    options,
  )
export const ActivateDesignDocument = `
    mutation ActivateDesign($id: ID!) {
  activateDesign(id: $id) {
    ...AllDesignFields
    ...AllDesignEquipment
  }
}
    ${AllDesignFieldsFragmentDoc}
${EstimateFieldsFragmentDoc}
${AllDesignEquipmentFragmentDoc}
${EquipmentFieldsFragmentDoc}`
export const useActivateDesignMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ActivateDesignMutation,
    TError,
    ActivateDesignMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    ActivateDesignMutation,
    TError,
    ActivateDesignMutationVariables,
    TContext
  >(
    ["ActivateDesign"],
    (variables?: ActivateDesignMutationVariables) =>
      fetcher<ActivateDesignMutation, ActivateDesignMutationVariables>(
        client,
        ActivateDesignDocument,
        variables,
        headers,
      )(),
    options,
  )
export const DesignDocument = `
    query design($id: ID!) {
  design(id: $id) {
    ...AllDesignFields
    ...AllDesignEquipment
  }
}
    ${AllDesignFieldsFragmentDoc}
${EstimateFieldsFragmentDoc}
${AllDesignEquipmentFragmentDoc}
${EquipmentFieldsFragmentDoc}`
export const useDesignQuery = <TData = DesignQuery, TError = unknown>(
  client: GraphQLClient,
  variables: DesignQueryVariables,
  options?: UseQueryOptions<DesignQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<DesignQuery, TError, TData>(
    ["design", variables],
    fetcher<DesignQuery, DesignQueryVariables>(
      client,
      DesignDocument,
      variables,
      headers,
    ),
    options,
  )
export const DesignGenabilityStorageIdDocument = `
    query designGenabilityStorageId($id: ID!) {
  design(id: $id) {
    profiles {
      id
      createdAt
      updatedAt
      type
      profileId
      providerProfileId
    }
  }
}
    `
export const useDesignGenabilityStorageIdQuery = <
  TData = DesignGenabilityStorageIdQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: DesignGenabilityStorageIdQueryVariables,
  options?: UseQueryOptions<DesignGenabilityStorageIdQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<DesignGenabilityStorageIdQuery, TError, TData>(
    ["designGenabilityStorageId", variables],
    fetcher<
      DesignGenabilityStorageIdQuery,
      DesignGenabilityStorageIdQueryVariables
    >(client, DesignGenabilityStorageIdDocument, variables, headers),
    options,
  )
export const GetDesignsDocument = `
    query GetDesigns($designsInput: DesignsInput!) {
  designs(designsInput: $designsInput) {
    ...AllDesignFields
    ...AllDesignEquipment
  }
}
    ${AllDesignFieldsFragmentDoc}
${EstimateFieldsFragmentDoc}
${AllDesignEquipmentFragmentDoc}
${EquipmentFieldsFragmentDoc}`
export const useGetDesignsQuery = <TData = GetDesignsQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetDesignsQueryVariables,
  options?: UseQueryOptions<GetDesignsQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetDesignsQuery, TError, TData>(
    ["GetDesigns", variables],
    fetcher<GetDesignsQuery, GetDesignsQueryVariables>(
      client,
      GetDesignsDocument,
      variables,
      headers,
    ),
    options,
  )
export const ResetDesignDocument = `
    mutation resetDesign($id: ID!) {
  resetDesign(id: $id) {
    ...AllDesignFields
    ...AllDesignEquipment
  }
}
    ${AllDesignFieldsFragmentDoc}
${EstimateFieldsFragmentDoc}
${AllDesignEquipmentFragmentDoc}
${EquipmentFieldsFragmentDoc}`
export const useResetDesignMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ResetDesignMutation,
    TError,
    ResetDesignMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    ResetDesignMutation,
    TError,
    ResetDesignMutationVariables,
    TContext
  >(
    ["resetDesign"],
    (variables?: ResetDesignMutationVariables) =>
      fetcher<ResetDesignMutation, ResetDesignMutationVariables>(
        client,
        ResetDesignDocument,
        variables,
        headers,
      )(),
    options,
  )
export const SavingsDocument = `
    query savings($designId: ID!) {
  savingsForDesignId(designId: $designId) {
    __typename
    ... on PoisonedSavings {
      id
      createdAt
      updatedAt
      data
      reason
      savings {
        ...SavingsFields
      }
    }
    ... on Savings {
      ...SavingsFields
    }
  }
}
    ${SavingsFieldsFragmentDoc}`
export const useSavingsQuery = <TData = SavingsQuery, TError = unknown>(
  client: GraphQLClient,
  variables: SavingsQueryVariables,
  options?: UseQueryOptions<SavingsQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<SavingsQuery, TError, TData>(
    ["savings", variables],
    fetcher<SavingsQuery, SavingsQueryVariables>(
      client,
      SavingsDocument,
      variables,
      headers,
    ),
    options,
  )
export const UpdateDesignDocument = `
    mutation UpdateDesign($input: UpdateDesignInput!) {
  updateDesign(input: $input) {
    ...AllDesignFields
    ...AllDesignEquipment
  }
}
    ${AllDesignFieldsFragmentDoc}
${EstimateFieldsFragmentDoc}
${AllDesignEquipmentFragmentDoc}
${EquipmentFieldsFragmentDoc}`
export const useUpdateDesignMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateDesignMutation,
    TError,
    UpdateDesignMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateDesignMutation,
    TError,
    UpdateDesignMutationVariables,
    TContext
  >(
    ["UpdateDesign"],
    (variables?: UpdateDesignMutationVariables) =>
      fetcher<UpdateDesignMutation, UpdateDesignMutationVariables>(
        client,
        UpdateDesignDocument,
        variables,
        headers,
      )(),
    options,
  )
export const UpdateInverterDocument = `
    mutation UpdateInverter($input: UpdateInverterInput!) {
  updateInverter(input: $input) {
    id
  }
}
    `
export const useUpdateInverterMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateInverterMutation,
    TError,
    UpdateInverterMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateInverterMutation,
    TError,
    UpdateInverterMutationVariables,
    TContext
  >(
    ["UpdateInverter"],
    (variables?: UpdateInverterMutationVariables) =>
      fetcher<UpdateInverterMutation, UpdateInverterMutationVariables>(
        client,
        UpdateInverterDocument,
        variables,
        headers,
      )(),
    options,
  )
export const UpdateModuleDocument = `
    mutation UpdateModule($designId: String!, $equipmentId: Int!) {
  updateModule(designId: $designId, equipmentId: $equipmentId) {
    id
  }
}
    `
export const useUpdateModuleMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateModuleMutation,
    TError,
    UpdateModuleMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateModuleMutation,
    TError,
    UpdateModuleMutationVariables,
    TContext
  >(
    ["UpdateModule"],
    (variables?: UpdateModuleMutationVariables) =>
      fetcher<UpdateModuleMutation, UpdateModuleMutationVariables>(
        client,
        UpdateModuleDocument,
        variables,
        headers,
      )(),
    options,
  )
export const UpdateNonPrimaryEquipmentSelectionDocument = `
    mutation UpdateNonPrimaryEquipmentSelection($designId: String!, $equipmentIds: [Int!]!) {
  updateNonPrimaryEquipmentSelection(
    designId: $designId
    equipmentIds: $equipmentIds
  ) {
    id
  }
}
    `
export const useUpdateNonPrimaryEquipmentSelectionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateNonPrimaryEquipmentSelectionMutation,
    TError,
    UpdateNonPrimaryEquipmentSelectionMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateNonPrimaryEquipmentSelectionMutation,
    TError,
    UpdateNonPrimaryEquipmentSelectionMutationVariables,
    TContext
  >(
    ["UpdateNonPrimaryEquipmentSelection"],
    (variables?: UpdateNonPrimaryEquipmentSelectionMutationVariables) =>
      fetcher<
        UpdateNonPrimaryEquipmentSelectionMutation,
        UpdateNonPrimaryEquipmentSelectionMutationVariables
      >(
        client,
        UpdateNonPrimaryEquipmentSelectionDocument,
        variables,
        headers,
      )(),
    options,
  )
export const UpdateStorageDocument = `
    mutation UpdateStorage($input: UpdateStorageInput!) {
  updateStorage(input: $input) {
    id
  }
}
    `
export const useUpdateStorageMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateStorageMutation,
    TError,
    UpdateStorageMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateStorageMutation,
    TError,
    UpdateStorageMutationVariables,
    TContext
  >(
    ["UpdateStorage"],
    (variables?: UpdateStorageMutationVariables) =>
      fetcher<UpdateStorageMutation, UpdateStorageMutationVariables>(
        client,
        UpdateStorageDocument,
        variables,
        headers,
      )(),
    options,
  )
export const GetEquipmentForProposalDocument = `
    query GetEquipmentForProposal($proposalId: String!, $equipmentType: NewEquipmentType, $inverterManufacturerId: Float) {
  equipmentForProposal(
    proposalId: $proposalId
    equipmentType: $equipmentType
    inverterManufacturerId: $inverterManufacturerId
  ) {
    ...AllNewEquipmentFields
  }
}
    ${AllNewEquipmentFieldsFragmentDoc}`
export const useGetEquipmentForProposalQuery = <
  TData = GetEquipmentForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetEquipmentForProposalQueryVariables,
  options?: UseQueryOptions<GetEquipmentForProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetEquipmentForProposalQuery, TError, TData>(
    ["GetEquipmentForProposal", variables],
    fetcher<GetEquipmentForProposalQuery, GetEquipmentForProposalQueryVariables>(
      client,
      GetEquipmentForProposalDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetInvertersForProposalDocument = `
    query GetInvertersForProposal($proposalId: String!) {
  invertersForProposal(proposalId: $proposalId) {
    inverters {
      ...AllNewEquipmentFields
    }
    brands
  }
}
    ${AllNewEquipmentFieldsFragmentDoc}`
export const useGetInvertersForProposalQuery = <
  TData = GetInvertersForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetInvertersForProposalQueryVariables,
  options?: UseQueryOptions<GetInvertersForProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetInvertersForProposalQuery, TError, TData>(
    ["GetInvertersForProposal", variables],
    fetcher<GetInvertersForProposalQuery, GetInvertersForProposalQueryVariables>(
      client,
      GetInvertersForProposalDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetBaseEquipmentForProposalDocument = `
    query GetBaseEquipmentForProposal($proposalId: String!) {
  baseEquipmentForProposal(proposalId: $proposalId) {
    moduleId
    inverters
  }
}
    `
export const useGetBaseEquipmentForProposalQuery = <
  TData = GetBaseEquipmentForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetBaseEquipmentForProposalQueryVariables,
  options?: UseQueryOptions<GetBaseEquipmentForProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetBaseEquipmentForProposalQuery, TError, TData>(
    ["GetBaseEquipmentForProposal", variables],
    fetcher<
      GetBaseEquipmentForProposalQuery,
      GetBaseEquipmentForProposalQueryVariables
    >(client, GetBaseEquipmentForProposalDocument, variables, headers),
    options,
  )
export const SearchEquipmentWithAvailabilityDocument = `
    query SearchEquipmentWithAvailability($searchTerm: String!, $proposalId: String!) {
  searchEquipmentWithAvailability(
    searchTerm: $searchTerm
    proposalId: $proposalId
  ) {
    id
    name
    catalogNumber
    manufacturerName
    availabilityStatus
    unavailabilityReason
  }
}
    `
export const useSearchEquipmentWithAvailabilityQuery = <
  TData = SearchEquipmentWithAvailabilityQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: SearchEquipmentWithAvailabilityQueryVariables,
  options?: UseQueryOptions<SearchEquipmentWithAvailabilityQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<SearchEquipmentWithAvailabilityQuery, TError, TData>(
    ["SearchEquipmentWithAvailability", variables],
    fetcher<
      SearchEquipmentWithAvailabilityQuery,
      SearchEquipmentWithAvailabilityQueryVariables
    >(client, SearchEquipmentWithAvailabilityDocument, variables, headers),
    options,
  )
export const EstimateDocument = `
    query Estimate($findEstimateInput: FindEstimateInput!) {
  estimate(findEstimateInput: $findEstimateInput) {
    __typename
    ... on Estimate {
      ...EstimateFields
    }
    ... on PoisonedEstimate {
      id
      createdAt
      updatedAt
      data
      reason
      estimate {
        ...EstimateFields
      }
    }
  }
}
    ${EstimateFieldsFragmentDoc}`
export const useEstimateQuery = <TData = EstimateQuery, TError = unknown>(
  client: GraphQLClient,
  variables: EstimateQueryVariables,
  options?: UseQueryOptions<EstimateQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<EstimateQuery, TError, TData>(
    ["Estimate", variables],
    fetcher<EstimateQuery, EstimateQueryVariables>(
      client,
      EstimateDocument,
      variables,
      headers,
    ),
    options,
  )
export const CreateEstimateOverridesDocument = `
    mutation createEstimateOverrides($input: CreateEstimateOverridesInput!) {
  createEstimateOverrides(input: $input)
}
    `
export const useCreateEstimateOverridesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CreateEstimateOverridesMutation,
    TError,
    CreateEstimateOverridesMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CreateEstimateOverridesMutation,
    TError,
    CreateEstimateOverridesMutationVariables,
    TContext
  >(
    ["createEstimateOverrides"],
    (variables?: CreateEstimateOverridesMutationVariables) =>
      fetcher<
        CreateEstimateOverridesMutation,
        CreateEstimateOverridesMutationVariables
      >(client, CreateEstimateOverridesDocument, variables, headers)(),
    options,
  )
export const EstimatesForDesignDocument = `
    query EstimatesForDesign($designId: ID!) {
  estimatesForDesign(designId: $designId) {
    __typename
    ... on Estimate {
      ...EstimateFields
    }
    ... on PoisonedEstimate {
      id
      createdAt
      updatedAt
      data
      reason
      estimate {
        ...EstimateFields
      }
    }
  }
}
    ${EstimateFieldsFragmentDoc}`
export const useEstimatesForDesignQuery = <
  TData = EstimatesForDesignQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: EstimatesForDesignQueryVariables,
  options?: UseQueryOptions<EstimatesForDesignQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<EstimatesForDesignQuery, TError, TData>(
    ["EstimatesForDesign", variables],
    fetcher<EstimatesForDesignQuery, EstimatesForDesignQueryVariables>(
      client,
      EstimatesForDesignDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetIncentivesByProposalIdDocument = `
    query getIncentivesByProposalId($id: String!) {
  getIncentivesByProposalId(proposalId: $id) {
    ...AllProposalIncentiveFields
  }
}
    ${AllProposalIncentiveFieldsFragmentDoc}
${AllIncentiveFieldsFragmentDoc}
${AllApplicabilityFieldsFragmentDoc}
${AllPropertyFieldsFragmentDoc}`
export const useGetIncentivesByProposalIdQuery = <
  TData = GetIncentivesByProposalIdQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetIncentivesByProposalIdQueryVariables,
  options?: UseQueryOptions<GetIncentivesByProposalIdQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetIncentivesByProposalIdQuery, TError, TData>(
    ["getIncentivesByProposalId", variables],
    fetcher<
      GetIncentivesByProposalIdQuery,
      GetIncentivesByProposalIdQueryVariables
    >(client, GetIncentivesByProposalIdDocument, variables, headers),
    options,
  )
export const GetSelectIncentivesModalDocument = `
    query GetSelectIncentivesModal($proposalId: String!) {
  getSelectIncentivesModal(proposalId: $proposalId) {
    listed {
      ...AllProposalIncentiveFields
    }
    unlisted {
      ...AllProposalIncentiveFields
    }
  }
}
    ${AllProposalIncentiveFieldsFragmentDoc}
${AllIncentiveFieldsFragmentDoc}
${AllApplicabilityFieldsFragmentDoc}
${AllPropertyFieldsFragmentDoc}`
export const useGetSelectIncentivesModalQuery = <
  TData = GetSelectIncentivesModalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetSelectIncentivesModalQueryVariables,
  options?: UseQueryOptions<GetSelectIncentivesModalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetSelectIncentivesModalQuery, TError, TData>(
    ["GetSelectIncentivesModal", variables],
    fetcher<
      GetSelectIncentivesModalQuery,
      GetSelectIncentivesModalQueryVariables
    >(client, GetSelectIncentivesModalDocument, variables, headers),
    options,
  )
export const CancelGoodleapLoanDocument = `
    mutation CancelGoodleapLoan($loanProviderId: String!) {
  cancelGoodleapLoan(loanProviderId: $loanProviderId)
}
    `
export const useCancelGoodleapLoanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CancelGoodleapLoanMutation,
    TError,
    CancelGoodleapLoanMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CancelGoodleapLoanMutation,
    TError,
    CancelGoodleapLoanMutationVariables,
    TContext
  >(
    ["CancelGoodleapLoan"],
    (variables?: CancelGoodleapLoanMutationVariables) =>
      fetcher<CancelGoodleapLoanMutation, CancelGoodleapLoanMutationVariables>(
        client,
        CancelGoodleapLoanDocument,
        variables,
        headers,
      )(),
    options,
  )
export const CreateLoanProductDocument = `
    mutation createLoanProduct($input: CreateLoanProductInput!) {
  createLoanProduct(CreateLoanProductInput: $input) {
    id
  }
}
    `
export const useCreateLoanProductMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    CreateLoanProductMutation,
    TError,
    CreateLoanProductMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    CreateLoanProductMutation,
    TError,
    CreateLoanProductMutationVariables,
    TContext
  >(
    ["createLoanProduct"],
    (variables?: CreateLoanProductMutationVariables) =>
      fetcher<CreateLoanProductMutation, CreateLoanProductMutationVariables>(
        client,
        CreateLoanProductDocument,
        variables,
        headers,
      )(),
    options,
  )
export const FindLoanProductsForProposalDocument = `
    query FindLoanProductsForProposal($proposalId: ID!, $provider: String!) {
  findLoanProductsForProposal(proposalId: $proposalId, provider: $provider) {
    __typename
    providers
    products {
      ...AllLoanProductFields
    }
  }
}
    ${AllLoanProductFieldsFragmentDoc}`
export const useFindLoanProductsForProposalQuery = <
  TData = FindLoanProductsForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: FindLoanProductsForProposalQueryVariables,
  options?: UseQueryOptions<FindLoanProductsForProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<FindLoanProductsForProposalQuery, TError, TData>(
    ["FindLoanProductsForProposal", variables],
    fetcher<
      FindLoanProductsForProposalQuery,
      FindLoanProductsForProposalQueryVariables
    >(client, FindLoanProductsForProposalDocument, variables, headers),
    options,
  )
export const FindPossibleTpoLoanProductTypesForProposalDocument = `
    query FindPossibleTpoLoanProductTypesForProposal($proposalId: ID!) {
  findPossibleTpoLoanProductTypesForProposal(proposalId: $proposalId)
}
    `
export const useFindPossibleTpoLoanProductTypesForProposalQuery = <
  TData = FindPossibleTpoLoanProductTypesForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: FindPossibleTpoLoanProductTypesForProposalQueryVariables,
  options?: UseQueryOptions<
    FindPossibleTpoLoanProductTypesForProposalQuery,
    TError,
    TData
  >,
  headers?: RequestInit["headers"],
) =>
  useQuery<FindPossibleTpoLoanProductTypesForProposalQuery, TError, TData>(
    ["FindPossibleTpoLoanProductTypesForProposal", variables],
    fetcher<
      FindPossibleTpoLoanProductTypesForProposalQuery,
      FindPossibleTpoLoanProductTypesForProposalQueryVariables
    >(
      client,
      FindPossibleTpoLoanProductTypesForProposalDocument,
      variables,
      headers,
    ),
    options,
  )
export const SunlightInfoDocument = `
    query SunlightInfo($id: String!) {
  getSunlightProjectStatus(id: $id) {
    returnCode
    projects {
      id
      externalId
      hashId
      stage
      ownerEmail
      term
      isACH
      isCreditAuthorized
      projectStatus
      installerName
      requestedLoanAmount
      statusText
      stips {
        id
        name
        status
        description
        installerOnlyEmail
        isStipSuppressed
      }
    }
  }
}
    `
export const useSunlightInfoQuery = <
  TData = SunlightInfoQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: SunlightInfoQueryVariables,
  options?: UseQueryOptions<SunlightInfoQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<SunlightInfoQuery, TError, TData>(
    ["SunlightInfo", variables],
    fetcher<SunlightInfoQuery, SunlightInfoQueryVariables>(
      client,
      SunlightInfoDocument,
      variables,
      headers,
    ),
    options,
  )
export const SearchLoanProductsDocument = `
    query SearchLoanProducts($searchTerms: SearchLoanProductInput!) {
  searchLoanProducts(searchTerms: $searchTerms) {
    ...AllLoanProductFields
  }
}
    ${AllLoanProductFieldsFragmentDoc}`
export const useSearchLoanProductsQuery = <
  TData = SearchLoanProductsQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: SearchLoanProductsQueryVariables,
  options?: UseQueryOptions<SearchLoanProductsQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<SearchLoanProductsQuery, TError, TData>(
    ["SearchLoanProducts", variables],
    fetcher<SearchLoanProductsQuery, SearchLoanProductsQueryVariables>(
      client,
      SearchLoanProductsDocument,
      variables,
      headers,
    ),
    options,
  )
export const SubmitChangeOrderDocument = `
    mutation SubmitChangeOrder($id: String!) {
  SubmitChangeOrder(id: $id) {
    id
  }
}
    `
export const useSubmitChangeOrderMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    SubmitChangeOrderMutation,
    TError,
    SubmitChangeOrderMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    SubmitChangeOrderMutation,
    TError,
    SubmitChangeOrderMutationVariables,
    TContext
  >(
    ["SubmitChangeOrder"],
    (variables?: SubmitChangeOrderMutationVariables) =>
      fetcher<SubmitChangeOrderMutation, SubmitChangeOrderMutationVariables>(
        client,
        SubmitChangeOrderDocument,
        variables,
        headers,
      )(),
    options,
  )
export const GetWarrantyPricingDocument = `
    query GetWarrantyPricing($proposalId: String!) {
  getWarrantyPricing(proposalId: $proposalId) {
    id
    cost
    name
    eligible
    family
    localizedName
  }
}
    `
export const useGetWarrantyPricingQuery = <
  TData = GetWarrantyPricingQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetWarrantyPricingQueryVariables,
  options?: UseQueryOptions<GetWarrantyPricingQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetWarrantyPricingQuery, TError, TData>(
    ["GetWarrantyPricing", variables],
    fetcher<GetWarrantyPricingQuery, GetWarrantyPricingQueryVariables>(
      client,
      GetWarrantyPricingDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetProposalDocument = `
    query GetProposal($findProposalInput: FindProposalInput!) {
  proposal(findProposalInput: $findProposalInput) {
    ...AllProposalFields
  }
}
    ${AllProposalFieldsFragmentDoc}
${AllAddressFieldsFragmentDoc}
${ProposalCostFieldsFragmentDoc}
${AllProposalLineItemFieldsFragmentDoc}
${AllUserFieldsFragmentDoc}
${AllProposalAdderFieldsFragmentDoc}
${AllAdderFieldsFragmentDoc}
${AllSiteFieldsFragmentDoc}
${AllImageryFieldsFragmentDoc}
${AllLoanProductFieldsFragmentDoc}
${AllProposalIncentiveFieldsFragmentDoc}
${AllIncentiveFieldsFragmentDoc}
${AllApplicabilityFieldsFragmentDoc}
${AllPropertyFieldsFragmentDoc}
${AllActiveLoanFieldsFragmentDoc}`
export const useGetProposalQuery = <TData = GetProposalQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetProposalQueryVariables,
  options?: UseQueryOptions<GetProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetProposalQuery, TError, TData>(
    ["GetProposal", variables],
    fetcher<GetProposalQuery, GetProposalQueryVariables>(
      client,
      GetProposalDocument,
      variables,
      headers,
    ),
    options,
  )
export const RefreshProposalDocument = `
    mutation RefreshProposal($id: String!) {
  refreshProposal(id: $id)
}
    `
export const useRefreshProposalMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    RefreshProposalMutation,
    TError,
    RefreshProposalMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    RefreshProposalMutation,
    TError,
    RefreshProposalMutationVariables,
    TContext
  >(
    ["RefreshProposal"],
    (variables?: RefreshProposalMutationVariables) =>
      fetcher<RefreshProposalMutation, RefreshProposalMutationVariables>(
        client,
        RefreshProposalDocument,
        variables,
        headers,
      )(),
    options,
  )
export const UpdateProposalDocument = `
    mutation UpdateProposal($updateProposalInput: UpdateProposalInput!) {
  updateProposal(updateProposalInput: $updateProposalInput) {
    __typename
    ...AllProposalFields
  }
}
    ${AllProposalFieldsFragmentDoc}
${AllAddressFieldsFragmentDoc}
${ProposalCostFieldsFragmentDoc}
${AllProposalLineItemFieldsFragmentDoc}
${AllUserFieldsFragmentDoc}
${AllProposalAdderFieldsFragmentDoc}
${AllAdderFieldsFragmentDoc}
${AllSiteFieldsFragmentDoc}
${AllImageryFieldsFragmentDoc}
${AllLoanProductFieldsFragmentDoc}
${AllProposalIncentiveFieldsFragmentDoc}
${AllIncentiveFieldsFragmentDoc}
${AllApplicabilityFieldsFragmentDoc}
${AllPropertyFieldsFragmentDoc}
${AllActiveLoanFieldsFragmentDoc}`
export const useUpdateProposalMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateProposalMutation,
    TError,
    UpdateProposalMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateProposalMutation,
    TError,
    UpdateProposalMutationVariables,
    TContext
  >(
    ["UpdateProposal"],
    (variables?: UpdateProposalMutationVariables) =>
      fetcher<UpdateProposalMutation, UpdateProposalMutationVariables>(
        client,
        UpdateProposalDocument,
        variables,
        headers,
      )(),
    options,
  )
export const UpdateTotalCostByPricePerWattDocument = `
    mutation UpdateTotalCostByPricePerWatt($proposalId: String!, $pricePerWatt: Float!) {
  updateTotalCostByPricePerWatt(
    proposalId: $proposalId
    pricePerWatt: $pricePerWatt
  ) {
    id
    margin
    totalCost
  }
}
    `
export const useUpdateTotalCostByPricePerWattMutation = <
  TError = unknown,
  TContext = unknown,
>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateTotalCostByPricePerWattMutation,
    TError,
    UpdateTotalCostByPricePerWattMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    UpdateTotalCostByPricePerWattMutation,
    TError,
    UpdateTotalCostByPricePerWattMutationVariables,
    TContext
  >(
    ["UpdateTotalCostByPricePerWatt"],
    (variables?: UpdateTotalCostByPricePerWattMutationVariables) =>
      fetcher<
        UpdateTotalCostByPricePerWattMutation,
        UpdateTotalCostByPricePerWattMutationVariables
      >(client, UpdateTotalCostByPricePerWattDocument, variables, headers)(),
    options,
  )
export const FindProposalStatusesDocument = `
    query FindProposalStatuses($proposalId: String!) {
  getProposalStatusEvents(proposalId: $proposalId) {
    id
    createdAt
    updatedAt
    message
    status
    updatedBy
    proposalId
  }
}
    `
export const useFindProposalStatusesQuery = <
  TData = FindProposalStatusesQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: FindProposalStatusesQueryVariables,
  options?: UseQueryOptions<FindProposalStatusesQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<FindProposalStatusesQuery, TError, TData>(
    ["FindProposalStatuses", variables],
    fetcher<FindProposalStatusesQuery, FindProposalStatusesQueryVariables>(
      client,
      FindProposalStatusesDocument,
      variables,
      headers,
    ),
    options,
  )
export const PublishProposalDocument = `
    mutation PublishProposal($publishProposalInput: PublishProposalInput!) {
  updateStatusProposalPublished(publishProposalInput: $publishProposalInput) {
    id
    createdAt
    updatedAt
    message
    status
    updatedBy
    proposalId
  }
}
    `
export const usePublishProposalMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    PublishProposalMutation,
    TError,
    PublishProposalMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    PublishProposalMutation,
    TError,
    PublishProposalMutationVariables,
    TContext
  >(
    ["PublishProposal"],
    (variables?: PublishProposalMutationVariables) =>
      fetcher<PublishProposalMutation, PublishProposalMutationVariables>(
        client,
        PublishProposalDocument,
        variables,
        headers,
      )(),
    options,
  )
export const RequestContractDocument = `
    mutation RequestContract($data: CreateProposalStatusInput!) {
  updateStatusProposalContractRequested(data: $data) {
    id
    createdAt
    updatedAt
    message
    status
    updatedBy
    proposalId
  }
}
    `
export const useRequestContractMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    RequestContractMutation,
    TError,
    RequestContractMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    RequestContractMutation,
    TError,
    RequestContractMutationVariables,
    TContext
  >(
    ["RequestContract"],
    (variables?: RequestContractMutationVariables) =>
      fetcher<RequestContractMutation, RequestContractMutationVariables>(
        client,
        RequestContractDocument,
        variables,
        headers,
      )(),
    options,
  )
export const ConfirmSummaryDocument = `
    mutation ConfirmSummary($createProposalStatusInput: CreateProposalStatusInput!) {
  updateStatusSummaryConfirmed(data: $createProposalStatusInput) {
    id
    createdAt
    updatedAt
    message
    status
    updatedBy
    proposalId
  }
}
    `
export const useConfirmSummaryMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    ConfirmSummaryMutation,
    TError,
    ConfirmSummaryMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<
    ConfirmSummaryMutation,
    TError,
    ConfirmSummaryMutationVariables,
    TContext
  >(
    ["ConfirmSummary"],
    (variables?: ConfirmSummaryMutationVariables) =>
      fetcher<ConfirmSummaryMutation, ConfirmSummaryMutationVariables>(
        client,
        ConfirmSummaryDocument,
        variables,
        headers,
      )(),
    options,
  )
export const GetQuotesForProposalDocument = `
    query GetQuotesForProposal($id: ID!) {
  getQuotesForProposal(id: $id) {
    __typename
    ... on Quote {
      ...AllQuoteFields
    }
    ... on PoisonedQuote {
      id
      createdAt
      updatedAt
      data
      reason
      quote {
        ...AllQuoteFields
      }
    }
  }
}
    ${AllQuoteFieldsFragmentDoc}`
export const useGetQuotesForProposalQuery = <
  TData = GetQuotesForProposalQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetQuotesForProposalQueryVariables,
  options?: UseQueryOptions<GetQuotesForProposalQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetQuotesForProposalQuery, TError, TData>(
    ["GetQuotesForProposal", variables],
    fetcher<GetQuotesForProposalQuery, GetQuotesForProposalQueryVariables>(
      client,
      GetQuotesForProposalDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetSiteDocument = `
    query GetSite($id: ID!) {
  site(id: $id) {
    __typename
    ...AllSiteFields
  }
}
    ${AllSiteFieldsFragmentDoc}
${AllImageryFieldsFragmentDoc}`
export const useGetSiteQuery = <TData = GetSiteQuery, TError = unknown>(
  client: GraphQLClient,
  variables: GetSiteQueryVariables,
  options?: UseQueryOptions<GetSiteQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetSiteQuery, TError, TData>(
    ["GetSite", variables],
    fetcher<GetSiteQuery, GetSiteQueryVariables>(
      client,
      GetSiteDocument,
      variables,
      headers,
    ),
    options,
  )
export const GetSitesDocument = `
    query GetSites {
  sites {
    ...AllSiteFields
  }
}
    ${AllSiteFieldsFragmentDoc}
${AllImageryFieldsFragmentDoc}`
export const useGetSitesQuery = <TData = GetSitesQuery, TError = unknown>(
  client: GraphQLClient,
  variables?: GetSitesQueryVariables,
  options?: UseQueryOptions<GetSitesQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetSitesQuery, TError, TData>(
    variables === undefined ? ["GetSites"] : ["GetSites", variables],
    fetcher<GetSitesQuery, GetSitesQueryVariables>(
      client,
      GetSitesDocument,
      variables,
      headers,
    ),
    options,
  )
export const UpdateSiteDocument = `
    mutation UpdateSite($updateSiteInput: UpdateSiteInput!) {
  updateSite(updateSiteInput: $updateSiteInput) {
    __typename
    ...AllSiteFields
  }
}
    ${AllSiteFieldsFragmentDoc}
${AllImageryFieldsFragmentDoc}`
export const useUpdateSiteMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateSiteMutation,
    TError,
    UpdateSiteMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<UpdateSiteMutation, TError, UpdateSiteMutationVariables, TContext>(
    ["UpdateSite"],
    (variables?: UpdateSiteMutationVariables) =>
      fetcher<UpdateSiteMutation, UpdateSiteMutationVariables>(
        client,
        UpdateSiteDocument,
        variables,
        headers,
      )(),
    options,
  )
export const SearchUsersDocument = `
    query SearchUsers($searchTerms: SearchUserInput!) {
  searchUsers(searchTerms: $searchTerms) {
    ...AllUserFields
  }
}
    ${AllUserFieldsFragmentDoc}`
export const useSearchUsersQuery = <TData = SearchUsersQuery, TError = unknown>(
  client: GraphQLClient,
  variables: SearchUsersQueryVariables,
  options?: UseQueryOptions<SearchUsersQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<SearchUsersQuery, TError, TData>(
    ["SearchUsers", variables],
    fetcher<SearchUsersQuery, SearchUsersQueryVariables>(
      client,
      SearchUsersDocument,
      variables,
      headers,
    ),
    options,
  )
export const UpdateUserDocument = `
    mutation UpdateUser($updateUserInput: UpdateUserInput!, $id: ID!) {
  updateUser(updateUserInput: $updateUserInput, id: $id) {
    __typename
    ...AllUserFields
  }
}
    ${AllUserFieldsFragmentDoc}`
export const useUpdateUserMutation = <TError = unknown, TContext = unknown>(
  client: GraphQLClient,
  options?: UseMutationOptions<
    UpdateUserMutation,
    TError,
    UpdateUserMutationVariables,
    TContext
  >,
  headers?: RequestInit["headers"],
) =>
  useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
    ["UpdateUser"],
    (variables?: UpdateUserMutationVariables) =>
      fetcher<UpdateUserMutation, UpdateUserMutationVariables>(
        client,
        UpdateUserDocument,
        variables,
        headers,
      )(),
    options,
  )
export const GetUtilityRatesForCompanyDocument = `
    query GetUtilityRatesForCompany($lseId: String!) {
  utilityTariffsForCompany(lseId: $lseId) {
    ...AllUtilityRateFields
  }
}
    ${AllUtilityRateFieldsFragmentDoc}`
export const useGetUtilityRatesForCompanyQuery = <
  TData = GetUtilityRatesForCompanyQuery,
  TError = unknown,
>(
  client: GraphQLClient,
  variables: GetUtilityRatesForCompanyQueryVariables,
  options?: UseQueryOptions<GetUtilityRatesForCompanyQuery, TError, TData>,
  headers?: RequestInit["headers"],
) =>
  useQuery<GetUtilityRatesForCompanyQuery, TError, TData>(
    ["GetUtilityRatesForCompany", variables],
    fetcher<
      GetUtilityRatesForCompanyQuery,
      GetUtilityRatesForCompanyQueryVariables
    >(client, GetUtilityRatesForCompanyDocument, variables, headers),
    options,
  )
